import type { IconProps } from './img'

export function ThreeDCraftsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3780"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3780)">
        <path
          d="M22.5 43.9L7.5 35.25C7.02 34.97 6.66 34.6 6.39 34.14C6.13 33.68 6 33.18 6 32.65V15.65C6 15.12 6.13 14.62 6.39 14.16C6.65 13.7 7.02 13.33 7.5 13.05L22.5 4.4C22.98 4.13 23.48 4 24.01 4C24.54 4 25.04 4.13 25.5 4.4L40.5 13.05C40.98 13.33 41.34 13.7 41.61 14.16C41.87 14.62 42 15.12 42 15.65V32.65C42 33.18 41.87 33.68 41.61 34.14C41.35 34.6 40.98 34.97 40.5 35.25L25.5 43.9C25.02 44.17 24.52 44.3 23.99 44.3C23.46 44.3 22.96 44.17 22.5 43.9ZM22.5 25V40.45L24 41.3L25.5 40.45V24.99L39 17.15V15.65L37.3 14.7L24 22.45L10.65 14.7L9 15.63V17.2L22.5 25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ThreeDSvgsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4408"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4408)">
        <path
          d="M22.4 39.65L11.4 33.2C10.9408 32.9237 10.5844 32.5531 10.3307 32.0884C10.0769 31.6237 9.95 31.1275 9.95 30.6V17.75C9.95 17.2225 10.0769 16.7263 10.3307 16.2616C10.5844 15.7969 10.9408 15.4263 11.4 15.15L22.45 8.6C22.9167 8.33333 23.4333 8.2 24 8.2C24.5667 8.2 25.0833 8.33333 25.55 8.6L36.6 15.15C37.0592 15.4263 37.4156 15.7969 37.6694 16.2616C37.9231 16.7263 38.05 17.2225 38.05 17.75V30.6C38.05 31.1275 37.9188 31.6237 37.6562 32.0884C37.3937 32.5531 37.025 32.9237 36.55 33.2L25.4 39.65C24.9224 39.9167 24.4197 40.05 23.8918 40.05C23.3639 40.05 22.8667 39.9167 22.4 39.65ZM5.49125 14.95C5.06375 14.95 4.70833 14.8063 4.425 14.5188C4.14167 14.2312 4 13.875 4 13.45V7C4 6.175 4.29375 5.46875 4.88125 4.88125C5.46875 4.29375 6.175 4 7 4H13.45C13.875 4 14.2312 4.14458 14.5188 4.43375C14.8063 4.72295 14.95 5.08128 14.95 5.50875C14.95 5.93625 14.8063 6.29167 14.5188 6.575C14.2312 6.85833 13.875 7 13.45 7H7V13.45C7 13.875 6.85542 14.2312 6.56625 14.5188C6.27705 14.8063 5.91872 14.95 5.49125 14.95ZM7 44C6.175 44 5.46875 43.7063 4.88125 43.1188C4.29375 42.5312 4 41.825 4 41V34.55C4 34.125 4.14458 33.7688 4.43375 33.4813C4.72295 33.1938 5.08128 33.05 5.50875 33.05C5.93625 33.05 6.29167 33.1938 6.575 33.4813C6.85833 33.7688 7 34.125 7 34.55V41H13.45C13.875 41 14.2312 41.1446 14.5188 41.4338C14.8063 41.7229 14.95 42.0813 14.95 42.5088C14.95 42.9363 14.8063 43.2917 14.5188 43.575C14.2312 43.8583 13.875 44 13.45 44H7ZM41 44H34.55C34.125 44 33.7688 43.8554 33.4813 43.5662C33.1938 43.2771 33.05 42.9187 33.05 42.4913C33.05 42.0638 33.1938 41.7083 33.4813 41.425C33.7688 41.1417 34.125 41 34.55 41H41V34.55C41 34.125 41.1446 33.7688 41.4338 33.4813C41.7229 33.1938 42.0813 33.05 42.5088 33.05C42.9363 33.05 43.2917 33.1938 43.575 33.4813C43.8583 33.7688 44 34.125 44 34.55V41C44 41.825 43.7063 42.5312 43.1188 43.1188C42.5312 43.7063 41.825 44 41 44ZM41 13.45V7H34.55C34.125 7 33.7688 6.85542 33.4813 6.56625C33.1938 6.27705 33.05 5.91872 33.05 5.49125C33.05 5.06375 33.1938 4.70833 33.4813 4.425C33.7688 4.14167 34.125 4 34.55 4H41C41.825 4 42.5312 4.29375 43.1188 4.88125C43.7063 5.46875 44 6.175 44 7V13.45C44 13.875 43.8554 14.2312 43.5662 14.5188C43.2771 14.8063 42.9187 14.95 42.4913 14.95C42.0638 14.95 41.7083 14.8063 41.425 14.5188C41.1417 14.2312 41 13.875 41 13.45ZM14.5 16.8L13 17.7V19.55L22.5 25V36.2L24 37.1L25.5 36.2V25L35.05 19.55V17.7L33.5 16.8L24 22.3L14.5 16.8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function AccuquiltTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4344"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4344)">
        <path
          d="M45.23 22.07L25.93 2.77C25.42 2.26 24.77 2 24 2C23.23 2 22.58 2.26 22.07 2.77L2.77 22.07C2.26 22.58 2 23.23 2 24C2 24.77 2.26 25.42 2.77 25.93L22.07 45.23C22.58 45.74 23.23 46 24 46C24.77 46 25.42 45.74 25.93 45.23L45.23 25.93C45.74 25.42 46 24.77 46 24C46 23.23 45.74 22.58 45.23 22.07ZM38.48 25.32L25.31 38.49C24.96 38.84 24.52 39.02 23.99 39.02C23.46 39.02 23.02 38.84 22.67 38.49L9.5 25.32C9.15 24.97 8.97 24.53 8.97 24C8.97 23.47 9.15 23.03 9.5 22.68L22.67 9.51C23.02 9.16 23.46 8.98 23.99 8.98C24.52 8.98 24.96 9.16 25.31 9.51L38.48 22.68C38.83 23.03 39.01 23.47 39.01 24C39.01 24.53 38.83 24.97 38.48 25.32ZM23.05 31.24C22.68 30.94 22.5 30.56 22.5 30.09V27C22.5 26.63 22.61 26.32 22.84 26.05C23.06 25.78 23.35 25.62 23.7 25.54C24.17 25.44 24.59 25.54 24.96 25.84C25.33 26.14 25.51 26.52 25.51 26.99V30.08C25.51 30.45 25.4 30.76 25.17 31.03C24.95 31.3 24.66 31.46 24.31 31.54C23.84 31.64 23.42 31.54 23.05 31.24ZM23.05 22.15C22.68 21.85 22.5 21.47 22.5 21V17.91C22.5 17.54 22.61 17.23 22.84 16.96C23.06 16.69 23.35 16.53 23.7 16.45C24.17 16.35 24.59 16.45 24.96 16.75C25.33 17.05 25.51 17.43 25.51 17.9V20.99C25.51 21.36 25.4 21.67 25.17 21.94C24.95 22.21 24.66 22.37 24.31 22.45C23.84 22.55 23.42 22.45 23.05 22.15ZM31.24 24.94C30.94 25.31 30.56 25.49 30.09 25.49H27C26.63 25.49 26.32 25.38 26.05 25.15C25.78 24.93 25.62 24.64 25.54 24.29C25.44 23.82 25.54 23.4 25.84 23.03C26.14 22.66 26.52 22.48 26.99 22.48H30.08C30.45 22.48 30.76 22.59 31.03 22.82C31.3 23.04 31.46 23.33 31.54 23.68C31.64 24.15 31.54 24.57 31.24 24.94ZM22.15 24.94C21.85 25.31 21.47 25.49 21 25.49H17.91C17.54 25.49 17.23 25.38 16.96 25.15C16.69 24.93 16.53 24.64 16.45 24.29C16.35 23.82 16.45 23.4 16.75 23.03C17.05 22.66 17.43 22.48 17.9 22.48H20.99C21.36 22.48 21.67 22.59 21.94 22.82C22.21 23.04 22.37 23.33 22.45 23.68C22.55 24.15 22.45 24.57 22.15 24.94Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ApparelDesignTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3726"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3726)">
        <path
          d="M10.9101 19.24L7.60009 21.08C7.11009 21.36 6.59009 21.44 6.05009 21.32C5.51009 21.2 5.13009 20.91 4.92009 20.45L1.29009 14.2C1.01009 13.71 0.930094 13.29 1.05009 12.94C1.17009 12.59 1.46009 12.27 1.92009 11.99L13.9001 5H18.2601C18.6501 5 18.9501 5.11 19.1801 5.34C19.4101 5.57 19.5201 5.87 19.5201 6.26V7.05C19.5201 8.38 19.9401 9.47 20.7801 10.31C21.6201 11.15 22.7101 11.57 24.0401 11.57C25.3701 11.57 26.4501 11.15 27.2701 10.31C28.0901 9.47 28.5001 8.38 28.5001 7.05V6.26C28.5001 5.87 28.6101 5.57 28.8401 5.34C29.0701 5.11 29.3701 5 29.7601 5H34.1201L46.1001 11.99C46.5601 12.27 46.8401 12.59 46.9401 12.94C47.0501 13.29 46.9701 13.71 46.7301 14.2L43.0501 20.45C42.8401 20.91 42.4001 21.2 41.7401 21.34C41.0701 21.48 40.5501 21.43 40.1601 21.18L36.9001 19.13V40.78C36.9001 41.34 36.6901 41.82 36.2701 42.23C35.8501 42.63 35.3601 42.83 34.8001 42.83H12.9601C12.4001 42.83 11.9201 42.63 11.5101 42.23C11.1101 41.83 10.9101 41.35 10.9101 40.78V19.24Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function AppliqueTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3883"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3883)">
        <path
          d="M23.4701 4C22.5801 4 21.6601 4.48 21.2201 5.43L16.3701 15.82L5.06006 17.73C3.03006 18.07 2.28006 20.59 3.79006 22L12.1801 29.81L10.4901 41.14C10.2501 42.73 11.5201 44 12.9501 44C13.3501 44 13.7601 43.9 14.1401 43.68L24.1501 38.12L34.4001 43.23C34.7601 43.41 35.1401 43.49 35.4901 43.49C36.9601 43.49 38.2501 42.16 37.9301 40.53L35.7401 29.28L43.7701 21.11C45.2201 19.64 44.3501 17.16 42.3001 16.9L30.9301 15.49L25.6701 5.33C25.2101 4.44 24.3401 4 23.4601 4H23.4701Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArtsAndCraftsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3895"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3895)">
        <path
          d="M24 44C21.27 44 18.68 43.47 16.25 42.43C13.82 41.38 11.69 39.95 9.87 38.13C8.05 36.31 6.62 34.19 5.57 31.75C4.52 29.31 4 26.73 4 24C4 21.27 4.53 18.58 5.6 16.15C6.67 13.72 8.12 11.6 9.98 9.8C11.83 8 14 6.58 16.48 5.55C18.96 4.52 21.62 4 24.45 4C27.08 4 29.58 4.44 31.95 5.32C34.32 6.2 36.39 7.43 38.18 9C39.96 10.57 41.38 12.43 42.43 14.57C43.48 16.72 44 19.08 44 21.65C44 25.25 42.95 28.09 40.85 30.18C38.75 32.26 35.97 33.3 32.5 33.3H28.75C28.15 33.3 27.63 33.53 27.2 34C26.77 34.47 26.55 34.98 26.55 35.55C26.55 36.22 26.79 36.85 27.27 37.45C27.75 38.05 28 38.77 28 39.6C28 40.43 27.59 41.42 26.77 42.45C25.95 43.48 25.03 44 24 44ZM12.35 25.3C13.02 25.3 13.6 25.05 14.1 24.55C14.6 24.05 14.85 23.47 14.85 22.8C14.85 22.13 14.6 21.55 14.1 21.05C13.6 20.55 13.02 20.3 12.35 20.3C11.68 20.3 11.1 20.55 10.6 21.05C10.1 21.55 9.85 22.13 9.85 22.8C9.85 23.47 10.1 24.05 10.6 24.55C11.1 25.05 11.68 25.3 12.35 25.3ZM18.65 16.8C19.32 16.8 19.9 16.55 20.4 16.05C20.9 15.55 21.15 14.97 21.15 14.3C21.15 13.63 20.9 13.05 20.4 12.55C19.9 12.05 19.32 11.8 18.65 11.8C17.98 11.8 17.4 12.05 16.9 12.55C16.4 13.05 16.15 13.63 16.15 14.3C16.15 14.97 16.4 15.55 16.9 16.05C17.4 16.55 17.98 16.8 18.65 16.8ZM29.35 16.8C30.02 16.8 30.6 16.55 31.1 16.05C31.6 15.55 31.85 14.97 31.85 14.3C31.85 13.63 31.6 13.05 31.1 12.55C30.6 12.05 30.02 11.8 29.35 11.8C28.68 11.8 28.1 12.05 27.6 12.55C27.1 13.05 26.85 13.63 26.85 14.3C26.85 14.97 27.1 15.55 27.6 16.05C28.1 16.55 28.68 16.8 29.35 16.8ZM35.9 25.3C36.57 25.3 37.15 25.05 37.65 24.55C38.15 24.05 38.4 23.47 38.4 22.8C38.4 22.13 38.15 21.55 37.65 21.05C37.15 20.55 36.57 20.3 35.9 20.3C35.23 20.3 34.65 20.55 34.15 21.05C33.65 21.55 33.4 22.13 33.4 22.8C33.4 23.47 33.65 24.05 34.15 24.55C34.65 25.05 35.23 25.3 35.9 25.3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function BakingAndCakeDecorationsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="img"
    >
      <mask
        id="mask0_5063_3817"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3756)">
        <path
          d="M8 43.65C7.43 43.65 6.96 43.46 6.57 43.08C6.19 42.7 6 42.22 6 41.65V30.7C6 29.87 6.29 29.17 6.88 28.58C7.47 27.99 8.17 27.7 9 27.7H39C39.82 27.7 40.53 27.99 41.12 28.58C41.71 29.17 42 29.87 42 30.7V41.65C42 42.22 41.81 42.69 41.43 43.08C41.05 43.46 40.57 43.65 40 43.65H8ZM10.35 24.7V18.6C10.35 17.78 10.64 17.07 11.23 16.48C11.82 15.89 12.52 15.6 13.35 15.6H22.5V12.4C21.83 11.93 21.32 11.42 20.98 10.87C20.63 10.32 20.45 9.65 20.45 8.88C20.45 8.39 20.54 7.93 20.73 7.48C20.91 7.03 21.17 6.64 21.5 6.3L23.45 4.25C23.45 4.25 23.67 4.13 24.01 4C24.07 4 24.25 4.08 24.55 4.25L26.5 6.3C26.83 6.63 27.1 7.02 27.3 7.48C27.5 7.93 27.6 8.4 27.6 8.88C27.6 9.66 27.42 10.32 27.05 10.87C26.68 11.42 26.17 11.93 25.5 12.4V15.6H34.65C35.48 15.6 36.18 15.89 36.77 16.48C37.36 17.07 37.65 17.77 37.65 18.6V24.7H10.35Z"
          fill="#598F68"
        />
      </g>
    </svg>
  )
}

export function BasketryTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4266"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4266)">
        <path
          d="M44.16 18.28C44.16 18.28 44.1 18.23 44.07 18.2C43.99 17.94 43.86 17.69 43.68 17.48C43.52 17.29 43.32 17.14 43.11 17.01C41.92 8.3 34.44 2 24.75 2C15.06 2 7.58999 8.3 6.38999 17.01C6.17999 17.13 5.97999 17.28 5.81999 17.48C5.63999 17.69 5.51999 17.94 5.42999 18.2C5.39999 18.23 5.36999 18.25 5.33999 18.28C5.04999 18.62 4.93999 19.07 5.01999 19.51L7.95999 35.54C8.97999 41.1 13.82 45.14 19.48 45.14H30.03C35.68 45.14 40.53 41.1 41.55 35.54L44.49 19.51C44.57 19.07 44.45 18.62 44.17 18.28H44.16ZM40.08 26.93H35.46L37.94 29.41L40 27.35L38.8 33.91L37.94 33.05L33.17 37.89L35.5 40.22C34.82 40.77 34.06 41.21 33.25 41.53L31.33 39.6C30.3 40.62 29.46 41.45 28.77 42.14H25.28L29.54 37.88L24.77 33.11L20 37.88L24.26 42.14H20.63L18.15 39.66L16.29 41.52C15.46 41.19 14.69 40.74 14 40.18L16.3 37.87L11.53 33.03L10.72 33.84L9.53999 27.41L11.53 29.4L14.01 26.92H9.44999L8.96999 24.31C25.28 24.31 34.93 24.31 40.57 24.3L40.09 26.92L40.08 26.93ZM24.75 5C32.59 5 38.72 9.87 40.03 16.7H9.46999C10.79 9.87 16.91 5 24.75 5ZM31.82 26.93L36.09 31.2L31.32 36.04L26.48 31.2L30.81 26.93H31.83H31.82ZM27.17 26.93L24.69 29.41L22.21 26.93H27.18H27.17ZM18.64 26.93L22.97 31.26L18.13 36.1L13.29 31.26L17.56 26.99L18.64 26.93Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function BeadingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4428"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4428)">
        <path
          d="M45.0002 29.44C45.0002 32.27 42.7002 34.57 39.8702 34.57C39.7602 34.57 39.6702 34.55 39.5602 34.54C38.6902 36.21 37.5202 37.69 36.1302 38.93C36.2002 39.27 36.2402 39.62 36.2402 39.98C36.2402 42.81 33.9402 45.11 31.1102 45.11C29.3102 45.11 27.7402 44.18 26.8202 42.79C26.5202 42.81 26.2302 42.84 25.9302 42.84H22.0502C21.7702 42.84 21.5002 42.81 21.2302 42.8C20.3102 44.2 18.7402 45.12 16.9502 45.12C14.1202 45.12 11.8202 42.82 11.8202 39.99C11.8202 39.65 11.8602 39.31 11.9202 38.99C10.5002 37.74 9.31023 36.24 8.43023 34.55C8.33023 34.55 8.23023 34.58 8.12023 34.58C5.29023 34.58 2.99023 32.28 2.99023 29.45C2.99023 27.12 4.56023 25.17 6.69023 24.55V20.97C4.56023 20.35 2.99023 18.4 2.99023 16.07C2.99023 13.74 4.56023 11.79 6.69023 11.17V5.43C6.69023 4.64 7.33023 4 8.12023 4C8.91023 4 9.55023 4.64 9.55023 5.43V11.16C11.6802 11.78 13.2502 13.73 13.2502 16.06C13.2502 18.39 11.6802 20.34 9.55023 20.96V24.54C11.6802 25.16 13.2502 27.11 13.2502 29.44C13.2502 31.13 12.4202 32.62 11.1502 33.56C11.7302 34.6 12.4602 35.55 13.3002 36.38C14.2302 35.44 15.5202 34.86 16.9402 34.86C19.7702 34.86 22.0602 37.15 22.0702 39.97H25.9302C25.9302 39.97 25.9702 39.97 25.9802 39.97C25.9902 37.15 28.2802 34.86 31.1102 34.86C32.5202 34.86 33.7902 35.43 34.7202 36.35C35.5502 35.53 36.2602 34.59 36.8402 33.57C35.5702 32.64 34.7402 31.15 34.7402 29.45C34.7402 27.12 36.3102 25.17 38.4402 24.55V20.97C36.3102 20.35 34.7402 18.4 34.7402 16.07C34.7402 13.74 36.3102 11.79 38.4402 11.17V5.43C38.4402 4.64 39.0802 4 39.8702 4C40.6602 4 41.3002 4.64 41.3002 5.43V11.16C43.4302 11.78 45.0002 13.73 45.0002 16.06C45.0002 18.39 43.4302 20.34 41.3002 20.96V24.54C43.4302 25.16 45.0002 27.11 45.0002 29.44Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function BibleJournalingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4436"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4436)">
        <path
          d="M39.57 9.16C39.29 8.87 38.93 8.73 38.5 8.73C38.07 8.73 37.71 8.87 37.42 9.16C37.13 9.45 36.99 9.8 36.99 10.23V41.73H13.5C12.83 41.73 12.25 41.53 11.75 41.13C11.25 40.73 11 40.21 11 39.58C11 39.03 11.19 38.52 11.57 38.06C11.85 37.72 12.19 37.47 12.57 37.32H32.04C33.69 37.32 35.03 35.97 35.03 34.33V5.99C35.03 4.34 33.68 3 32.04 3H10.99C9.35 3 8 4.35 8 5.99V39.57C8 41.03 8.54 42.25 9.62 43.24C10.7 44.23 12 44.72 13.5 44.72H37C37.82 44.72 38.53 44.43 39.12 43.84C39.71 43.25 40 42.55 40 41.72V10.22C40 9.8 39.86 9.44 39.57 9.15V9.16ZM16.32 15.46H20.01V11.63C20.01 10.81 20.69 10.13 21.52 10.13C22.35 10.13 23.03 10.8 23.03 11.63V15.46H26.72C27.55 15.46 28.23 16.13 28.23 16.96C28.23 17.79 27.55 18.46 26.72 18.46H23.03V24.69C23.03 25.51 22.35 26.19 21.52 26.19C20.69 26.19 20.01 25.52 20.01 24.69V18.46H16.32C15.49 18.46 14.81 17.79 14.81 16.96C14.81 16.13 15.49 15.46 16.32 15.46Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function BobbinLaceMakingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4004"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4004)">
        <path
          d="M45.99 24.85C46.12 20.96 44.34 17.91 40.83 15.98C41.85 12.57 40.58 10.28 39.24 8.9C37.31 6.93 34.89 6.35 32.03 7.17C30.16 3.78 27.24 2 23.5 2H23.46C19.78 2.01 16.88 3.78 15 7.13C11.88 6.12 9.61998 7.27 8.20998 8.52C5.95998 10.52 5.24998 13.13 6.14998 16C3.01998 17.69 1.25998 20.35 1.02998 23.75C0.749981 27.81 2.50998 30.99 6.12998 33C5.30998 35.54 5.78998 37.88 7.56998 39.85C9.55998 42.05 12.15 42.75 15 41.86C16.74 45.03 19.46 46.8 22.94 46.98C23.15 46.99 23.35 47 23.56 47C27.22 47 30.11 45.24 32 41.88C35.06 42.86 37.72 41.65 39.2 40.14C41.08 38.22 41.64 35.73 40.82 33.03C44.09 31.24 45.87 28.44 45.99 24.86V24.85ZM31.68 14.2L33.87 12.01C34.13 11.75 34.43 11.61 34.78 11.58C35.13 11.55 35.45 11.63 35.74 11.83C36.14 12.1 36.37 12.46 36.42 12.93C36.47 13.4 36.33 13.8 35.99 14.13L33.8 16.32C33.54 16.58 33.24 16.72 32.89 16.75C32.54 16.78 32.22 16.7 31.93 16.5C31.53 16.23 31.3 15.87 31.25 15.4C31.2 14.93 31.34 14.53 31.68 14.2ZM21.67 8.87C22.17 8.37 22.75 8.12 23.42 8.12C24.09 8.12 24.67 8.37 25.17 8.87C25.67 9.37 25.92 9.95 25.92 10.62C25.92 11.29 25.67 11.87 25.17 12.37C24.67 12.87 24.09 13.12 23.42 13.12C22.75 13.12 22.17 12.87 21.67 12.37C21.17 11.87 20.92 11.29 20.92 10.62C20.92 9.95 21.17 9.37 21.67 8.87ZM11.18 12.91C11.45 12.51 11.81 12.28 12.28 12.23C12.75 12.18 13.15 12.32 13.48 12.66L15.67 14.85C15.93 15.11 16.07 15.41 16.1 15.76C16.13 16.11 16.05 16.43 15.85 16.72C15.58 17.12 15.22 17.35 14.75 17.4C14.28 17.45 13.88 17.31 13.55 16.97L11.36 14.78C11.1 14.52 10.96 14.22 10.93 13.87C10.9 13.52 10.98 13.2 11.18 12.91ZM7.75998 26.5C7.25998 26 7.00998 25.42 7.00998 24.75C7.00998 24.08 7.25998 23.5 7.75998 23C8.25998 22.5 8.83998 22.25 9.50998 22.25C10.18 22.25 10.76 22.5 11.26 23C11.76 23.5 12.01 24.08 12.01 24.75C12.01 25.42 11.76 26 11.26 26.5C10.76 27 10.18 27.25 9.50998 27.25C8.83998 27.25 8.25998 27 7.75998 26.5ZM15.32 34.8L13.13 36.99C12.87 37.25 12.57 37.39 12.22 37.42C11.87 37.45 11.55 37.37 11.26 37.17C10.86 36.9 10.63 36.54 10.58 36.07C10.53 35.6 10.67 35.2 11.01 34.87L13.2 32.68C13.46 32.42 13.76 32.28 14.11 32.25C14.46 32.22 14.78 32.3 15.07 32.5C15.47 32.77 15.7 33.13 15.75 33.6C15.8 34.07 15.66 34.47 15.32 34.8ZM25.17 40.13C24.67 40.63 24.09 40.88 23.42 40.88C22.75 40.88 22.17 40.63 21.67 40.13C21.17 39.63 20.92 39.05 20.92 38.38C20.92 37.71 21.17 37.13 21.67 36.63C22.17 36.13 22.75 35.88 23.42 35.88C24.09 35.88 24.67 36.13 25.17 36.63C25.67 37.13 25.92 37.71 25.92 38.38C25.92 39.05 25.67 39.63 25.17 40.13ZM23.5 32.39C19.14 32.39 15.61 28.86 15.61 24.5C15.61 20.14 19.14 16.61 23.5 16.61C27.86 16.61 31.39 20.14 31.39 24.5C31.39 28.86 27.86 32.39 23.5 32.39ZM35.8 36.67C35.53 37.07 35.17 37.3 34.7 37.35C34.23 37.4 33.83 37.26 33.5 36.92L31.31 34.73C31.05 34.47 30.91 34.17 30.88 33.82C30.85 33.47 30.93 33.15 31.13 32.86C31.4 32.46 31.76 32.23 32.23 32.18C32.7 32.13 33.1 32.27 33.43 32.61L35.62 34.8C35.88 35.06 36.02 35.36 36.05 35.71C36.08 36.06 36 36.38 35.8 36.67ZM39.23 26.53C38.73 27.03 38.15 27.28 37.48 27.28C36.81 27.28 36.23 27.03 35.73 26.53C35.23 26.03 34.98 25.45 34.98 24.78C34.98 24.11 35.23 23.53 35.73 23.03C36.23 22.53 36.81 22.28 37.48 22.28C38.15 22.28 38.73 22.53 39.23 23.03C39.73 23.53 39.98 24.11 39.98 24.78C39.98 25.45 39.73 26.03 39.23 26.53ZM22.55 29.74C22.18 29.44 22 29.06 22 28.59V27.5C22 27.13 22.11 26.82 22.34 26.55C22.56 26.28 22.85 26.12 23.2 26.04C23.67 25.94 24.09 26.04 24.46 26.34C24.83 26.64 25.01 27.02 25.01 27.49V28.58C25.01 28.95 24.9 29.26 24.67 29.53C24.45 29.8 24.16 29.96 23.81 30.04C23.34 30.14 22.92 30.04 22.55 29.74ZM22.55 22.65C22.18 22.35 22 21.97 22 21.5V20.41C22 20.04 22.11 19.73 22.34 19.46C22.56 19.19 22.85 19.03 23.2 18.95C23.67 18.85 24.09 18.95 24.46 19.25C24.83 19.55 25.01 19.93 25.01 20.4V21.49C25.01 21.86 24.9 22.17 24.67 22.44C24.45 22.71 24.16 22.87 23.81 22.95C23.34 23.05 22.92 22.95 22.55 22.65ZM28.74 25.44C28.44 25.81 28.06 25.99 27.59 25.99H26.5C26.13 25.99 25.82 25.88 25.55 25.65C25.28 25.43 25.12 25.14 25.04 24.79C24.94 24.32 25.04 23.9 25.34 23.53C25.64 23.16 26.02 22.98 26.49 22.98H27.58C27.95 22.98 28.26 23.09 28.53 23.32C28.8 23.54 28.96 23.83 29.04 24.18C29.14 24.65 29.04 25.07 28.74 25.44ZM21.65 25.44C21.35 25.81 20.97 25.99 20.5 25.99H19.41C19.04 25.99 18.73 25.88 18.46 25.65C18.19 25.43 18.03 25.14 17.95 24.79C17.85 24.32 17.95 23.9 18.25 23.53C18.55 23.16 18.93 22.98 19.4 22.98H20.49C20.86 22.98 21.17 23.09 21.44 23.32C21.71 23.54 21.87 23.83 21.95 24.18C22.05 24.65 21.95 25.07 21.65 25.44Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function BookbindingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3738"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3738)">
        <path
          d="M13.5 44C12 44 10.7083 43.506 9.625 42.5181C8.54167 41.5302 8 40.3075 8 38.85V10.65C8 9.43109 8.36863 8.34052 9.1059 7.37825C9.84313 6.41599 10.8078 5.80656 12 5.54996L27.4 2.34996C28.3333 2.14996 29.1667 2.35229 29.9 2.95696C30.6333 3.56159 31 4.34259 31 5.29996V30.15C31 30.8554 30.7833 31.4817 30.35 32.029C29.9167 32.5763 29.35 32.9333 28.65 33.1L13 36.45C12.4286 36.573 11.9524 36.8653 11.5714 37.3269C11.1905 37.7884 11 38.2961 11 38.85C11 39.4833 11.25 40 11.75 40.4C12.25 40.8 12.8333 41 13.5 41H37V9.49996C37 9.07496 37.1446 8.71871 37.4338 8.43121C37.7229 8.14371 38.0813 7.99996 38.5087 7.99996C38.9362 7.99996 39.2917 8.14371 39.575 8.43121C39.8583 8.71871 40 9.07496 40 9.49996V41C40 41.825 39.7062 42.5312 39.1187 43.1187C38.5312 43.7062 37.825 44 37 44H13.5ZM15.8079 32.8551C16.1556 32.7827 16.4412 32.6138 16.6647 32.3483C16.8882 32.0827 17 31.7666 17 31.4V9.39996C17 8.92862 16.8167 8.54412 16.45 8.24646C16.0833 7.94879 15.664 7.84824 15.1921 7.9448C14.8444 8.0172 14.5588 8.18616 14.3353 8.45166C14.1118 8.71719 14 9.03329 14 9.39996V31.4C14 31.8713 14.1833 32.2558 14.55 32.5535C14.9167 32.8511 15.336 32.9517 15.8079 32.8551Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function BrotherTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4194"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4194)">
        <path
          d="M45.47 9.43999C45.47 7.09999 43.56 5.18999 41.22 5.18999H37.75V4.54999C37.75 3.15999 36.62 2.02999 35.23 2.02999H32.4C31.01 2.02999 29.88 3.15999 29.88 4.54999V5.18999H13.88V3.48999C13.88 2.65999 13.21 1.98999 12.38 1.98999C11.55 1.98999 10.88 2.65999 10.88 3.48999V5.18999H6.24C3.91 5.19999 2 7.09999 2 9.43999V16.64C2 18.62 3.37 20.27 5.2 20.74V21.43C5.2 23.18 6.63 24.61 8.38 24.61H10.88V26.5C10.88 27.33 11.55 28 12.38 28C13.21 28 13.88 27.33 13.88 26.5V24.61H16.38C18.13 24.61 19.56 23.18 19.56 21.43V20.88H29.8V33.77H6.25C3.94 33.78 2.06 35.66 2.06 37.97V44.5C2.06 45.33 2.73 46 3.56 46H43.91C44.74 46 45.41 45.33 45.41 44.5V38.6C45.44 38.47 45.47 38.34 45.47 38.21V20.31C45.47 20.14 45.44 19.98 45.38 19.82C45.43 19.67 45.47 19.5 45.47 19.33V9.43999ZM16.56 21.44C16.56 21.54 16.48 21.62 16.38 21.62H8.38C8.28 21.62 8.2 21.54 8.2 21.44V20.89H16.56V21.44ZM37.63 21.11C40.23 21.11 42.35 23.23 42.35 25.83C42.35 28.43 40.23 30.55 37.63 30.55C35.03 30.55 32.91 28.43 32.91 25.83C32.91 23.23 35.03 21.11 37.63 21.11ZM42.41 43H5.06V37.97C5.06 37.31 5.59 36.78 6.25 36.78H42.41V43ZM35.84 25.83C35.84 24.84 36.64 24.04 37.63 24.04C38.62 24.04 39.42 24.84 39.42 25.83C39.42 26.82 38.62 27.62 37.63 27.62C36.64 27.62 35.84 26.82 35.84 25.83Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function BulletJournalingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4060"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4060)">
        <path
          d="M40.57 9.16C40.29 8.87 39.93 8.73 39.5 8.73C39.07 8.73 38.71 8.87 38.42 9.16C38.13 9.45 37.99 9.8 37.99 10.23V18.07H32.07C31.34 18.07 30.65 18.41 30.11 19.02C29.54 19.68 29.21 20.59 29.21 21.54C29.21 22.49 29.54 23.4 30.11 24.06C30.64 24.67 31.34 25.01 32.07 25.01H37.99V41.74H12.5C11.83 41.74 11.25 41.54 10.75 41.14C10.25 40.74 10 40.22 10 39.59C10 39.04 10.19 38.53 10.57 38.07C10.85 37.73 11.19 37.48 11.57 37.33H33.04C34.69 37.33 36.03 35.98 36.03 34.34V27.53H32.07C30.63 27.53 29.23 26.87 28.23 25.72C27.26 24.6 26.72 23.13 26.72 21.56C26.72 19.99 27.26 18.52 28.23 17.4C29.23 16.25 30.63 15.59 32.07 15.59H36.03V5.99C36.03 4.34 34.68 3 33.04 3H9.99C8.35 3 7 4.35 7 5.99V39.57C7 41.03 7.54 42.25 8.62 43.24C9.7 44.23 11 44.72 12.5 44.72H38C38.82 44.72 39.53 44.43 40.12 43.84C40.71 43.25 41 42.55 41 41.72V10.22C41 9.8 40.86 9.44 40.57 9.15V9.16ZM34.74 21.82C34.68 22.11 34.54 22.38 34.33 22.59C34.12 22.8 33.85 22.94 33.56 23C33.27 23.06 32.97 23.03 32.69 22.91C32.42 22.8 32.18 22.6 32.02 22.36C31.85 22.11 31.77 21.82 31.77 21.52C31.77 21.12 31.93 20.74 32.21 20.46C32.49 20.18 32.88 20.02 33.27 20.02C33.57 20.02 33.86 20.11 34.11 20.27C34.36 20.44 34.55 20.67 34.66 20.95C34.77 21.22 34.8 21.53 34.75 21.82H34.74ZM18.57 9.03C18.72 8.4 19.12 7.87 19.7 7.56C20.14 7.32 20.67 7.24 21.18 7.34C21.81 7.46 22.38 7.83 22.75 8.37L23.06 8.83L23.52 8.52C24.06 8.16 24.73 8.02 25.36 8.14C25.87 8.24 26.34 8.5 26.66 8.89C27.08 9.39 27.26 10.02 27.17 10.67C27.08 11.31 26.73 11.88 26.2 12.24L22.34 14.86C22.21 14.95 22.06 14.98 21.91 14.95C21.76 14.92 21.63 14.84 21.54 14.71L18.9 10.86C18.54 10.33 18.41 9.67 18.56 9.04L18.57 9.03ZM11.2 21.49L13.66 20.46L14.21 17.85C14.26 17.61 14.44 17.45 14.64 17.41C14.84 17.36 15.06 17.41 15.21 17.6L16.95 19.62L19.6 19.34C20.08 19.29 20.41 19.81 20.16 20.22L18.77 22.5L19.86 24.94C20.02 25.29 19.8 25.66 19.46 25.74C19.38 25.76 19.29 25.76 19.2 25.74L16.6 25.12L14.62 26.91C14.55 26.98 14.46 27.02 14.37 27.05C14.05 27.13 13.69 26.9 13.66 26.53L13.44 23.87L11.13 22.54C10.71 22.3 10.75 21.69 11.19 21.5L11.2 21.49Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function BundlesTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3901"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3901)">
        <path
          d="M5 43C4.18 43 3.47 42.71 2.88 42.12C2.29 41.53 2 40.83 2 40V13.5C2 13.07 2.15 12.72 2.43 12.43C2.72 12.14 3.08 12 3.5 12C3.92 12 4.28 12.14 4.57 12.43C4.85 12.72 5 13.07 5 13.5V40H40.5C40.93 40 41.28 40.14 41.57 40.43C41.86 40.72 42 41.08 42 41.51C42 41.94 41.86 42.29 41.57 42.58C41.28 42.86 40.93 43.01 40.5 43.01H5V43ZM11 37C10.18 37 9.47 36.71 8.88 36.12C8.29 35.53 8 34.83 8 34V8C8 7.18 8.29 6.47 8.88 5.88C9.47 5.29 10.17 5 11 5H21.75C22.16 5 22.56 5.08 22.94 5.25C23.32 5.42 23.64 5.63 23.9 5.9L27 9H43C43.82 9 44.53 9.29 45.12 9.88C45.71 10.47 46 11.17 46 12V34C46 34.82 45.71 35.53 45.12 36.12C44.53 36.71 43.83 37 43 37H11ZM25.2 26.5L22.1 22.85C21.93 22.68 21.74 22.61 21.52 22.63C21.3 22.65 21.11 22.74 20.95 22.91L17.7 26.76C17.5 27.03 17.47 27.3 17.61 27.58C17.75 27.86 17.98 28.01 18.3 28.01H35.8C36.11 28.01 36.32 27.88 36.45 27.61C36.58 27.34 36.56 27.08 36.39 26.81L31.29 20.01C31.12 19.81 30.92 19.71 30.69 19.71C30.46 19.71 30.26 19.81 30.09 20.01L25.19 26.51L25.2 26.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CalligraphyTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4121"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4121)">
        <path
          d="M11.22 31.5401C10.6 25.0201 12.04 19.3201 16.65 14.6601C19.04 12.2501 21.43 9.83009 23.85 7.46009C27.04 4.33009 30.85 3.22009 35.11 4.55009C39.34 5.87009 42.09 8.83009 43.11 13.2101C43.64 15.4801 43.47 17.7501 42.49 19.8801C42.25 20.3901 41.67 20.9101 41.13 21.0901C38.8 21.8801 36.42 22.5301 34.09 23.3001C33.69 23.4301 33.41 23.9501 33.07 24.2901C33.48 24.4801 33.88 24.7401 34.32 24.8301C34.8 24.9201 35.35 24.7601 35.81 24.8901C36.25 25.0101 36.81 25.3001 36.95 25.6601C37.08 26.0101 36.84 26.6201 36.57 26.9601C35.71 28.0801 34.6 28.8501 33.17 29.1601C31.86 29.4501 30.57 29.8701 29.3 30.3101C28.96 30.4201 28.72 30.8001 28.43 31.0601C28.67 31.3201 28.9 31.5801 29.14 31.8301C29.42 32.1201 29.91 32.4001 29.91 32.7001C29.91 33.0001 29.5 33.4001 29.17 33.6001C25.82 35.6701 22.12 36.5501 18.25 36.3201C15.65 36.1601 14.01 36.9701 12.07 38.9001C11.56 39.4101 6.94 44.0101 6.38 44.4801C5.56 45.1701 4.64 45.1501 3.99 44.4801C3.91 44.4001 6.03 40.0901 6.03 40.0901C6.03 40.0901 21.67 24.5601 25.78 20.4601C26.05 20.1901 26.47 19.9201 26.52 19.6001C26.6 19.1301 26.58 18.4301 26.3 18.1701C26.03 17.9101 25.33 17.9801 24.87 18.1001C24.54 18.1801 24.29 18.5801 24.01 18.8501C20.07 22.7701 16.13 26.6901 12.19 30.6001C11.9 30.8901 11.59 31.1601 11.2 31.5201L11.22 31.5401Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CandleMakingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4402"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4402)">
        <path
          d="M23.95 16C22.4167 16 21.125 15.4584 20.075 14.375C19.025 13.2917 18.5 11.9834 18.5 10.45C18.5 8.85005 18.9667 7.44172 19.9 6.22505C20.8333 5.00838 21.85 3.91672 22.95 2.95005C23.1167 2.81672 23.2917 2.71672 23.475 2.65005C23.6583 2.58338 23.8333 2.55005 24 2.55005C24.1667 2.55005 24.3333 2.58338 24.5 2.65005C24.6667 2.71672 24.8333 2.83338 25 3.00005C26.0333 4.03338 27.0417 5.13338 28.025 6.30005C29.0083 7.46672 29.5 8.85005 29.5 10.45C29.5 11.9834 28.9583 13.2917 27.875 14.375C26.7917 15.4584 25.4833 16 23.95 16ZM40.9 34C41.4667 34 41.9583 33.7917 42.375 33.375C42.7917 32.9584 43 32.4667 43 31.9C43 31.3334 42.7917 30.85 42.375 30.45C41.9583 30.05 41.4667 29.85 40.9 29.85C40.3333 29.85 39.8417 30.05 39.425 30.45C39.0083 30.85 38.8 31.3334 38.8 31.9C38.8 32.4667 39.0083 32.9584 39.425 33.375C39.8417 33.7917 40.3333 34 40.9 34ZM36 44H12C10.3333 44 8.91667 43.4167 7.75 42.25C6.58333 41.0834 6 39.6501 6 37.9501V35.5C6 35.0667 6.14167 34.7084 6.425 34.425C6.70833 34.1417 7.06667 34 7.5 34H17.95V21C17.95 20.1667 18.2417 19.4584 18.825 18.875C19.4083 18.2917 20.1167 18 20.95 18H27C27.8333 18 28.5417 18.2917 29.125 18.875C29.7083 19.4584 30 20.1667 30 21V34H36.25C36.0833 33.6667 35.9667 33.3251 35.9 32.975C35.8333 32.625 35.8 32.2667 35.8 31.9C35.8 30.5 36.3 29.3084 37.3 28.325C38.3 27.3417 39.5 26.85 40.9 26.85C42.3 26.85 43.5 27.3417 44.5 28.325C45.5 29.3084 46 30.5 46 31.9C46 33.1334 45.625 34.2084 44.875 35.125C44.125 36.0417 43.1667 36.6334 42 36.9001V38C42 39.6667 41.4167 41.0834 40.25 42.25C39.0833 43.4167 37.6667 44 36 44Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CardMakingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4127"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4127)">
        <path
          d="M43.4 0.09C42.69 -0.62 41.79 -1 40.82 -1H15.37L4.33004 9.54L4.03004 9.86C3.66004 10.24 3.60004 10.32 3.38004 10.76C3.03004 11.46 3.00004 12.74 3.00004 13.12V45.23C3.00004 45.79 2.99004 46.38 3.27004 46.94C3.46004 47.33 3.83004 48.06 4.85004 48.06C5.24004 48.06 5.95004 48.06 15.49 38.81H40.81C41.79 38.81 42.68 38.43 43.39 37.72C44.1 37.01 44.48 36.11 44.48 35.14V2.68C44.48 1.7 44.1 0.81 43.39 0.1L43.4 0.09ZM41.49 35.14C41.49 35.29 41.45 35.43 41.28 35.6C41.1 35.78 40.97 35.81 40.82 35.81H18.37V2H40.82C40.97 2 41.11 2.04 41.28 2.21C41.46 2.39 41.49 2.52 41.49 2.67V35.13V35.14ZM37.37 12.25C38.43 13.12 39.05 14.35 39.12 15.71C39.19 17.06 38.68 18.38 37.74 19.33L30.8 26.23C30.57 26.46 30.26 26.58 29.95 26.58C29.64 26.58 29.34 26.46 29.1 26.23L22.16 19.33C21.2 18.38 20.69 17.06 20.75 15.71C20.81 14.35 21.44 13.11 22.5 12.23C23.32 11.56 24.37 11.19 25.47 11.19C26.81 11.19 28.14 11.74 29.11 12.7L29.94 13.53L30.77 12.7C31.74 11.74 33.06 11.19 34.41 11.19C35.51 11.19 36.56 11.56 37.38 12.23L37.37 12.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CeramicsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3946"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3946)">
        <path
          d="M41.86 27.33C41.85 25.53 41.14 23.83 39.86 22.55L29.52 12.22C28.95 11.65 28.25 11.31 27.51 11.19C27.2 10.08 27.13 8.92002 27.32 7.79002L27.71 5.41002C27.77 5.06002 27.67 4.71002 27.44 4.44002C27.21 4.17002 26.88 4.02002 26.52 4.02002H15.2C14.85 4.02002 14.51 4.18002 14.28 4.44002C14.05 4.71002 13.95 5.06002 14.01 5.41002L14.4 7.79002C14.87 10.62 13.73 13.51 11.44 15.32C8.63 17.57 7 20.76 7 24.09C7 26.36 7.76 30.09 8.99 33.81C10.4 38.12 12.25 41.92 14.18 44.51C14.41 44.81 14.76 44.99 15.14 44.99H26.6C26.98 44.99 27.34 44.81 27.56 44.51C28.33 43.48 29.07 42.28 29.78 40.93C30.13 41.6 30.59 42.23 31.14 42.78C32.57 44.21 34.47 45 36.49 45H40.74C41.06 45 41.37 44.87 41.59 44.65C41.81 44.42 41.94 44.12 41.94 43.8L41.85 27.33H41.86ZM28.93 26.77V28.62C28.41 28.93 27.9 29.13 26.99 29.13C25.84 29.13 25.33 28.81 24.64 28.36C23.84 27.85 22.84 27.21 20.99 27.21C19.14 27.21 18.14 27.85 17.34 28.36C16.64 28.81 16.13 29.13 14.99 29.13C13.85 29.13 13.33 28.81 12.64 28.36C11.96 27.92 11.14 27.4 9.77 27.25C9.54 26.01 9.42 24.92 9.42 24.09C9.42 21.46 10.68 19.01 12.98 17.19C15.95 14.83 17.42 11.07 16.81 7.38002L16.65 6.40002H25.14L24.98 7.38002C24.75 8.78002 24.81 10.21 25.16 11.58C24.86 11.74 24.58 11.95 24.33 12.2C22.89 13.64 22.89 15.98 24.33 17.41L30.6 23.68C29.61 24.34 28.95 25.47 28.95 26.75L28.93 26.77ZM36.5 42.6C35.12 42.6 33.82 42.06 32.85 41.09C31.87 40.11 31.34 38.82 31.34 37.44V26.78C31.34 26.07 31.92 25.49 32.63 25.49C32.67 25.49 32.72 25.49 32.76 25.49C33.42 25.56 33.92 26.11 33.92 26.77V34.53C33.92 35.19 34.46 35.73 35.12 35.73C35.78 35.73 36.32 35.19 36.32 34.53V26.77C36.32 25.02 35.12 23.55 33.46 23.17L26.01 15.72C25.51 15.22 25.51 14.4 26.01 13.9C26.51 13.4 27.33 13.4 27.83 13.9L38.16 24.23C38.99 25.06 39.45 26.16 39.46 27.33L39.55 42.59H36.51L36.5 42.6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CfSparkTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4212"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4212)">
        <path
          d="M17.5598 31.12C17.1398 31.12 16.7698 30.82 16.6898 30.4C16.6298 30.11 16.0398 27.5 14.2498 24.67C11.7498 20.74 8.20977 18.31 3.72977 17.43C3.30977 17.35 3.00977 16.98 3.00977 16.56C3.00977 16.14 3.30977 15.77 3.72977 15.68C8.20977 14.81 11.7498 12.38 14.2498 8.45001C16.1098 5.53001 16.6698 2.83001 16.6998 2.72001C16.7498 2.46001 16.9198 2.23001 17.1598 2.10001C17.5098 1.92001 17.9298 1.98001 18.2098 2.26001C18.3598 2.41001 18.4398 2.57001 18.4598 2.76001C19.3298 7.21001 21.7598 10.74 25.6898 13.24C28.6498 15.12 31.3898 15.68 31.4198 15.68C31.8398 15.76 32.1398 16.13 32.1398 16.56C32.1398 16.99 31.8398 17.35 31.4198 17.43C31.3898 17.43 28.6498 17.99 25.6898 19.87C21.7598 22.37 19.3298 25.91 18.4498 30.39C18.3698 30.81 17.9998 31.11 17.5798 31.11L17.5598 31.12ZM29.4698 39.52L29.3598 39.49C29.2898 39.47 29.2198 39.45 29.1598 39.43L29.0198 39.39C28.4698 39.21 27.4098 38.77 26.4998 37.87C26.2398 37.58 26.0298 37.32 25.8598 37.05C25.3998 36.33 25.1598 35.64 25.0698 35.31L25.0398 35.2C25.0298 35.15 25.0098 35.1 24.9998 35.05L24.9398 34.74H24.8798C24.7198 34.5 24.4398 34.34 24.1298 34.34C23.8198 34.34 23.5498 34.5 23.3898 34.74L23.2498 34.7V35.09C23.2298 35.21 23.1898 35.32 23.1498 35.43L23.0898 35.61C22.9098 36.13 22.6698 36.62 22.3898 37.06C22.1698 37.4 21.9198 37.72 21.6198 38.02C21.3398 38.28 21.0598 38.49 20.7798 38.68C20.3798 38.94 19.9398 39.16 19.4798 39.33L19.3198 39.38C19.1398 39.44 18.9698 39.5 18.7798 39.54C18.3798 39.62 18.0898 39.96 18.0598 40.36V40.42C18.0598 40.42 18.0598 40.43 18.0598 40.44V40.48C18.0898 40.88 18.3798 41.22 18.7798 41.3L18.8898 41.33C18.9598 41.35 19.0298 41.37 19.0898 41.39L19.2298 41.43C19.7798 41.61 20.8398 42.05 21.7498 42.95C22.0098 43.24 22.2198 43.5 22.3898 43.77C22.8298 44.45 23.0698 45.1 23.1798 45.51L23.2098 45.63C23.2098 45.63 23.2398 45.72 23.2498 45.78L23.3098 46.07H23.3698C23.5298 46.32 23.8098 46.49 24.1298 46.49C24.4298 46.49 24.6998 46.34 24.8598 46.11L25.0098 46.17V45.75C25.0298 45.63 25.0698 45.52 25.1098 45.41L25.1598 45.24C25.3398 44.72 25.5798 44.23 25.8598 43.79C26.0798 43.45 26.3398 43.13 26.6298 42.83C26.9098 42.57 27.1898 42.35 27.4698 42.17C27.8698 41.91 28.3098 41.69 28.7698 41.52L28.9198 41.47C29.0998 41.41 29.2798 41.35 29.4698 41.31C29.8698 41.23 30.1598 40.89 30.1898 40.49V40.43C30.1898 40.43 30.1898 40.42 30.1898 40.41V40.37C30.1598 39.97 29.8698 39.63 29.4698 39.55V39.52ZM44.5698 27.35C44.4398 27.32 44.3198 27.29 44.1898 27.26L44.0798 27.23C43.4898 27.05 42.5898 26.71 41.6198 26.1C41.1698 25.81 40.7498 25.49 40.3498 25.13C39.8898 24.67 39.4798 24.16 39.1298 23.61C38.1498 22.08 37.8498 20.63 37.8498 20.62C37.7698 20.2 37.3998 19.9 36.9798 19.9C36.5598 19.9 36.1898 20.2 36.1098 20.62C36.0998 20.68 36.0798 20.74 36.0698 20.81L36.0398 20.94C35.8898 21.47 35.5398 22.52 34.8398 23.62C34.5498 24.07 34.2298 24.48 33.8698 24.87C33.4198 25.31 32.9198 25.71 32.3798 26.06C30.8298 27.05 29.4098 27.34 29.3898 27.34C28.9798 27.42 28.6898 27.77 28.6698 28.18V28.25C28.6898 28.67 28.9798 29.02 29.3898 29.1C29.5198 29.12 29.6398 29.16 29.7598 29.19L29.8798 29.22C30.4698 29.4 31.3698 29.74 32.3398 30.35C32.7898 30.64 33.2098 30.96 33.6098 31.32C34.0698 31.78 34.4798 32.29 34.8298 32.84C35.8098 34.37 36.1098 35.82 36.1098 35.83C36.1898 36.25 36.5598 36.55 36.9798 36.55C37.3998 36.55 37.7698 36.25 37.8498 35.83C37.8598 35.76 37.8798 35.7 37.8998 35.63L37.9298 35.51C38.0798 34.99 38.4198 33.94 39.1298 32.83C39.4198 32.38 39.7298 31.97 40.0898 31.58C40.5398 31.13 41.0398 30.74 41.5798 30.39C43.1198 29.4 44.5498 29.11 44.5698 29.11C44.9798 29.03 45.2698 28.68 45.2898 28.27V28.2C45.2698 27.78 44.9798 27.43 44.5698 27.35Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CfStudioTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4224"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4224)">
        <path
          d="M43.66 23.53L29.4 18.6L24.47 4.34C24.4 4.14 24.21 4 24 4C23.79 4 23.6 4.14 23.53 4.34L18.59 18.6L4.34 23.53C4.14 23.6 4 23.79 4 24C4 24.21 4.14 24.4 4.34 24.47L18.6 29.4L23.54 43.66C23.61 43.86 23.8 44 24.01 44C24.22 44 24.41 43.86 24.48 43.66L29.42 29.4L43.68 24.47C43.88 24.4 44.02 24.21 44.02 24C44.02 23.79 43.88 23.6 43.68 23.53H43.66Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ClassesTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4390"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4390)">
        <path
          d="M7 40C6.2 40 5.5 39.7 4.9 39.1C4.3 38.5 4 37.8 4 37V11C4 10.2 4.3 9.5 4.9 8.9C5.5 8.3 6.2 8 7 8H33C33.8 8 34.5 8.3 35.1 8.9C35.7 9.5 36 10.2 36 11V21.75L42.7 15.05C42.9333 14.8167 43.2083 14.7583 43.525 14.875C43.8417 14.9917 44 15.2167 44 15.55V32.45C44 32.7833 43.8417 33.0083 43.525 33.125C43.2083 33.2417 42.9333 33.1833 42.7 32.95L36 26.25V37C36 37.8 35.7 38.5 35.1 39.1C34.5 39.7 33.8 40 33 40H7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ClayTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4290"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4290)">
        <path
          d="M38.0102 28.72L29.7102 28.68V25.88C29.7202 25.39 30.1302 24.99 30.6202 24.99L37.1302 25.02C37.6202 25.02 38.0202 25.43 38.0202 25.92V28.72H38.0102ZM38.0002 30.51L38.9702 42.47C38.9602 45.27 36.6602 47.55 33.8602 47.54H33.7002C32.2902 47.54 31.0102 46.94 30.0902 46C27.4002 46.29 22.8302 46.71 18.9202 46.71C17.4202 46.71 16.0202 46.65 14.8602 46.49C14.0102 46.38 13.1702 46.29 12.3702 46.21C7.96018 45.75 3.40018 45.28 2.28018 40.22C1.40018 36.25 2.88018 33.83 3.89018 32.7C3.47018 30.82 3.00018 26.69 6.30018 24.6C10.6702 21.83 14.4402 23.23 16.6302 25C17.8702 23.67 19.9102 22.46 22.6702 23.02C26.4602 23.79 28.3302 27.93 28.9602 29.67C29.4302 29.87 29.9502 30.14 30.4802 30.47L38.0002 30.5V30.51ZM28.7002 43.12C28.6702 42.89 28.6302 42.66 28.6302 42.42L29.4402 33.4C28.4302 32.63 27.4002 32.29 27.3102 32.26C26.8302 32.11 26.4502 31.72 26.3102 31.23C25.9502 29.93 24.4802 26.45 22.0702 25.96C19.4802 25.44 18.3002 27.7 18.1702 27.96C17.9402 28.43 17.4802 28.75 16.9702 28.8C16.4502 28.86 15.9402 28.64 15.6302 28.22C15.4002 27.93 13.8202 26.03 11.3002 26.03C10.3102 26.03 9.17018 26.32 7.91018 27.12C6.30018 28.14 6.51018 30.48 6.77018 31.78C8.62018 32.01 11.7502 32.54 13.0602 33.63C14.8402 35.12 15.1502 38.17 15.2002 38.77C15.2602 39.6 14.6402 40.32 13.8102 40.38C13.7702 40.38 13.7302 40.38 13.7002 40.38C12.9202 40.38 12.2702 39.78 12.2102 38.99C12.1402 38.05 11.7502 36.43 11.1402 35.93C10.5902 35.47 8.18018 34.96 6.09018 34.72C5.55018 35.34 4.61018 36.85 5.21018 39.56C5.84018 42.38 8.08018 42.73 12.6902 43.21C13.5202 43.3 14.3902 43.39 15.2702 43.5C16.9302 43.72 19.1802 43.73 21.5002 43.63C21.6402 42.62 21.8802 40.71 21.8802 39.89C21.8702 39.47 21.0602 38.21 20.2202 37.3C19.6602 36.69 19.6902 35.75 20.2902 35.18C20.8902 34.62 21.8402 34.65 22.4102 35.25C22.9902 35.87 24.8702 38.02 24.8802 39.86C24.8802 40.77 24.6902 42.4 24.5502 43.45C26.0702 43.34 27.5102 43.21 28.7102 43.09L28.7002 43.12ZM45.9102 2.09C45.5102 1.47 44.8202 1.09 44.0802 1.09L23.8702 1C23.1302 1 22.4502 1.37 22.0402 1.99C21.6302 2.61 21.5702 3.39 21.8702 4.07L29.6602 21.83C30.0102 22.62 30.7902 23.13 31.6502 23.14L36.1302 23.16C36.9902 23.16 37.7702 22.66 38.1202 21.87L46.0602 4.18C46.3602 3.51 46.3002 2.72 45.9002 2.1L45.9102 2.09Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CookingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4358"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4358)">
        <path
          d="M10 40C8.3 40 6.875 39.425 5.725 38.275C4.575 37.125 4 35.7 4 34V25.55C4 25.1167 4.15 24.75 4.45 24.45C4.75 24.15 5.11667 24 5.55 24H33C33 22.9333 33.2667 21.9583 33.8 21.075C34.3333 20.1917 35.0833 19.5833 36.05 19.25L44.1 16.55C44.5 16.4167 44.8833 16.4417 45.25 16.625C45.6167 16.8083 45.8667 17.1 46 17.5C46.1333 17.9 46.1083 18.2833 45.925 18.65C45.7417 19.0167 45.45 19.2667 45.05 19.4L37 22.05C36.6333 22.1833 36.375 22.4417 36.225 22.825C36.075 23.2083 36 23.6 36 24V34C36 35.6667 35.425 37.0833 34.275 38.25C33.125 39.4167 31.7 40 30 40H10ZM7 13.4C6.3 12.3667 5.79167 11.3917 5.475 10.475C5.15833 9.55833 5.01667 8.56667 5.05 7.5C5.05 7.06667 5.19167 6.70833 5.475 6.425C5.75833 6.14167 6.11667 6 6.55 6C6.91667 6 7.23333 6.14167 7.5 6.425C7.76667 6.70833 7.9 7.05 7.9 7.45C7.93333 8.31667 8.1 9.125 8.4 9.875C8.7 10.625 9.21667 11.5167 9.95 12.55C10.65 13.5833 11.1667 14.5583 11.5 15.475C11.8333 16.3917 11.9667 17.4167 11.9 18.55C11.8667 18.95 11.7 19.2917 11.4 19.575C11.1 19.8583 10.7333 20 10.3 20C9.93333 20 9.625 19.8583 9.375 19.575C9.125 19.2917 9 18.95 9 18.55C9 17.6833 8.84167 16.8667 8.525 16.1C8.20833 15.3333 7.7 14.4333 7 13.4ZM15.5 13.4C14.8 12.3667 14.2833 11.3917 13.95 10.475C13.6167 9.55833 13.4667 8.56667 13.5 7.5C13.5 7.06667 13.65 6.70833 13.95 6.425C14.25 6.14167 14.6167 6 15.05 6C15.4167 6 15.7333 6.14167 16 6.425C16.2667 6.70833 16.4 7.05 16.4 7.45C16.4333 8.31667 16.6 9.125 16.9 9.875C17.2 10.625 17.7167 11.5167 18.45 12.55C19.15 13.5833 19.6583 14.5583 19.975 15.475C20.2917 16.3917 20.4167 17.4167 20.35 18.55C20.3167 18.95 20.1583 19.2917 19.875 19.575C19.5917 19.8583 19.2333 20 18.8 20C18.4333 20 18.125 19.8583 17.875 19.575C17.625 19.2917 17.5 18.95 17.5 18.55C17.5 17.6833 17.3417 16.8667 17.025 16.1C16.7083 15.3333 16.2 14.4333 15.5 13.4ZM24 13.4C23.3 12.3667 22.7833 11.3917 22.45 10.475C22.1167 9.55833 21.9667 8.56667 22 7.5C22 7.06667 22.15 6.70833 22.45 6.425C22.75 6.14167 23.1167 6 23.55 6C23.9167 6 24.2333 6.14167 24.5 6.425C24.7667 6.70833 24.9 7.05 24.9 7.45C24.9333 8.31667 25.1 9.125 25.4 9.875C25.7 10.625 26.2167 11.5167 26.95 12.55C27.65 13.5833 28.1583 14.5583 28.475 15.475C28.7917 16.3917 28.9167 17.4167 28.85 18.55C28.8167 18.95 28.6583 19.2917 28.375 19.575C28.0917 19.8583 27.7333 20 27.3 20C26.9333 20 26.625 19.8583 26.375 19.575C26.125 19.2917 26 18.95 26 18.55C26 17.6833 25.8417 16.8667 25.525 16.1C25.2083 15.3333 24.7 14.4333 24 13.4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CraftersCompanionTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4326"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4326)">
        <path
          d="M36.6898 8.69013H10.3498C9.64979 8.69013 9.02979 8.95013 8.50979 9.48013C7.98979 10.0101 7.71979 10.6201 7.71979 11.3201V37.6601C7.71979 38.3601 7.97979 38.9801 8.50979 39.5001C9.03979 40.0201 9.64979 40.2901 10.3498 40.2901H36.6898C37.3898 40.2901 38.0098 40.0301 38.5298 39.5001C39.0498 38.9701 39.3198 38.3601 39.3198 37.6601V11.3301C39.3198 10.6301 39.0598 10.0101 38.5298 9.49013C37.9998 8.97013 37.3898 8.70013 36.6898 8.70013V8.69013ZM16.2898 15.2401C16.5398 15.4901 16.6798 15.7801 16.7098 16.1201C16.7398 16.4501 16.6598 16.7601 16.4698 17.0501C16.2098 17.4401 15.8598 17.6601 15.4098 17.7001C14.9598 17.7501 14.5698 17.6101 14.2498 17.2901L12.1398 15.1801C11.8898 14.9301 11.7498 14.6401 11.7198 14.3001C11.6898 13.9701 11.7698 13.6601 11.9598 13.3701C12.2198 12.9801 12.5698 12.7601 13.0198 12.7201C13.4698 12.6701 13.8598 12.8101 14.1798 13.1301L16.2898 15.2401ZM22.9098 22.2901C22.9098 22.2901 22.9098 22.3001 22.9098 22.3101C22.9398 22.6401 22.8598 22.9501 22.6698 23.2401C22.4098 23.6301 22.0598 23.8501 21.6098 23.8901C21.1598 23.9401 20.7698 23.8001 20.4498 23.4801L18.3398 21.3701C18.0898 21.1201 17.9498 20.8301 17.9198 20.4901C17.9198 20.4901 17.9198 20.4801 17.9198 20.4701C17.8898 20.1401 17.9698 19.8301 18.1598 19.5401C18.4198 19.1501 18.7698 18.9301 19.2198 18.8901C19.6698 18.8401 20.0598 18.9801 20.3798 19.3001L22.4898 21.4101C22.7398 21.6601 22.8798 21.9501 22.9098 22.2901ZM35.3198 34.7001C35.3498 35.0301 35.2698 35.3401 35.0798 35.6301C34.8198 36.0201 34.4698 36.2401 34.0198 36.2801C33.5698 36.3301 33.1798 36.1901 32.8598 35.8701L30.7498 33.7601C30.4998 33.5101 30.3598 33.2201 30.3298 32.8801C30.2998 32.5501 30.3798 32.2401 30.5698 31.9501C30.8298 31.5601 31.1798 31.3401 31.6298 31.3001C32.0798 31.2501 32.4698 31.3901 32.7898 31.7101L34.8998 33.8201C35.1498 34.0701 35.2898 34.3601 35.3198 34.7001ZM28.6998 27.6201C28.9498 27.8701 29.0898 28.1601 29.1198 28.5001C29.1498 28.8301 29.0698 29.1401 28.8798 29.4301C28.6198 29.8201 28.2698 30.0401 27.8198 30.0801C27.3698 30.1301 26.9798 29.9901 26.6598 29.6701L24.5498 27.5601C24.2998 27.3101 24.1598 27.0201 24.1298 26.6801C24.0998 26.3501 24.1798 26.0401 24.3698 25.7501C24.6298 25.3601 24.9798 25.1401 25.4298 25.1001C25.8798 25.0501 26.2698 25.1901 26.5898 25.5101L28.6998 27.6201ZM7.57979 6.53013C7.82979 6.78013 7.96979 7.07013 7.99979 7.41013C8.02979 7.74013 7.94979 8.05013 7.75979 8.34013C7.49979 8.73013 7.14979 8.95013 6.69979 8.99013C6.24979 9.04013 5.85979 8.90013 5.53979 8.58013L3.41979 6.47013C3.16979 6.22013 3.02979 5.93013 2.99979 5.59013C2.96979 5.26013 3.04979 4.95013 3.23979 4.66013C3.49979 4.27013 3.85979 4.06013 4.30979 4.00013C4.75979 3.95013 5.14979 4.09013 5.46979 4.41013L7.57979 6.52013V6.53013ZM44.0298 43.3801C44.0298 43.3801 44.0298 43.3901 44.0298 43.4001C44.0598 43.7301 43.9798 44.0401 43.7898 44.3301C43.5298 44.7201 43.1798 44.9401 42.7298 44.9801C42.2798 45.0301 41.8898 44.8901 41.5698 44.5701L39.4598 42.4601C39.2098 42.2101 39.0698 41.9201 39.0398 41.5801C39.0398 41.5801 39.0398 41.5701 39.0398 41.5601C39.0098 41.2301 39.0898 40.9201 39.2798 40.6301C39.5398 40.2401 39.8898 40.0201 40.3398 39.9801C40.7898 39.9301 41.1798 40.0701 41.4998 40.3901L43.6098 42.5001C43.8598 42.7501 43.9998 43.0401 44.0298 43.3801Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CraftsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3774"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3774)">
        <path
          d="M25.05 27.25L19.2 33.1C19.57 33.67 19.79 34.22 19.88 34.75C19.97 35.28 20 35.87 20 36.5C20 38.63 19.28 40.42 17.85 41.85C16.42 43.28 14.63 44 12.5 44C10.37 44 8.58 43.28 7.15 41.85C5.72 40.42 5 38.63 5 36.5C5 34.37 5.72 32.58 7.15 31.15C8.58 29.72 10.37 29 12.5 29C13.1 29 13.69 29.08 14.27 29.25C14.85 29.42 15.46 29.67 16.1 30L21.9 24.2L16 18.3C15.43 18.57 14.86 18.75 14.27 18.85C13.69 18.95 13.1 19 12.5 19C10.37 19 8.58 18.28 7.15 16.85C5.72 15.42 5 13.63 5 11.5C5 9.37 5.72 7.58 7.15 6.15C8.58 4.72 10.37 4 12.5 4C14.63 4 16.42 4.72 17.85 6.15C19.28 7.58 20 9.37 20 11.5C20 12.13 19.96 12.73 19.88 13.3C19.8 13.87 19.62 14.4 19.36 14.9L42.76 38.3C43.53 39.07 43.7 39.92 43.28 40.87C42.86 41.82 42.12 42.3 41.06 42.3C40.76 42.3 40.47 42.24 40.18 42.12C39.9 42 39.64 41.83 39.4 41.59L25.05 27.24V27.25ZM30.95 21.65L27.65 18.35L39.4 6.6C39.63 6.37 39.89 6.19 40.18 6.07C40.46 5.95 40.75 5.9 41.06 5.9C42.13 5.9 42.85 6.38 43.24 7.35C43.62 8.32 43.45 9.17 42.71 9.9L30.96 21.65H30.95ZM12.5 16C13.77 16 14.83 15.57 15.7 14.7C16.57 13.83 17 12.77 17 11.5C17 10.23 16.57 9.17 15.7 8.3C14.83 7.43 13.77 7 12.5 7C11.23 7 10.17 7.43 9.3 8.3C8.43 9.17 8 10.23 8 11.5C8 12.77 8.43 13.83 9.3 14.7C10.17 15.57 11.23 16 12.5 16ZM25.15 25.15C25.42 25.15 25.64 25.06 25.83 24.87C26.02 24.68 26.11 24.46 26.11 24.19C26.11 23.92 26.02 23.7 25.83 23.52C25.64 23.34 25.42 23.24 25.15 23.24C24.88 23.24 24.66 23.33 24.48 23.52C24.3 23.71 24.2 23.93 24.2 24.19C24.2 24.45 24.29 24.68 24.48 24.87C24.67 25.06 24.89 25.15 25.15 25.15ZM12.5 41C13.77 41 14.83 40.57 15.7 39.7C16.57 38.83 17 37.77 17 36.5C17 35.23 16.57 34.17 15.7 33.3C14.83 32.43 13.77 32 12.5 32C11.23 32 10.17 32.43 9.3 33.3C8.43 34.17 8 35.23 8 36.5C8 37.77 8.43 38.83 9.3 39.7C10.17 40.57 11.23 41 12.5 41Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CreativeBusinessTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4371"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4371)">
        <path
          d="M8.94996 42C8.14996 42 7.44996 41.7 6.84996 41.1C6.24996 40.5 5.94996 39.8 5.94996 39V22.05C5.01663 21.25 4.39996 20.2667 4.09996 19.1C3.79996 17.9333 3.83329 16.7667 4.19996 15.6L6.34996 8.85C6.61663 7.95 7.08329 7.25 7.74996 6.75C8.41663 6.25 9.18329 6 10.05 6H37.7C38.6333 6 39.45 6.25833 40.15 6.775C40.85 7.29167 41.3333 7.98333 41.6 8.85L43.8 15.6C44.1666 16.7667 44.1916 17.9333 43.875 19.1C43.5583 20.2667 42.9333 21.25 42 22.05V39C42 39.8 41.7 40.5 41.1 41.1C40.5 41.7 39.8 42 39 42H8.94996ZM28.5 20.5C29.4666 20.5 30.2833 20.1833 30.95 19.55C31.6166 18.9167 31.8833 18.15 31.75 17.25L30.5 9H25.5V17.25C25.5 18.1167 25.7833 18.875 26.35 19.525C26.9166 20.175 27.6333 20.5 28.5 20.5ZM19.15 20.5C20.0833 20.5 20.875 20.1833 21.525 19.55C22.175 18.9167 22.5 18.15 22.5 17.25V9H17.5L16.25 17.25C16.1166 18.1167 16.35 18.875 16.95 19.525C17.55 20.175 18.2833 20.5 19.15 20.5ZM10.05 20.5C10.85 20.5 11.5416 20.225 12.125 19.675C12.7083 19.125 13.05 18.45 13.15 17.65L14.45 9H9.44996L7.14996 16.3C6.81663 17.3333 6.94996 18.2917 7.54996 19.175C8.14996 20.0583 8.98329 20.5 10.05 20.5ZM37.9 20.5C38.9666 20.5 39.8083 20.0667 40.425 19.2C41.0416 18.3333 41.1833 17.3667 40.85 16.3L38.55 9H33.55L34.85 17.65C34.95 18.45 35.2916 19.125 35.875 19.675C36.4583 20.225 37.1333 20.5 37.9 20.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CreativeInspirationTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3829"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3829)">
        <path
          d="M23.5 44C22.6 44 21.81 43.78 21.12 43.35C20.43 42.92 20 42.32 19.8 41.55H19.1C18.3 41.55 17.6 41.25 17 40.65C16.4 40.05 16.1 39.35 16.1 38.55V31.4C13.9 29.97 12.17 28.13 10.9 25.9C9.63 23.67 9 21.2 9 18.5C9 14.47 10.41 11.04 13.23 8.22C16.04 5.41 19.47 4 23.5 4C27.53 4 30.96 5.41 33.77 8.22C36.59 11.04 38 14.46 38 18.5C38 21.2 37.37 23.67 36.1 25.9C34.83 28.13 33.1 29.97 30.9 31.4V38.55C30.9 39.35 30.6 40.05 30 40.65C29.4 41.25 28.7 41.55 27.9 41.55H27.2C27 42.32 26.56 42.92 25.88 43.35C25.2 43.78 24.4 44 23.5 44ZM19.1 38.55H27.9V36.35H19.1V38.55ZM19.1 34.35H27.9V32.35H19.1V34.35ZM24.65 29.35V22.5L28.5 18.65C28.73 18.42 28.84 18.16 28.82 17.87C28.8 17.59 28.68 17.33 28.44 17.09C28.2 16.85 27.96 16.74 27.69 16.74C27.42 16.74 27.17 16.86 26.94 17.09L23.49 20.54L20.04 17.09C19.81 16.86 19.56 16.75 19.29 16.77C19.02 16.79 18.77 16.91 18.54 17.15C18.31 17.39 18.19 17.63 18.19 17.9C18.19 18.17 18.31 18.42 18.54 18.65L22.34 22.5V29.35H24.64H24.65Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CreativeWritingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3823"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3823)">
        <path
          d="M9.34 15.86C9.05 15.57 8.91 15.21 8.91 14.78C8.91 14.35 9.05 14 9.34 13.71C9.63 13.43 9.98 13.29 10.41 13.29H35.91C36.33 13.29 36.69 13.43 36.98 13.72C37.27 14.01 37.41 14.37 37.41 14.79C37.41 15.21 37.27 15.57 36.98 15.86C36.69 16.14 36.34 16.28 35.91 16.28H10.41C9.98 16.28 9.63 16.14 9.34 15.85V15.86ZM10.41 24.54H35.91C36.33 24.54 36.69 24.4 36.98 24.12C37.27 23.84 37.41 23.48 37.41 23.05C37.41 22.62 37.27 22.26 36.98 21.98C36.69 21.69 36.34 21.55 35.91 21.55H10.41C9.98 21.55 9.63 21.69 9.34 21.97C9.05 22.25 8.91 22.61 8.91 23.04C8.91 23.47 9.05 23.83 9.34 24.11C9.63 24.4 9.98 24.54 10.41 24.54ZM44.91 32.14C44.91 32.51 44.83 32.88 44.68 33.26C44.53 33.64 44.3 33.99 44 34.29L33.5 44.83C33.33 45 33.16 45.11 32.99 45.18C32.82 45.25 32.64 45.28 32.45 45.28H28.4C27.97 45.28 27.62 45.14 27.33 44.85C27.04 44.56 26.9 44.21 26.9 43.78V39.73C26.9 39.55 26.93 39.36 27 39.19C27.07 39.02 27.18 38.85 27.35 38.68L37.93 28.14C38.23 27.84 38.57 27.62 38.94 27.48C39.31 27.34 39.68 27.28 40.05 27.28C40.45 27.28 40.83 27.36 41.2 27.5C41.57 27.65 41.9 27.88 42.2 28.17L44.05 30.02C44.35 30.32 44.57 30.65 44.7 31.02C44.83 31.39 44.9 31.75 44.9 32.12L44.91 32.14ZM41.91 32.14L40.06 30.29L38.16 32.19L40.06 34.09L41.91 32.14ZM28.48 32.36C28.77 32.08 28.91 31.72 28.91 31.29C28.91 30.86 28.77 30.5 28.48 30.21C28.19 29.92 27.84 29.78 27.41 29.78H10.41C9.98 29.78 9.63 29.92 9.34 30.2C9.05 30.48 8.91 30.84 8.91 31.27C8.91 31.7 9.05 32.06 9.34 32.35C9.63 32.64 9.98 32.78 10.41 32.78H27.41C27.83 32.78 28.19 32.64 28.48 32.36ZM23.84 41.58C23.84 40.75 23.17 40.08 22.34 40.08H8.8C7.26 40.08 6 38.83 6 37.28V8.8C6 7.26 7.25 6 8.79 6L37.59 6.02C39.13 6.02 40.39 7.27 40.39 8.82V23.31C40.39 24.14 41.06 24.81 41.89 24.81C42.72 24.81 43.39 24.14 43.39 23.31V8.82C43.39 5.62 40.79 3.02 37.59 3.02L8.79 3C5.6 3 3 5.6 3 8.8V37.29C3 40.49 5.6 43.09 8.8 43.09H22.35C23.18 43.09 23.85 42.42 23.85 41.59L23.84 41.58Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CricutTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4332"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4332)">
        <path
          d="M42.39 12.58H5.34V8.73C5.34 7.7 5.71 6.83 6.44 6.1C7.17 5.37 8.05 5 9.07 5H38.66C39.69 5 40.56 5.37 41.29 6.1C42.02 6.83 42.39 7.71 42.39 8.73V12.58ZM48.73 21.04V31.36C48.73 32.39 48.36 33.26 47.63 33.99C46.9 34.72 46.02 35.09 45 35.09H43.63V39.81C43.63 40.84 43.26 41.71 42.53 42.44C41.8 43.17 40.92 43.54 39.9 43.54H7.83C6.8 43.54 5.93 43.17 5.2 42.44C4.47 41.71 4.1 40.83 4.1 39.81V35.09H2.73C1.7 35.09 0.83 34.72 0.1 33.99C-0.63 33.26 -1 32.38 -1 31.36V21.04C-1 19.17 -0.37 17.61 0.9 16.35C2.16 15.09 3.73 14.46 5.59 14.46H42.14C44.01 14.46 45.57 15.09 46.83 16.35C48.09 17.61 48.72 19.18 48.72 21.04H48.73ZM8.19 27.56H11.53V33.36C11.53 33.64 12.32 35.11 12.6 35.11H12.82C13.02 35.11 13.91 33.44 13.91 33.36V27.56H17.58C18.17 27.56 18.68 27.19 18.89 26.67V19.86H8.88C6.77 19.86 6.77 21.45 6.77 21.87V26.15C6.77 26.93 7.4 27.56 8.18 27.56H8.19ZM39.9 30.36H16.4V33.39C16.4 34.1 15.17 37.59 12.82 37.59H12.6C10.19 37.59 9.04 34.19 9.04 33.36V30.36H7.82V39.81H39.9V30.36ZM40.59 21.73C40.59 20.7 39.76 19.87 38.72 19.87H21.9V23.6H38.72C39.75 23.6 40.59 22.77 40.59 21.74V21.73Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CrochetTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3982"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3982)">
        <path
          d="M22 23.06C22 23.06 36.51 11.09 35.89 9.68C35.03 7.71 33.31 10.48 32.99 10.44C31.88 10.28 31.7 9.99 32.14 8.97C33.07 6.79 34.44 5.01 37.02 5C38.96 5 40.44 5.93 41.38 7.87C42.22 9.59 41.12 12.63 39.84 14.1C36.57 17.89 27.98 26.4 26.67 27.73C25.1 26.17 22 23.06 22 23.06ZM26.12 30.92C26.46 30.58 26.46 30.02 26.12 29.68L20.18 23.74C19.84 23.4 19.28 23.4 18.94 23.74L17 25.68L24.18 32.86L26.12 30.92ZM7.46 35.22C5.52 37.16 5.52 40.35 7.46 42.29L7.57 42.4C9.51 44.34 12.7 44.34 14.64 42.4L22.94 34.1L15.76 26.92L7.46 35.22Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function DecoupageTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3998"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3998)">
        <path
          d="M46 18.34V15.88C46 15.53 45.98 15.19 45.95 14.85C45.94 14.73 45.92 14.61 45.9 14.49C45.87 14.28 45.84 14.07 45.8 13.86C45.77 13.71 45.74 13.56 45.7 13.41C45.66 13.24 45.62 13.08 45.57 12.91C45.52 12.74 45.47 12.58 45.42 12.41C45.38 12.28 45.33 12.16 45.28 12.03C45.21 11.84 45.14 11.65 45.06 11.47C45.03 11.41 45 11.35 44.97 11.29C43.24 7.58 39.48 5 35.11 5H12.88C7.44 5 2.95 8.99 2.14 14.2C2.14 14.21 2.14 14.22 2.14 14.23C2.09 14.54 2.06 14.85 2.04 15.17C2.02 15.41 2 15.64 2 15.88V28.08V43.13H46V25.74V18.33V18.34ZM38.54 10.6C38.54 11.41 38.28 12.05 37.72 12.61C37.16 13.17 36.53 13.43 35.74 13.43C34.95 13.43 34.35 13.18 33.82 12.63C33.29 12.08 33.03 11.41 33.03 10.6C33.03 9.79 33.29 9.13 33.82 8.57C33.97 8.42 34.13 8.29 34.29 8.18H35.12C36.06 8.18 36.96 8.36 37.79 8.67C38.3 9.21 38.54 9.82 38.54 10.6ZM8.87 23.39C8.31 23.95 7.68 24.21 6.89 24.21C6.21 24.21 5.66 24 5.19 23.59V19.17C5.66 18.76 6.21 18.55 6.89 18.55C7.69 18.55 8.32 18.81 8.87 19.37C9.43 19.93 9.69 20.57 9.69 21.38C9.69 22.19 9.43 22.83 8.87 23.39ZM14.61 22.66C15.6 23.26 15.81 23.9 15.88 24.33C15.91 24.53 15.93 24.71 15.93 24.9H10.84C11.72 23.92 12.18 22.74 12.18 21.38C12.18 19.9 11.66 18.63 10.63 17.61C9.6 16.58 8.34 16.06 6.88 16.06C6.27 16.06 5.71 16.17 5.18 16.35V15.88C5.18 14.1 5.79 12.46 6.82 11.15C6.84 11.15 6.86 11.15 6.88 11.15C7.6 11.15 8.18 11.38 8.72 11.88C9.28 12.4 9.61 13.08 9.74 13.97L10.01 15.84L11.77 15.15C12.58 14.84 13.29 14.8 13.95 15.04C14.64 15.29 15.16 15.73 15.55 16.37C15.93 17 16.06 17.67 15.94 18.42C15.87 18.83 15.67 19.46 14.63 20.08L12.49 21.36L14.62 22.65L14.61 22.66ZM27.76 31.84H20.23V28.08H27.76V31.84ZM42.82 24.9H18.93C18.93 24.55 18.9 24.2 18.84 23.84C18.69 22.93 18.3 22.1 17.71 21.39C18.34 20.67 18.74 19.84 18.89 18.89C19.12 17.43 18.86 16.06 18.11 14.81C17.37 13.58 16.32 12.7 14.99 12.21C14.13 11.89 13.23 11.79 12.3 11.91C11.96 11.04 11.45 10.28 10.77 9.65C10.43 9.33 10.06 9.08 9.68 8.87C10.66 8.42 11.75 8.16 12.89 8.16H23.74C23.9 9.07 24.28 9.88 24.9 10.59C24.3 11.29 23.92 12.1 23.76 13.02C23.5 14.5 23.76 15.88 24.51 17.13C25.26 18.36 26.31 19.24 27.63 19.73C28.49 20.05 29.39 20.15 30.32 20.03C30.66 20.9 31.17 21.66 31.85 22.28C32.94 23.3 34.25 23.81 35.73 23.81C37.21 23.81 38.52 23.3 39.61 22.28C40.29 21.65 40.8 20.9 41.14 20.03C41.71 20.1 42.27 20.09 42.82 19.99V24.89V24.9ZM42.82 16.92C42.82 16.92 42.8 16.92 42.79 16.93C42.13 17.17 41.42 17.14 40.61 16.82L38.85 16.13L38.58 18C38.45 18.89 38.12 19.57 37.56 20.09C37.02 20.59 36.44 20.82 35.72 20.82C35 20.82 34.42 20.59 33.88 20.09C33.32 19.57 32.99 18.89 32.86 18L32.59 16.13L30.83 16.82C30.02 17.13 29.31 17.17 28.65 16.93C27.97 16.68 27.44 16.24 27.05 15.6C26.67 14.97 26.55 14.32 26.69 13.55C26.77 13.12 26.98 12.48 27.98 11.88L30.11 10.59L27.97 9.31C27.31 8.92 26.99 8.52 26.82 8.18H31.08C30.72 8.91 30.52 9.71 30.52 10.6C30.52 12.06 31.02 13.33 32 14.35C33 15.39 34.25 15.92 35.72 15.92C37.19 15.92 38.44 15.4 39.47 14.37C40.42 13.42 40.91 12.26 40.99 10.93C42.12 12.27 42.8 14 42.8 15.88V16.92H42.82Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function DieCuttingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4242"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4242)">
        <path
          d="M11.38 9.96C11.74 9.43 12.16 8.95 12.63 8.51C12.99 8.18 13.37 7.88 13.75 7.63C14.44 7.18 15.37 7.37 15.83 8.06C16.28 8.75 16.09 9.68 15.4 10.14C15.15 10.3 14.91 10.49 14.67 10.71C14.36 11 14.09 11.31 13.85 11.66C13.56 12.08 13.09 12.31 12.61 12.31C12.32 12.31 12.02 12.23 11.76 12.05C11.08 11.58 10.9 10.65 11.37 9.97L11.38 9.96ZM1.69 23.05C2.51 22.97 3.12 22.23 3.03 21.41C3.01 21.2 3 21 3 20.81C3 20.28 3.08 19.76 3.23 19.26C3.47 18.47 3.02 17.63 2.23 17.39C1.44 17.15 0.6 17.59 0.36 18.39C0.12 19.17 0 19.98 0 20.81C0 21.11 0.02 21.4 0.05 21.71C0.13 22.48 0.78 23.06 1.54 23.06C1.59 23.06 1.64 23.06 1.69 23.06V23.05ZM1.16 27.68C0.72 28.38 0.92 29.31 1.62 29.75C1.87 29.91 2.15 29.98 2.42 29.98C2.92 29.98 3.4 29.73 3.69 29.28C4.04 28.73 4.55 28.22 5.21 27.78C5.9 27.32 6.07 26.38 5.61 25.7C5.15 25.01 4.21 24.84 3.53 25.3C2.53 25.98 1.74 26.78 1.16 27.68ZM5.99 15.7C6.18 15.7 6.37 15.66 6.56 15.59L6.75 15.51C7.3 15.31 7.86 15.21 8.45 15.21H8.64C8.64 15.21 8.68 15.21 8.69 15.21C9.49 15.21 10.16 14.57 10.19 13.76C10.22 12.93 9.57 12.24 8.74 12.21C7.7 12.17 6.68 12.33 5.7 12.7L5.42 12.81C4.65 13.12 4.28 14 4.6 14.77C4.84 15.35 5.4 15.7 5.99 15.7ZM14.12 18C13.26 18.44 12.46 19.03 11.74 19.78C11.66 19.86 11.58 19.95 11.5 20.03C10.95 20.65 11 21.6 11.62 22.15C11.91 22.41 12.26 22.53 12.62 22.53C13.03 22.53 13.44 22.36 13.74 22.03L13.9 21.86C14.38 21.36 14.9 20.97 15.46 20.68C16.2 20.31 16.5 19.4 16.12 18.66C15.74 17.92 14.84 17.62 14.1 18H14.12ZM9.22 27.12C9.27 27.79 9.4 28.43 9.58 29.05C9.54 29.31 9.58 29.59 9.68 29.85C10.65 32.1 12.33 33.75 14.67 34.74C14.89 34.83 15.1 34.91 15.32 34.98C15.45 35.07 15.6 35.14 15.76 35.19C16.19 35.3 16.64 35.38 17.1 35.42C17.53 35.48 17.96 35.53 18.39 35.53C19.49 35.53 20.58 35.32 21.65 34.91C23.97 34.02 25.64 32.39 26.63 30.06C26.7 29.89 26.73 29.72 26.74 29.54C27.1 28.57 27.29 27.52 27.3 26.41C27.3 25.58 26.64 24.9 25.82 24.89H25.8C24.98 24.89 24.31 25.55 24.3 26.37C24.3 27.16 24.16 27.9 23.91 28.56C23.86 28.69 23.84 28.83 23.82 28.97C23.18 30.44 22.16 31.44 20.74 32.03C20.61 32.04 20.47 32.06 20.34 32.11C19.48 32.43 18.45 32.54 17.49 32.45C16.95 32.37 16.4 32.21 15.84 31.98C14.52 31.42 13.56 30.59 12.88 29.48C12.86 29.33 12.83 29.19 12.76 29.05C12.46 28.4 12.27 27.67 12.21 26.9C12.14 26.07 11.41 25.44 10.6 25.52C9.77 25.58 9.16 26.31 9.22 27.13V27.12ZM47.15 1V19.77H40.57V27.17C40.57 27.97 40.33 28.76 39.87 29.43L37.45 32.98C37.05 33.57 36.49 34.03 35.87 34.33C35.68 34.95 35.42 35.56 35.08 36.14C35.08 36.14 35.08 36.14 35.08 36.15C34.89 36.47 34.69 36.76 34.48 37.03C34.45 37.07 34.4 37.11 34.36 37.15C33.37 38.38 32.12 39.3 30.61 39.86C29.73 40.18 28.81 40.33 27.88 40.33C27.82 40.33 27.76 40.35 27.7 40.35C27.69 40.35 27.67 40.35 27.66 40.35C27.58 40.35 27.49 40.34 27.4 40.33C27.31 40.33 27.22 40.32 27.13 40.31C26.82 40.28 26.51 40.24 26.2 40.18C26.17 40.18 26.14 40.18 26.11 40.17C25.64 41.7 24.83 43 23.69 44.06C23.37 44.35 23.04 44.61 22.7 44.84C22.68 44.86 22.66 44.88 22.64 44.89C22.62 44.91 22.59 44.92 22.56 44.93C22.39 45.04 22.22 45.14 22.05 45.24C21.99 45.27 21.93 45.31 21.87 45.35C21.39 45.6 20.89 45.8 20.37 45.94C20.29 45.96 20.2 45.98 20.12 46C19.95 46.04 19.77 46.08 19.59 46.11C19.55 46.11 19.52 46.13 19.48 46.13C19.45 46.13 19.43 46.13 19.4 46.13C19 46.19 18.6 46.22 18.18 46.22C17.9 46.22 17.62 46.2 17.35 46.18C17.28 46.18 17.21 46.16 17.14 46.15C16.94 46.13 16.74 46.1 16.54 46.06C16.46 46.04 16.38 46.02 16.3 46C16.12 45.96 15.94 45.91 15.76 45.86C15.67 45.83 15.59 45.8 15.5 45.77C15.34 45.71 15.18 45.65 15.02 45.58C14.97 45.56 14.92 45.55 14.88 45.53C14.85 45.52 14.83 45.5 14.81 45.49C14.05 45.14 13.33 44.66 12.67 44.05C11.54 43 10.73 41.7 10.25 40.16C10.24 40.16 10.23 40.16 10.22 40.16C10.15 40.18 10.07 40.19 10 40.2C9.94 40.21 9.87 40.21 9.81 40.21C8.41 40.43 7.05 40.32 5.75 39.84C4.65 39.44 3.7 38.83 2.88 38.06C2.84 38.03 2.79 38.02 2.75 37.98C2.61 37.85 2.49 37.69 2.35 37.54C2.26 37.44 2.16 37.34 2.07 37.23C1.78 36.88 1.51 36.51 1.26 36.11C1.1 35.84 0.95 35.56 0.82 35.28C0.47 34.53 0.8 33.64 1.55 33.29C2.31 32.94 3.19 33.27 3.54 34.02C3.62 34.2 3.72 34.38 3.83 34.56C3.99 34.83 4.17 35.08 4.36 35.31C4.42 35.38 4.49 35.45 4.55 35.52C5.16 36.19 5.89 36.69 6.77 37.02C7.67 37.35 8.62 37.4 9.63 37.19C9.7 37.17 9.78 37.16 9.85 37.14C10.16 37.06 10.48 36.97 10.8 36.85L12.56 36.16L12.83 38.03C13.06 39.63 13.67 40.87 14.69 41.82C15.16 42.25 15.66 42.57 16.19 42.8C16.39 42.88 16.59 42.94 16.8 43C16.91 43.03 17.02 43.07 17.14 43.1C17.47 43.16 17.81 43.2 18.16 43.2C18.48 43.2 18.79 43.17 19.09 43.12C19.12 43.12 19.16 43.11 19.19 43.1C19.77 42.99 20.3 42.78 20.8 42.46C20.83 42.44 20.86 42.43 20.88 42.41C21.14 42.24 21.39 42.05 21.63 41.83C22.65 40.88 23.26 39.64 23.49 38.04L23.76 36.17L25.52 36.86C25.52 36.86 25.58 36.88 25.61 36.89C25.96 37.02 26.3 37.13 26.63 37.2C26.73 37.22 26.82 37.22 26.92 37.24C27.17 37.28 27.43 37.32 27.67 37.33C28.32 37.35 28.95 37.26 29.55 37.03C30.81 36.57 31.77 35.77 32.48 34.59C32.48 34.59 32.48 34.58 32.49 34.57C32.53 34.51 32.55 34.44 32.59 34.38C31.89 34.09 31.28 33.6 30.84 32.95L28.42 29.4C27.97 28.74 27.72 27.95 27.72 27.14V19.74H24.57C24.97 20.31 24.96 21.09 24.47 21.62C24.17 21.94 23.77 22.09 23.38 22.09C23.01 22.09 22.64 21.96 22.35 21.68C21.79 21.15 21.16 20.75 20.5 20.48C19.73 20.17 19.36 19.29 19.68 18.52C19.93 17.91 20.53 17.56 21.15 17.59V10.28C20.83 10.04 20.51 9.84 20.17 9.69C19.41 9.36 19.06 8.48 19.39 7.72C19.69 7.03 20.45 6.69 21.15 6.87V1H47.16H47.15ZM36.57 12.2H31.73V27.17L34.15 30.72L36.57 27.17V12.2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function DigitalDesignsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3792"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3792)">
        <path
          d="M34.12 26.02C34.73 27.24 34.68 28.49 34.05 29.68C32.69 32.26 31.33 34.83 29.92 37.38C29.76 37.66 29.31 37.94 29 37.95C25.82 37.99 22.65 38 19.47 37.95C19.1 37.95 18.59 37.61 18.41 37.28C17.05 34.85 15.76 32.37 14.44 29.92C13.67 28.49 13.7 27.09 14.43 25.65C16.77 21.01 19.08 16.36 21.4 11.71C21.76 10.99 22.17 10.32 23.27 10.29C23.25 12.23 23.22 14.13 23.22 16.03C23.22 18.13 23.25 20.22 23.21 22.32C23.21 22.67 22.96 23.14 22.67 23.35C21.6 24.14 21.09 25.38 21.44 26.6C21.8 27.84 22.92 28.71 24.18 28.72C25.49 28.73 26.63 27.87 26.99 26.57C27.33 25.37 26.8 24.12 25.71 23.36C25.47 23.19 25.2 22.84 25.2 22.57C25.19 18.57 25.21 14.56 25.24 10.56C25.24 10.47 25.29 10.38 25.41 10.02C25.94 10.52 26.52 10.85 26.77 11.34C29.26 16.22 31.71 21.12 34.15 26.03L34.12 26.02ZM18.92 44.53C19 46.45 20.3 47.84 22.21 47.95C23.54 48.02 24.88 48.03 26.21 47.95C28.05 47.84 29.34 46.52 29.44 44.7C29.52 43.18 29.51 41.66 29.54 40.31C25.86 40.31 22.43 40.31 18.81 40.3C18.85 41.62 18.88 43.08 18.94 44.54L18.92 44.53ZM43.66 6.76C45.53 6.76 47.04 5.25 47.04 3.38C47.04 1.51 45.53 0 43.66 0C42.31 0 41.15 0.8 40.61 1.95H27.42V1C27.42 0.53 27.04 0.15 26.57 0.15H21.48C21.01 0.15 20.63 0.53 20.63 1V1.95H7.43C6.89 0.8 5.73 0 4.38 0C2.51 0 1 1.51 1 3.38C1 5.25 2.51 6.76 4.38 6.76C5.73 6.76 6.89 5.96 7.43 4.81H14.29C9.33 7.87 5.91 13.17 5.46 19.3H4.27C3.8 19.3 3.42 19.68 3.42 20.15V25.24C3.42 25.71 3.8 26.09 4.27 26.09H9.36C9.83 26.09 10.21 25.71 10.21 25.24V20.15C10.21 19.68 9.83 19.3 9.36 19.3H8.31C8.91 12.39 13.98 6.75 20.61 5.28V6.09C20.61 6.56 20.99 6.94 21.46 6.94H26.55C27.02 6.94 27.4 6.56 27.4 6.09V5.28C34.03 6.74 39.1 12.38 39.7 19.3H38.65C38.18 19.3 37.8 19.68 37.8 20.15V25.24C37.8 25.71 38.18 26.09 38.65 26.09H43.74C44.21 26.09 44.59 25.71 44.59 25.24V20.15C44.59 19.68 44.21 19.3 43.74 19.3H42.56C42.11 13.17 38.69 7.87 33.73 4.81H40.59C41.13 5.96 42.29 6.76 43.64 6.76H43.66Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function DollMakingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4084"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4084)">
        <path
          d="M41.22 7.11999C41.22 4.68999 39.24 2.70999 36.81 2.70999C35.22 2.70999 33.84 3.55999 33.06 4.82999C30.82 2.46999 27.66 0.98999 24.16 0.98999C20.25 0.98999 16.77 2.82999 14.52 5.68999C13.9 3.99999 12.3 2.77999 10.39 2.77999C7.98 2.78999 6 4.75999 6 7.18999C6 9.61999 7.98 11.59 10.4 11.59C10.99 11.59 11.55 11.47 12.06 11.26C11.95 11.92 11.88 12.59 11.88 13.28C11.88 17.34 13.87 20.94 16.91 23.17L9.15 30.93C8.39 31.69 8.39 32.92 9.15 33.68C9.53 34.06 10.03 34.25 10.53 34.25C11.03 34.25 11.53 34.06 11.91 33.68L15.96 29.63L14.5 36.51C14.3 37.43 15.01 38.3 15.95 38.3H17.54V44.45C17.54 45.53 18.41 46.4 19.49 46.4C20.57 46.4 21.44 45.53 21.44 44.45V38.3H26.71V44.45C26.71 45.53 27.58 46.4 28.66 46.4C29.74 46.4 30.61 45.53 30.61 44.45V38.3H32.4C33.34 38.3 34.04 37.43 33.85 36.51L32.32 29.31L36.44 33.43C36.82 33.81 37.32 34 37.82 34C38.32 34 38.82 33.81 39.2 33.43C39.96 32.67 39.96 31.44 39.2 30.68L31.58 23.06C34.54 20.82 36.47 17.27 36.47 13.27C36.47 12.66 36.41 12.06 36.32 11.46C36.49 11.48 36.65 11.51 36.83 11.51C39.26 11.51 41.24 9.52999 41.24 7.10999L41.22 7.11999ZM33.46 12.13C33 12.21 32.53 12.26 32.05 12.26C29.64 12.26 27.42 11.21 25.9 9.39999C26.7 7.91999 27.17 6.22999 27.21 4.42999C30.54 5.56999 33.02 8.53999 33.47 12.13H33.46ZM24.17 3.91999C24.17 3.91999 24.24 3.91999 24.28 3.91999C24.28 3.99999 24.29 4.08999 24.29 4.16999C24.29 8.61999 20.67 12.25 16.21 12.25C15.66 12.25 15.27 12.21 14.88 12.11C15.46 7.49999 19.4 3.90999 24.16 3.90999L24.17 3.91999ZM24.17 22.65C19.63 22.65 15.84 19.4 14.99 15.11C15.36 15.16 15.75 15.18 16.22 15.18C19.33 15.18 22.13 13.88 24.14 11.8C26.19 13.94 29.01 15.18 32.05 15.18C32.49 15.18 32.93 15.14 33.36 15.09C32.51 19.39 28.72 22.64 24.18 22.64L24.17 22.65Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function DrawingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3805"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3805)">
        <path
          d="M8.50023 42C8.07023 42 7.71023 41.86 7.43023 41.57C7.15023 41.29 7.00023 40.93 7.00023 40.5V36.85C7.00023 36.45 7.08023 36.06 7.25023 35.68C7.42023 35.3 7.63023 34.97 7.90023 34.7L35.5502 7.05C35.9202 6.68 36.2902 6.42 36.6702 6.25C37.0502 6.08 37.4602 6 37.8902 6C38.2902 6 38.6802 6.08 39.0702 6.25C39.4602 6.42 39.8302 6.68 40.1902 7.05L41.9402 8.8C42.3102 9.13 42.5702 9.49 42.7402 9.87C42.9102 10.25 42.9902 10.66 42.9902 11.09C42.9902 11.49 42.9102 11.89 42.7402 12.29C42.5702 12.69 42.3102 13.07 41.9402 13.44L14.2902 41.09C14.0202 41.36 13.7002 41.57 13.3102 41.74C12.9202 41.91 12.5402 41.99 12.1302 41.99H8.48023L8.50023 42ZM36.6502 14.55L40.0502 11.15L37.8502 8.95L34.4502 12.35L36.6502 14.55ZM27.0002 42C29.6002 42 31.9202 41.39 33.9502 40.18C35.9802 38.96 37.0002 37.24 37.0002 35C37.0002 33.67 36.5102 32.44 35.5202 31.32C34.5402 30.2 33.0002 29.33 30.9002 28.7L28.5502 31.05C30.2202 31.45 31.5402 32.02 32.5202 32.75C33.5002 33.48 34.0002 34.23 34.0002 35C34.0002 36.07 33.3202 37 31.9802 37.8C30.6302 38.6 28.9702 39 27.0002 39C26.6002 39 26.2502 39.14 25.9502 39.43C25.6502 39.71 25.5002 40.07 25.5002 40.5C25.5002 40.9 25.6502 41.25 25.9502 41.55C26.2502 41.85 26.6002 42 27.0002 42ZM11.0002 27.3L13.4002 24.9C11.6002 24.47 10.2502 24.01 9.35023 23.52C8.45023 23.04 8.00023 22.53 8.00023 21.99C8.00023 21.45 8.36023 20.95 9.07023 20.46C9.79023 19.98 11.2602 19.32 13.5002 18.49C16.2702 17.46 18.1202 16.46 19.0702 15.52C20.0202 14.57 20.5002 13.41 20.5002 12.05C20.5002 10.18 19.8202 8.71 18.4502 7.62C17.0802 6.53 15.2702 6 13.0002 6C11.6002 6 10.3302 6.24 9.20023 6.72C8.07023 7.2 7.22023 7.81 6.65023 8.55C6.38023 8.85 6.26023 9.2 6.27023 9.6C6.29023 10 6.48023 10.33 6.85023 10.6C7.18023 10.87 7.56023 10.98 7.97023 10.93C8.39023 10.88 8.73023 10.72 8.99023 10.45C9.49023 9.95 10.0602 9.58 10.6902 9.35C11.3202 9.12 12.0902 9 12.9902 9C14.5202 9 15.6602 9.3 16.3902 9.9C17.1202 10.5 17.4902 11.22 17.4902 12.05C17.4902 12.72 17.1702 13.3 16.5402 13.8C15.9102 14.3 14.4902 14.95 12.2902 15.75C9.16023 16.88 7.16023 17.92 6.29023 18.85C5.42023 19.78 4.99023 20.83 4.99023 22C4.99023 23.07 5.46023 24.1 6.39023 25.1C7.32023 26.1 8.86023 26.83 10.9902 27.3H11.0002Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function EmbossingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4097"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4097)">
        <path
          d="M40.28 6.08C36.02 1.71 30.07 -1 23.5 -1C10.54 -1 0 9.54 0 22.5C0 29.76 3.31 36.26 8.5 40.57C12.77 44.93 18.71 47.65 25.28 47.65C38.24 47.65 48.78 37.11 48.78 24.15C48.78 16.89 45.47 10.39 40.28 6.08ZM25.29 44.65C13.99 44.65 4.79 35.45 4.79 24.15C4.79 12.85 13.98 3.65 25.29 3.65C36.6 3.65 45.79 12.85 45.79 24.15C45.79 35.45 36.59 44.65 25.29 44.65ZM40.03 25.4C40.93 24.48 41.49 23.39 41.69 22.15C41.97 20.38 41.65 18.73 40.74 17.22C39.84 15.73 38.57 14.67 36.96 14.08C35.82 13.66 34.63 13.56 33.39 13.78C32.99 12.63 32.36 11.63 31.5 10.81C31.48 10.79 31.46 10.77 31.44 10.75C31.44 10.75 31.44 10.74 31.43 10.73C30.33 9.68 29.42 7.9 25.47 7.93C23.95 7.93 21.81 8.5 20.68 9.55C19.55 10.6 18.46 11.86 18.22 13.57C16.62 12.95 15.12 12.89 13.73 13.41C12.33 13.93 11.24 14.83 10.46 16.13C9.67 17.43 9.4 18.85 9.65 20.38C9.89 21.91 10.83 23.17 12.46 24.14C10.89 25.09 9.97 26.34 9.69 27.88C9.42 29.43 10.22 31.75 11.11 32.98C13.13 35.79 15.14 36.45 16.88 36.82C16.91 36.82 16.94 36.83 16.97 36.84C17.99 37.14 19.04 37.22 20.13 37.02C20.54 38.21 21.2 39.23 22.1 40.06C23.42 41.28 24.99 41.9 26.78 41.9C28.57 41.9 30.14 41.28 31.46 40.06C32.36 39.23 33.02 38.21 33.43 37.02C34.67 37.24 35.86 37.13 37 36.71C38.61 36.12 39.88 35.06 40.79 33.56C41.67 32.08 41.97 30.42 41.67 28.63C41.47 27.4 40.93 26.32 40.07 25.42L40.03 25.4ZM36.84 26.67C37.92 27.32 38.5 28.09 38.67 29.1C38.85 30.18 38.68 31.14 38.17 32C37.62 32.91 36.88 33.52 35.92 33.88C34.98 34.23 33.97 34.18 32.84 33.74C32.41 33.57 31.93 33.61 31.54 33.84C31.14 34.07 30.88 34.47 30.81 34.92C30.63 36.16 30.17 37.11 29.38 37.84C28.62 38.54 27.76 38.88 26.74 38.88C25.72 38.88 24.86 38.54 24.1 37.84C23.31 37.11 22.85 36.16 22.67 34.92C22.6 34.47 22.34 34.07 21.94 33.84C21.71 33.7 21.45 33.64 21.18 33.64C21 33.64 20.81 33.67 20.64 33.74C19.51 34.18 18.5 34.23 17.56 33.88C16.59 33.52 15.85 32.91 15.31 32C14.77 31.11 14.6 30.16 14.79 29.1C14.96 28.11 15.57 27.32 16.64 26.68C17.09 26.41 17.37 25.92 17.36 25.39C17.36 24.86 17.08 24.38 16.63 24.11C15.52 23.44 14.9 22.65 14.75 21.69C14.58 20.63 14.76 19.68 15.3 18.78C15.85 17.87 16.59 17.26 17.55 16.9C18.49 16.55 19.5 16.6 20.63 17.04C21.06 17.21 21.54 17.17 21.93 16.94C22.33 16.71 22.59 16.31 22.66 15.86C22.84 14.62 23.3 13.67 24.09 12.94C24.85 12.24 25.71 11.9 26.73 11.9C27.75 11.9 28.61 12.24 29.37 12.94C30.16 13.67 30.62 14.62 30.8 15.86C30.87 16.31 31.13 16.71 31.53 16.94C31.93 17.17 32.41 17.21 32.83 17.04C33.96 16.6 34.97 16.55 35.91 16.9C36.88 17.26 37.62 17.87 38.16 18.78C38.7 19.68 38.88 20.63 38.71 21.69C38.56 22.65 37.94 23.44 36.83 24.11C36.38 24.38 36.1 24.87 36.1 25.39C36.1 25.92 36.37 26.4 36.82 26.68L36.84 26.67ZM31.15 20.94C30.34 20.13 29.42 19.6 28.38 19.33C27.62 19 26.79 18.83 25.89 18.83C24.16 18.83 22.72 19.44 21.56 20.65C20.4 21.86 19.82 23.34 19.82 25.09C19.82 26.84 20.4 28.32 21.56 29.53C22.34 30.34 23.25 30.88 24.28 31.15C25.02 31.48 25.84 31.64 26.74 31.64C28.46 31.64 29.93 31.03 31.15 29.82C32.36 28.61 32.97 27.13 32.97 25.38C32.97 23.63 32.36 22.15 31.15 20.94ZM29.03 27.71C28.38 28.36 27.68 28.65 26.75 28.65C25.82 28.65 25.18 28.37 24.58 27.76C23.95 27.1 23.67 26.37 23.67 25.39C23.67 24.41 23.95 23.68 24.58 23.02C25.17 22.4 25.84 22.13 26.75 22.13C27.66 22.13 28.38 22.42 29.03 23.07C29.68 23.72 29.97 24.44 29.97 25.39C29.97 26.34 29.68 27.06 29.03 27.71Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function EmbroideryTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4109"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4109)">
        <path
          d="M30.34 8.66V6.21H33.85C34.65 6.21 35.31 5.56 35.31 4.75C35.31 3.94 34.66 3.29 33.85 3.29H30.34V2.35C30.34 1.61 29.74 1 28.99 1C28.24 1 27.64 1.6 27.64 2.35V3.29H21.01V2.35C21.01 1.61 20.41 1 19.66 1C18.91 1 18.31 1.6 18.31 2.35V3.29H14.8C14 3.29 13.34 3.94 13.34 4.75C13.34 5.56 13.99 6.21 14.8 6.21H18.31V8.66C10.59 11.19 5 18.45 5 27.02C5 37.69 13.65 46.35 24.33 46.35C35.01 46.35 43.66 37.7 43.66 27.02C43.66 18.45 38.07 11.19 30.34 8.66ZM24.33 41.65C16.26 41.65 9.7 35.09 9.7 27.02C9.7 18.95 16.26 12.39 24.33 12.39C32.4 12.39 38.96 18.95 38.96 27.02C38.96 35.09 32.4 41.65 24.33 41.65ZM21.01 6.21H27.64V8C26.56 7.81 25.46 7.7 24.33 7.7C23.2 7.7 22.09 7.82 21.02 8V6.21H21.01ZM33.61 34.05C34.06 34.5 34.06 35.36 33.61 35.82C33.38 36.05 33.05 36.16 32.72 36.16C32.39 36.16 32.06 36.05 31.84 35.82L30.04 34.02L28.24 35.82C27.78 36.28 26.93 36.28 26.47 35.82C26.03 35.38 26.01 34.65 26.44 34.09L26.47 34.05L28.27 32.25L26.47 30.45C26.02 30 26.02 29.14 26.47 28.68C27.03 28.12 27.68 28.12 28.24 28.68L30.04 30.48L31.84 28.68C32.4 28.12 33.05 28.12 33.61 28.68C34.07 29.14 34.07 29.99 33.61 30.45L31.81 32.25L33.61 34.05ZM33.61 23.66C34.06 24.11 34.06 24.97 33.61 25.43C33.38 25.66 33.05 25.77 32.72 25.77C32.39 25.77 32.06 25.66 31.84 25.43L30.04 23.63L28.24 25.43C27.78 25.89 26.93 25.89 26.47 25.43C26.02 24.97 26.02 24.12 26.47 23.66L28.27 21.86L26.47 20.06C26.02 19.61 26.02 18.75 26.47 18.29C27.03 17.73 27.68 17.73 28.24 18.29L30.04 20.09L31.84 18.29C32.4 17.73 33.05 17.73 33.61 18.29C34.07 18.75 34.07 19.6 33.61 20.06L31.81 21.86L33.61 23.66ZM23.22 20.06L21.42 21.86L23.22 23.66C23.67 24.11 23.67 24.97 23.22 25.43C22.99 25.66 22.66 25.77 22.34 25.77C22.02 25.77 21.68 25.66 21.46 25.43L19.66 23.63L17.86 25.43C17.4 25.88 16.54 25.88 16.09 25.43C15.83 25.17 15.68 24.78 15.71 24.41C15.73 24.1 15.87 23.83 16.11 23.64L17.89 21.86L16.09 20.06C15.64 19.61 15.64 18.75 16.09 18.29C16.65 17.73 17.3 17.73 17.86 18.29L19.66 20.09L21.46 18.29C22.02 17.73 22.67 17.73 23.23 18.29C23.68 18.74 23.68 19.6 23.23 20.06H23.22Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function EpsonTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3919"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3919)">
        <path
          d="M15.1 42C14.27 42 13.57 41.71 12.98 41.12C12.39 40.53 12.1 39.83 12.1 39V33.2H7C6.18 33.2 5.47 32.91 4.88 32.32C4.29 31.73 4 31.03 4 30.2V20.9C4 19.4 4.51 18.14 5.52 17.12C6.54 16.1 7.8 15.6 9.3 15.6H38.7C40.2 15.6 41.46 16.11 42.48 17.12C43.5 18.14 44 19.39 44 20.9V30.2C44 31.03 43.71 31.73 43.12 32.32C42.53 32.91 41.83 33.2 41 33.2H35.9V39C35.9 39.82 35.61 40.53 35.02 41.12C34.43 41.71 33.73 42 32.9 42H15.1ZM35.9 14.1H12.1V9C12.1 8.18 12.39 7.47 12.98 6.88C13.57 6.29 14.27 6 15.1 6H32.9C33.73 6 34.43 6.29 35.02 6.88C35.61 7.47 35.9 8.17 35.9 9V14.1ZM36.95 23.85C37.48 23.85 37.95 23.65 38.35 23.25C38.75 22.85 38.95 22.38 38.95 21.85C38.95 21.32 38.75 20.85 38.35 20.45C37.95 20.05 37.48 19.85 36.95 19.85C36.42 19.85 35.95 20.05 35.55 20.45C35.15 20.85 34.95 21.32 34.95 21.85C34.95 22.38 35.15 22.85 35.55 23.25C35.95 23.65 36.42 23.85 36.95 23.85ZM15.1 39H32.9V29.4H15.1V39Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function EtchingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4011"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4011)">
        <path
          d="M41 41.0599C41 41.5699 40.8 42.0699 40.43 42.4299C40.07 42.7899 39.57 42.9999 39.06 42.9999H31.32C30.81 42.9999 30.31 42.7999 29.95 42.4299C29.59 42.0699 29.38 41.5699 29.38 41.0599C29.38 40.5499 29.58 40.0499 29.95 39.6899C30.31 39.3299 30.81 39.1199 31.32 39.1199H39.06C39.57 39.1199 40.07 39.3199 40.43 39.6899C40.79 40.0499 41 40.5399 41 41.0599ZM29.83 36.3299C30.04 36.4799 30.27 36.5899 30.52 36.6399C30.77 36.6999 31.03 36.6999 31.28 36.6599C31.53 36.6199 31.77 36.5199 31.99 36.3899L35.37 34.2999C35.73 34.0799 36 33.7499 36.15 33.3499C36.3 32.9599 36.32 32.5299 36.21 32.1199C36.1 31.7199 35.85 31.3599 35.51 31.1099C35.17 30.8599 34.76 30.7199 34.34 30.7199C33.98 30.7199 33.63 30.8199 33.33 31.0099L29.95 33.0999C29.73 33.2299 29.54 33.4099 29.39 33.6099C29.24 33.8199 29.13 34.0499 29.07 34.2999C29.01 34.5499 29 34.8099 29.04 35.0599C29.08 35.3099 29.17 35.5599 29.31 35.7699C29.45 35.9899 29.62 36.1799 29.83 36.3199V36.3299ZM18.61 33.6099C18.46 33.3999 18.27 33.2299 18.05 33.0999L14.67 31.0099C14.45 30.8699 14.21 30.7799 13.96 30.7399C13.71 30.6999 13.45 30.6999 13.2 30.7599C12.95 30.8199 12.72 30.9199 12.51 31.0699C12.3 31.2199 12.12 31.4099 11.99 31.6199C11.85 31.8399 11.76 32.0799 11.72 32.3299C11.68 32.5799 11.69 32.8399 11.75 33.0899C11.81 33.3399 11.92 33.5699 12.07 33.7799C12.22 33.9899 12.41 34.1599 12.63 34.2899L16.01 36.3799C16.23 36.5199 16.47 36.6099 16.72 36.6499C16.97 36.6899 17.23 36.6899 17.48 36.6299C17.73 36.5699 17.97 36.4699 18.17 36.3199C18.38 36.1699 18.56 35.9799 18.69 35.7699C18.83 35.5499 18.92 35.3099 18.96 35.0599C19 34.8099 18.99 34.5499 18.93 34.2999C18.87 34.0499 18.76 33.8199 18.61 33.6099ZM16.68 39.1299H8.94C8.43 39.1299 7.93 39.3299 7.57 39.6999C7.21 40.0599 7 40.5499 7 41.0699C7 41.5899 7.2 42.0799 7.57 42.4399C7.93 42.7999 8.42 43.0099 8.94 43.0099H16.68C17.19 43.0099 17.69 42.8099 18.05 42.4399C18.41 42.0799 18.62 41.5799 18.62 41.0699C18.62 40.5599 18.42 40.0599 18.05 39.6999C17.69 39.3399 17.19 39.1299 16.68 39.1299ZM31.57 21.7199L33.57 14.6699H35.62C36.82 14.6699 37.97 14.1899 38.81 13.3499C39.66 12.4999 40.13 11.3499 40.13 10.1599V6.93989C40.13 6.64989 40.07 6.36989 39.94 6.10989C39.82 5.84989 39.64 5.61989 39.41 5.43989C39.19 5.25989 38.93 5.12989 38.65 5.05989C38.37 4.98989 38.08 4.98989 37.8 5.03989C37.35 5.13989 36.96 5.38989 36.68 5.74989C36.4 6.10989 36.25 6.55989 36.26 7.00989V10.1599C36.26 10.3299 36.19 10.4999 36.07 10.6199C35.95 10.7399 35.78 10.8099 35.61 10.8099H12.39C12.22 10.8099 12.06 10.7399 11.93 10.6199C11.81 10.4999 11.74 10.3299 11.74 10.1599V7.00989C11.74 6.54989 11.6 6.10989 11.32 5.74989C11.04 5.38989 10.64 5.13989 10.19 5.03989C9.91 4.97989 9.62 4.98989 9.34 5.05989C9.06 5.12989 8.8 5.25989 8.58 5.43989C8.36 5.61989 8.18 5.84989 8.06 6.10989C7.94 6.36989 7.87 6.64989 7.87 6.93989V10.1699C7.87 11.3699 8.35 12.5199 9.19 13.3599C10.04 14.2099 11.18 14.6799 12.38 14.6799H14.43L16.44 21.7299C16.71 22.6699 17.28 23.4999 18.06 24.0899C18.84 24.6799 19.79 24.9999 20.77 24.9999H22.06V32.0199C22.06 32.4799 22.2 32.9199 22.48 33.2799C22.76 33.6399 23.16 33.8899 23.61 33.9899C23.89 34.0499 24.18 34.0399 24.46 33.9699C24.74 33.8999 25 33.7699 25.22 33.5899C25.44 33.4099 25.62 33.1799 25.74 32.9199C25.86 32.6599 25.93 32.3799 25.93 32.0899V24.9899H27.22C28.2 24.9899 29.16 24.6699 29.94 24.0799C30.72 23.4899 31.29 22.6599 31.56 21.7099L31.57 21.7199ZM24 39.1299C22.93 39.1299 22.06 39.9999 22.06 41.0699C22.06 42.1399 22.93 42.9999 24 42.9999C25.07 42.9999 25.94 42.1299 25.94 41.0699C25.94 40.0099 25.07 39.1299 24 39.1299Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function EtsyStoreTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4461"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4461)">
        <path
          d="M8.94996 42C8.14996 42 7.44996 41.7 6.84996 41.1C6.24996 40.5 5.94996 39.8 5.94996 39V22.05C5.01663 21.25 4.39996 20.2667 4.09996 19.1C3.79996 17.9333 3.83329 16.7667 4.19996 15.6L6.34996 8.85C6.61663 7.95 7.08329 7.25 7.74996 6.75C8.41663 6.25 9.18329 6 10.05 6H37.7C38.6333 6 39.45 6.25833 40.15 6.775C40.85 7.29167 41.3333 7.98333 41.6 8.85L43.8 15.6C44.1666 16.7667 44.1916 17.9333 43.875 19.1C43.5583 20.2667 42.9333 21.25 42 22.05V39C42 39.8 41.7 40.5 41.1 41.1C40.5 41.7 39.8 42 39 42H8.94996ZM28.5 20.5C29.4666 20.5 30.2833 20.1833 30.95 19.55C31.6166 18.9167 31.8833 18.15 31.75 17.25L30.5 9H25.5V17.25C25.5 18.1167 25.7833 18.875 26.35 19.525C26.9166 20.175 27.6333 20.5 28.5 20.5ZM19.15 20.5C20.0833 20.5 20.875 20.1833 21.525 19.55C22.175 18.9167 22.5 18.15 22.5 17.25V9H17.5L16.25 17.25C16.1166 18.1167 16.35 18.875 16.95 19.525C17.55 20.175 18.2833 20.5 19.15 20.5ZM10.05 20.5C10.85 20.5 11.5416 20.225 12.125 19.675C12.7083 19.125 13.05 18.45 13.15 17.65L14.45 9H9.44996L7.14996 16.3C6.81663 17.3333 6.94996 18.2917 7.54996 19.175C8.14996 20.0583 8.98329 20.5 10.05 20.5ZM37.9 20.5C38.9666 20.5 39.8083 20.0667 40.425 19.2C41.0416 18.3333 41.1833 17.3667 40.85 16.3L38.55 9H33.55L34.85 17.65C34.95 18.45 35.2916 19.125 35.875 19.675C36.4583 20.225 37.1333 20.5 37.9 20.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function FeltCraftsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4296"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4296)">
        <path
          d="M43.7199 8.67018C43.1299 8.08018 42.1799 8.08018 41.5999 8.67018L33.8799 16.3902C33.5999 16.0902 33.3099 15.7802 32.9999 15.4702C32.5799 15.0602 32.1699 14.6702 31.7599 14.3002L39.4999 6.56018C40.0899 5.97018 40.0899 5.02018 39.4999 4.44018C38.9099 3.85018 37.9599 3.85018 37.3799 4.44018L29.4699 12.3502C28.6599 11.7102 27.9899 11.2102 27.6099 10.9302C27.3699 11.3502 27.2099 11.5902 27.0799 11.8502C24.2499 17.4802 24.2699 18.1502 19.2699 21.9702C18.4799 22.5702 17.0199 23.5202 16.0499 23.2702C12.7099 22.4002 8.50994 24.4502 6.61994 27.1002C4.54994 30.0002 4.39994 33.2302 6.59994 36.2302C7.98994 38.1202 9.75994 39.7602 11.5299 41.3102C12.4099 42.0802 13.6499 42.6002 14.8099 42.8802C20.4899 44.2402 26.3599 38.0602 24.9199 32.1802C24.6699 31.1602 25.5999 29.6602 26.2299 28.8502C30.0199 23.9802 30.5599 24.0202 36.0799 21.2202C36.4299 21.0402 36.7699 20.8402 37.2399 20.5802C37.0299 20.2902 36.5499 19.5902 35.8399 18.6802L43.7299 10.7902C44.3199 10.2002 44.3199 9.25018 43.7299 8.67018H43.7199Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function FloralDesignTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3841"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3841)">
        <path
          d="M24.0601 44C22.1901 44 20.5701 43.36 19.1801 42.07C17.8001 40.79 16.9601 39.1 16.6601 37C14.6901 37.77 12.8501 37.83 11.1301 37.2C9.41006 36.57 8.07006 35.45 7.11006 33.85C6.15006 32.25 5.83006 30.5 6.16006 28.6C6.49006 26.7 7.63006 25.17 9.56006 24C7.56006 22.8 6.41006 21.26 6.11006 19.38C5.81006 17.5 6.14006 15.76 7.11006 14.16C8.08006 12.56 9.42006 11.44 11.1301 10.81C12.8501 10.18 14.6901 10.24 16.6601 11.01C16.9601 8.91001 17.8001 7.22001 19.1801 5.94001C20.5601 4.66001 22.1901 4.01001 24.0601 4.01001C25.9301 4.01001 27.5501 4.65001 28.9401 5.94001C30.3201 7.22001 31.1701 8.91001 31.4701 11.01C33.4401 10.24 35.2801 10.18 36.9901 10.81C38.7101 11.44 40.0501 12.56 41.0101 14.16C41.9801 15.76 42.3101 17.5 42.0101 19.38C41.7101 21.26 40.5601 22.81 38.5601 24C40.4901 25.17 41.6201 26.71 41.9401 28.62C42.2601 30.53 41.9401 32.28 41.0101 33.84C40.0401 35.44 38.7001 36.56 36.9901 37.19C35.2701 37.82 33.4301 37.76 31.4701 36.99C31.1701 39.09 30.3301 40.78 28.9401 42.06C27.5601 43.34 25.9301 43.99 24.0601 43.99V44ZM24.0601 32.35C26.3601 32.35 28.3201 31.54 29.9401 29.93C31.5601 28.31 32.3701 26.34 32.3701 24C32.3701 21.66 31.5601 19.69 29.9401 18.07C28.3201 16.45 26.3701 15.65 24.0601 15.65C21.7501 15.65 19.8401 16.46 18.2901 18.07C16.7401 19.69 15.9701 21.66 15.9701 24C15.9701 26.34 16.7401 28.31 18.2901 29.93C19.8401 31.55 21.7601 32.35 24.0601 32.35Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function FontsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3859"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3859)">
        <path
          d="M26.35 13.49C26.22 13.09 25.97 12.75 25.62 12.5C25.27 12.24 24.85 12.11 24.41 12.11H23.56C23.12 12.11 22.7 12.25 22.35 12.5C21.99 12.76 21.75 13.09 21.63 13.45L15.08 30.59C14.79 31.33 14.89 32.09 15.35 32.74C15.81 33.37 16.47 33.71 17.25 33.71C17.7 33.71 18.13 33.58 18.53 33.33C18.95 33.06 19.26 32.66 19.4 32.21L20.86 28.31H27.42L28.87 32.22C29.02 32.66 29.29 33.04 29.68 33.31C30.06 33.58 30.49 33.71 30.96 33.71C31.73 33.71 32.38 33.36 32.8 32.74C33.22 32.11 33.29 31.4 32.99 30.73L26.37 13.5L26.35 13.49ZM25.72 24H22.26L23.97 19.18L25.71 24H25.72ZM44.5 12.65C44.93 12.65 45.28 12.51 45.57 12.22C45.86 11.93 46 11.58 46 11.15V3.5C46 3.08 45.86 2.72 45.57 2.43C45.28 2.14 44.93 2 44.5 2H36.85C36.43 2 36.07 2.14 35.78 2.43C35.49 2.72 35.35 3.07 35.35 3.5V5.95H12.65V3.5C12.65 3.08 12.51 2.72 12.22 2.43C11.93 2.14 11.58 2 11.15 2H3.5C3.07 2 2.72 2.14 2.43 2.43C2.14 2.72 2 3.07 2 3.5V11.15C2 11.58 2.14 11.93 2.43 12.22C2.72 12.51 3.07 12.65 3.5 12.65H5.95V35.35H3.5C3.07 35.35 2.72 35.49 2.43 35.78C2.14 36.07 2 36.42 2 36.85V44.5C2 44.92 2.14 45.28 2.43 45.57C2.72 45.86 3.07 46 3.5 46H11.15C11.58 46 11.93 45.86 12.22 45.57C12.51 45.28 12.65 44.93 12.65 44.5V42.05H35.35V44.5C35.35 44.92 35.49 45.28 35.78 45.57C36.07 45.86 36.42 46 36.85 46H44.5C44.93 46 45.28 45.86 45.57 45.57C45.86 45.28 46 44.93 46 44.5V36.85C46 36.43 45.86 36.07 45.57 35.78C45.28 35.49 44.93 35.35 44.5 35.35H42.05V12.65H44.5ZM39.05 35.35H36.85C36.43 35.35 36.07 35.49 35.78 35.78C35.49 36.07 35.35 36.42 35.35 36.85V39.05H12.65V36.85C12.65 36.43 12.51 36.07 12.22 35.78C11.93 35.49 11.58 35.35 11.15 35.35H8.95V12.65H11.15C11.58 12.65 11.93 12.51 12.22 12.22C12.51 11.93 12.65 11.58 12.65 11.15V8.95H35.35V11.15C35.35 11.58 35.49 11.93 35.78 12.22C36.07 12.51 36.42 12.65 36.85 12.65H39.05V35.35Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function FoodCraftTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3939"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3939)">
        <path
          d="M33.23 27.12H27.95C27.95 26.33 27.94 15.49 27.95 8.95C27.96 4.72 31.69 2.02 35.95 2C37.89 2 39.83 2 41.86 2C41.92 2.39 42.04 28.7 42.02 41.53C42.02 43.67 40.9 45.14 38.94 45.78C37.16 46.36 35.16 45.75 34.15 44.09C33.67 43.31 33.42 42.28 33.39 41.36C33.3 38.27 33.28 27.74 33.23 27.12ZM23.49 4.75C23.49 2.99 22.71 2.02 21.36 2.01C20.05 2 19.18 3.01 19.15 4.73C19.11 7.34 19.11 12.92 19.11 12.92H16.97C16.97 12.92 16.93 4.57 16.9 4.31C16.78 2.83 16.03 2.02 14.8 2.01C13.49 2 12.62 3.01 12.59 4.73C12.59 4.9 12.53 12.92 12.53 12.92H10.35C10.35 12.92 10.38 7.41 10.34 4.73C10.32 3.01 9.45 2 8.14 2.01C6.79 2.02 6.01 2.99 6 4.75C6 9.63 6 14.5 6.01 19.37C6.01 19.69 6.03 19.98 6.07 20.27C6.17 22.21 7.48 23.33 9.32 23.86C9.66 23.97 10.01 24.07 10.41 24.19C10.41 28.28 10.41 39.85 10.42 41.6C10.42 42.94 10.91 44.03 11.76 44.81C12.54 45.62 13.64 46.02 14.75 46C15.86 46.02 16.96 45.62 17.74 44.81C18.59 44.03 19.07 42.94 19.08 41.6C19.08 39.85 19.09 28.27 19.09 24.19C19.49 24.07 19.83 23.97 20.18 23.86C22.02 23.33 23.33 22.21 23.43 20.27C23.47 19.99 23.49 19.69 23.49 19.37C23.51 14.5 23.5 9.63 23.49 4.76V4.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function GardenAndOutdoorTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3871"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3871)">
        <path
          d="M32.41 44.3C31.74 44.9 31.07 45.35 30.39 45.65C29.71 45.95 28.91 46.1 28.01 46.1C26.14 46.1 24.51 45.4 23.11 44C21.71 42.6 21.01 40.97 21.01 39.1C21.01 38.2 21.16 37.41 21.46 36.72C21.76 36.03 22.21 35.36 22.81 34.69C22.21 34.02 21.76 33.35 21.46 32.66C21.16 31.98 21.01 31.19 21.01 30.28C21.01 28.41 21.71 26.78 23.11 25.38C24.51 23.98 26.14 23.28 28.01 23.28C28.91 23.28 29.7 23.43 30.39 23.73C31.07 24.03 31.75 24.48 32.41 25.08C33.08 24.48 33.75 24.03 34.44 23.73C35.12 23.43 35.91 23.28 36.82 23.28C38.69 23.28 40.32 23.98 41.72 25.38C43.12 26.78 43.82 28.41 43.82 30.28C43.82 31.18 43.67 31.97 43.37 32.66C43.07 33.34 42.62 34.02 42.02 34.69C42.62 35.36 43.07 36.03 43.37 36.72C43.67 37.4 43.82 38.19 43.82 39.1C43.82 40.97 43.12 42.6 41.72 44C40.32 45.4 38.69 46.1 36.82 46.1C35.92 46.1 35.13 45.95 34.44 45.65C33.75 45.35 33.08 44.9 32.41 44.3ZM32.41 38.7C33.49 38.7 34.42 38.3 35.22 37.51C36.02 36.71 36.41 35.78 36.41 34.7C36.41 33.62 36.01 32.69 35.22 31.89C34.42 31.09 33.49 30.7 32.41 30.7C31.33 30.7 30.4 31.1 29.6 31.89C28.8 32.68 28.41 33.62 28.41 34.7C28.41 35.78 28.81 36.71 29.6 37.51C30.4 38.31 31.33 38.7 32.41 38.7ZM10.96 37.65C10.13 37.65 9.41999 37.36 8.83999 36.77C8.25999 36.18 7.95999 35.48 7.95999 34.65V17.65H5.15999C4.62999 17.65 4.26999 17.4 4.08999 16.9C3.90999 16.4 4.02999 15.98 4.46999 15.65L22.11 1.65C22.68 1.22 23.29 1 23.96 1C24.63 1 25.24 1.22 25.81 1.65L43.46 15.65C43.89 15.98 44.02 16.4 43.84 16.9C43.66 17.4 43.3 17.65 42.77 17.65H39.97V19.9H36.97V14.25L23.96 3.95L10.96 14.25V34.65H17.41V37.65H10.96Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function GlassBeadmakingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4443"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4443)">
        <path
          d="M44.79 20.4C44.79 17.57 42.49 15.27 39.66 15.27C39.5 15.27 39.34 15.3 39.19 15.32C37.58 13.39 35.53 11.84 33.21 10.8C32.99 8.17005 30.81 6.09005 28.13 6.09005C25.67 6.09005 23.61 7.83005 23.12 10.15C20.55 10.69 18.13 11.82 16.07 13.49L5.36 4.34005C4.94 3.98005 4.34 3.90005 3.83 4.13005C3.32 4.36005 3 4.87005 3 5.43005V13.31C3 13.85 3.3 14.34 3.78 14.59L26.49 26.12C26.49 26.12 26.56 26.14 26.59 26.16C27.76 27.24 28.05 28.64 27.53 30.67C27.18 32.04 25.03 33.51 23.55 34.26C21.51 34.36 19.79 35.63 19.05 37.42C17.36 36.32 15.94 34.86 14.87 33.15C16.37 32.26 17.39 30.63 17.39 28.76C17.39 25.93 15.09 23.63 12.26 23.63C9.43 23.63 7.13 25.93 7.13 28.76C7.13 31.59 9.26 33.69 11.95 33.86C13.52 36.73 15.93 39.08 18.83 40.61C19.39 42.84 21.39 44.49 23.79 44.49C25.47 44.49 26.94 43.67 27.88 42.43C31 42.17 33.87 41.04 36.27 39.28C36.56 39.33 36.85 39.37 37.15 39.37C39.98 39.37 42.28 37.07 42.28 34.24C42.28 33.5 42.12 32.8 41.84 32.17C42.62 30.25 43.07 28.15 43.07 25.94C43.07 25.39 43.04 24.85 42.99 24.31C44.1 23.37 44.82 21.98 44.82 20.41L44.79 20.4ZM5.86 12.44V8.54005L17.08 18.13L5.86 12.44ZM40.18 25.93C40.18 27.26 39.98 28.55 39.62 29.77C38.88 29.36 38.04 29.1 37.13 29.1C34.3 29.1 32 31.4 32 34.23C32 35.59 32.54 36.81 33.4 37.73C32.03 38.54 30.52 39.11 28.9 39.4C28.9 39.38 28.9 39.37 28.9 39.36C28.9 37.79 28.18 36.39 27.06 35.45C28.41 34.47 29.85 33.08 30.29 31.38C31.22 27.77 30.23 25.02 27.39 23.18L18.28 15.39C19.79 14.26 21.51 13.46 23.33 13.03C24.06 14.97 25.92 16.35 28.11 16.35C30.05 16.35 31.71 15.27 32.58 13.68C34 14.39 35.28 15.34 36.37 16.49C35.25 17.43 34.52 18.82 34.52 20.4C34.52 23.23 36.82 25.53 39.65 25.53C39.82 25.53 39.98 25.5 40.14 25.48C40.14 25.63 40.16 25.78 40.16 25.93H40.18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function GlassEtchingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4396"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4396)">
        <path
          d="M22.5 39V29.75C19.2 29.2833 16.625 27.955 14.775 25.7649C12.925 23.5748 12 20.9865 12 18V7.5C12 7.075 12.1438 6.71875 12.4313 6.43125C12.7188 6.14375 13.075 6 13.5 6H34.5C34.925 6 35.2812 6.14375 35.5688 6.43125C35.8563 6.71875 36 7.075 36 7.5V18C36 20.9865 35.075 23.5748 33.225 25.7649C31.375 27.955 28.8 29.2833 25.5 29.75V39H30.5C30.925 39 31.2812 39.1446 31.5688 39.4338C31.8563 39.7229 32 40.0813 32 40.5088C32 40.9363 31.8563 41.2917 31.5688 41.575C31.2812 41.8583 30.925 42 30.5 42H17.5C17.075 42 16.7188 41.8554 16.4313 41.5662C16.1438 41.2771 16 40.9187 16 40.4913C16 40.0638 16.1438 39.7083 16.4313 39.425C16.7188 39.1417 17.075 39 17.5 39H22.5ZM15 16.5H33V9H15V16.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function GlowforgeTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4078"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4078)">
        <path
          d="M45.2701 46.29C44.9801 46.65 44.5501 46.86 44.0901 46.86H3.50011C3.04011 46.86 2.61011 46.65 2.32011 46.29C2.04011 45.93 1.93011 45.46 2.04011 45.01L7.04011 24.05C7.20011 23.37 7.80011 22.9 8.50011 22.9H16.4101V23.14C16.4101 24.12 16.7001 25.08 17.2501 25.9C17.2601 25.92 17.2701 25.94 17.2801 25.96L19.0501 28.55C19.8501 29.73 21.1201 30.49 22.5101 30.68V34.05H13.0901C12.9001 34.06 12.7101 34.13 12.5601 34.25C12.4101 34.37 12.3001 34.53 12.2401 34.71L10.8801 38.81C10.8101 38.95 10.7801 39.1 10.7901 39.26C10.8001 39.42 10.8501 39.57 10.9401 39.69C11.0301 39.82 11.1501 39.92 11.2901 39.98C11.4101 40.03 11.5301 40.06 11.6401 40.06C11.6701 40.06 11.6901 40.06 11.7101 40.06H35.8701C36.1501 40.03 36.4001 39.91 36.5901 39.7C36.7001 39.58 36.7601 39.42 36.7801 39.26C36.8001 39.1 36.7701 38.94 36.7001 38.83L33.2501 29.18C33.2101 29.05 33.0701 28.98 32.9401 29.03L31.7001 29.44C31.6401 29.46 31.5801 29.51 31.5501 29.57C31.5201 29.63 31.5201 29.7 31.5401 29.76L34.5301 38.18H13.0401L13.7701 35.92H28.2801C28.4201 35.92 28.5301 35.81 28.5301 35.67V34.29C28.5301 34.15 28.4201 34.04 28.2801 34.04H24.3901V30.57C25.5701 30.28 26.6101 29.56 27.3101 28.54L29.0801 25.95C29.0801 25.95 29.1001 25.91 29.1101 25.89C29.6501 25.07 29.9501 24.11 29.9501 23.13V22.89H39.0901C39.7801 22.89 40.3901 23.37 40.5501 24.04L45.5501 45C45.6601 45.45 45.5501 45.92 45.2701 46.28V46.29ZM14.9601 16.26V3.72C14.9601 2.77 15.7301 2 16.6801 2H29.6601C30.6101 2 31.3801 2.77 31.3801 3.72L31.4001 16.27C31.4001 16.73 31.2201 17.17 30.9001 17.49C30.6401 17.75 30.3101 17.91 29.9501 17.97C29.8601 17.98 29.7701 18 29.6801 18H27.9501V23.16C27.9501 23.76 27.7701 24.35 27.4301 24.85L25.6601 27.44C25.3401 27.91 24.8901 28.25 24.3901 28.47C24.2301 28.54 24.0601 28.61 23.8901 28.66C23.6601 28.72 23.4201 28.75 23.1801 28.75C23.1201 28.75 23.0701 28.73 23.0101 28.73C22.8401 28.73 22.6701 28.71 22.5101 28.67C21.7801 28.5 21.1301 28.07 20.7001 27.44L18.9301 24.85C18.5901 24.35 18.4101 23.76 18.4101 23.16V18H16.6801C16.5901 18 16.5001 17.99 16.4101 17.97C15.5901 17.84 14.9501 17.14 14.9501 16.28L14.9601 16.26ZM21.4101 23.15L23.1801 25.74L24.9501 23.15V17.99H21.4201V23.15H21.4101Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function GraphicDesignsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3798"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3798)">
        <path
          d="M7.1 41.05C6.93 41.22 6.76 41.33 6.57 41.4C6.38 41.47 6.19 41.5 6 41.5C5.81 41.5 5.62 41.47 5.45 41.4C5.28 41.33 5.12 41.22 4.95 41.05C4.65 40.78 4.5 40.44 4.5 40.02C4.5 39.6 4.63 39.24 4.9 38.94C5.47 38.37 6.16 38.03 6.98 37.92C7.8 37.8 8.6 37.81 9.4 37.94C9.77 38.01 10.1 38.06 10.4 38.12C10.7 38.17 10.97 38.08 11.2 37.84C11.47 37.57 11.58 37.26 11.55 36.89C11.52 36.52 11.47 36.16 11.4 35.79C11.27 34.99 11.24 34.18 11.33 33.36C11.41 32.54 11.74 31.83 12.31 31.24C12.88 30.67 13.57 30.33 14.38 30.21C15.2 30.09 16 30.1 16.81 30.24C17.18 30.31 17.52 30.36 17.83 30.42C18.15 30.47 18.42 30.38 18.65 30.14C18.92 29.87 19.03 29.56 18.98 29.19C18.93 28.82 18.87 28.46 18.8 28.09C18.67 27.29 18.64 26.48 18.73 25.67C18.81 24.85 19.14 24.14 19.7 23.55C20.27 22.98 20.96 22.64 21.77 22.52C22.59 22.4 23.39 22.41 24.2 22.55C24.57 22.62 24.91 22.67 25.23 22.72C25.55 22.77 25.82 22.68 26.05 22.44C26.32 22.17 26.43 21.86 26.37 21.49C26.31 21.12 26.26 20.76 26.19 20.39C26.06 19.56 26.04 18.74 26.14 17.94C26.24 17.14 26.57 16.44 27.14 15.84C27.71 15.27 28.4 14.93 29.22 14.81C30.04 14.69 30.84 14.7 31.64 14.84C32.01 14.91 32.35 14.96 32.67 15.02C32.99 15.07 33.26 14.98 33.49 14.74C33.76 14.47 33.87 14.16 33.81 13.79C33.76 13.42 33.7 13.06 33.63 12.69C33.5 11.86 33.48 11.04 33.58 10.24C33.68 9.44 34.01 8.74 34.58 8.14C35.15 7.54 35.84 7.19 36.65 7.09C37.46 6.99 38.27 7.01 39.08 7.14C39.45 7.21 39.78 7.26 40.08 7.31C40.38 7.36 40.66 7.25 40.93 6.99C41.2 6.69 41.54 6.54 41.96 6.54C42.38 6.54 42.73 6.67 43.03 6.94C43.33 7.21 43.48 7.55 43.48 7.97C43.48 8.39 43.35 8.75 43.08 9.05C42.51 9.65 41.82 10.01 41 10.12C40.18 10.23 39.38 10.23 38.58 10.09C38.21 10.02 37.87 9.97 37.55 9.92C37.23 9.87 36.96 9.96 36.73 10.19C36.46 10.46 36.35 10.77 36.41 11.14C36.47 11.51 36.52 11.87 36.59 12.24C36.72 13.07 36.74 13.89 36.64 14.69C36.54 15.49 36.21 16.19 35.64 16.79C35.07 17.36 34.38 17.7 33.57 17.81C32.75 17.93 31.95 17.92 31.14 17.79C30.77 17.72 30.44 17.67 30.14 17.61C29.84 17.56 29.57 17.65 29.34 17.89C29.07 18.16 28.96 18.47 28.99 18.84C29.02 19.21 29.07 19.57 29.14 19.94C29.27 20.74 29.3 21.55 29.22 22.37C29.14 23.19 28.81 23.9 28.24 24.5C27.67 25.07 26.98 25.41 26.17 25.53C25.35 25.65 24.55 25.64 23.74 25.5C23.37 25.43 23.04 25.38 22.74 25.35C22.44 25.32 22.17 25.42 21.94 25.65C21.67 25.92 21.56 26.22 21.59 26.57C21.62 26.92 21.67 27.28 21.74 27.65C21.87 28.45 21.9 29.26 21.81 30.07C21.73 30.89 21.4 31.6 20.84 32.19C20.27 32.79 19.57 33.14 18.74 33.24C17.91 33.34 17.09 33.32 16.29 33.19C15.92 33.12 15.59 33.07 15.29 33.04C14.99 33.01 14.72 33.11 14.49 33.34C14.22 33.61 14.11 33.92 14.17 34.27C14.23 34.62 14.28 34.98 14.35 35.34C14.48 36.17 14.5 36.99 14.4 37.79C14.3 38.59 13.97 39.29 13.4 39.89C12.83 40.46 12.14 40.8 11.33 40.92C10.51 41.04 9.71 41.03 8.9 40.89C8.53 40.82 8.2 40.77 7.9 40.74C7.6 40.71 7.33 40.81 7.1 41.04V41.05ZM12 22C9.23 22 6.88 21.03 4.93 19.07C2.98 17.12 2 14.76 2 12C2 9.24 2.98 6.83 4.93 4.9C6.88 2.97 9.23 2 12 2C14.77 2 17.17 2.97 19.1 4.9C21.03 6.83 22 9.2 22 12C22 14.8 21.03 17.12 19.1 19.07C17.17 21.02 14.8 22 12 22ZM31 46C30.17 46 29.46 45.71 28.88 45.12C28.3 44.53 28 43.83 28 43V31C28 30.17 28.29 29.46 28.88 28.88C29.47 28.3 30.17 28 31 28H43C43.83 28 44.54 28.29 45.12 28.88C45.7 29.47 46 30.17 46 31V43C46 43.83 45.71 44.54 45.12 45.12C44.53 45.7 43.83 46 43 46H31Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function GraphicsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3877"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3877)">
        <path
          d="M9 42C8.2 42 7.5 41.7 6.9 41.1C6.3 40.5 6 39.8 6 39V9C6 8.2 6.3 7.5 6.9 6.9C7.5 6.3 8.2 6 9 6H39C39.8 6 40.5 6.3 41.1 6.9C41.7 7.5 42 8.2 42 9V39C42 39.8 41.7 40.5 41.1 41.1C40.5 41.7 39.8 42 39 42H9ZM10.92 35.18H37.13C37.5 35.18 37.76 35.02 37.92 34.69C38.08 34.36 38.06 34.04 37.86 33.71L30.71 24.18C30.51 23.94 30.26 23.81 29.98 23.81C29.7 23.81 29.45 23.93 29.25 24.18L21.92 33.65L16.97 26.87C16.77 26.63 16.52 26.5 16.24 26.5C15.96 26.5 15.71 26.62 15.51 26.87L10.26 33.71C10.02 34.04 9.98 34.36 10.14 34.69C10.3 35.02 10.57 35.18 10.93 35.18H10.92ZM17 20.5C17.98 20.5 18.81 20.16 19.48 19.49C20.16 18.81 20.5 17.98 20.5 17C20.5 16.02 20.16 15.19 19.48 14.51C18.8 13.83 17.98 13.5 17 13.5C16.02 13.5 15.19 13.84 14.52 14.51C13.84 15.19 13.5 16.02 13.5 17C13.5 17.98 13.84 18.81 14.52 19.49C15.2 20.17 16.02 20.5 17 20.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function HandEmbroideryTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4103"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4103)">
        <path
          d="M21.18 23.58C21.63 24.04 21.63 24.89 21.18 25.35C20.9 25.63 20.6 25.77 20.29 25.77C19.98 25.77 19.68 25.63 19.41 25.35L17.61 23.55L15.81 25.35C15.26 25.9 14.6 25.91 14.04 25.35C13.59 24.9 13.59 24.04 14.04 23.58L15.84 21.78L14.04 19.98C13.59 19.52 13.59 18.67 14.04 18.21C14.5 17.75 15.35 17.75 15.81 18.21L17.61 20.01L19.41 18.21C19.86 17.75 20.72 17.76 21.18 18.21C21.62 18.65 21.64 19.38 21.22 19.94L21.19 19.98L19.39 21.78L21.19 23.58H21.18ZM19.38 32.18L21.18 30.38C21.63 29.92 21.63 29.07 21.18 28.61C20.72 28.16 19.87 28.16 19.41 28.61L17.61 30.41L15.81 28.61C15.35 28.16 14.5 28.16 14.04 28.61C13.59 29.07 13.59 29.92 14.04 30.38L15.84 32.18L14.04 33.98C13.59 34.44 13.59 35.3 14.04 35.75C14.6 36.31 15.25 36.31 15.81 35.75L17.61 33.95L19.41 35.75C19.69 36.03 19.99 36.17 20.29 36.17C20.59 36.17 20.9 36.03 21.18 35.75C21.63 35.29 21.63 34.43 21.18 33.98L19.38 32.18ZM31.95 29.63C31.98 29.26 31.83 28.87 31.57 28.61C31.11 28.16 30.26 28.16 29.8 28.61L28 30.41L26.2 28.61C25.74 28.16 24.89 28.16 24.43 28.61C23.98 29.07 23.98 29.92 24.43 30.38L26.23 32.18L24.43 33.98C23.98 34.44 23.98 35.3 24.43 35.75C24.99 36.31 25.64 36.31 26.2 35.75L28 33.95L29.8 35.75C30.08 36.03 30.38 36.17 30.68 36.17C30.98 36.17 31.29 36.03 31.56 35.75C32.01 35.29 32.01 34.43 31.56 33.98L29.76 32.18L31.54 30.4C31.77 30.21 31.91 29.94 31.94 29.63H31.95ZM43.85 13.41C43.75 13.54 43.63 13.66 43.5 13.76L38.85 17.03C40.62 19.95 41.66 23.36 41.66 27.03C41.66 37.7 33.01 46.36 22.33 46.36C11.65 46.36 3 37.69 3 27.02C3 18.45 8.59 11.19 16.32 8.66V6.21H12.81C12.01 6.21 11.35 5.56 11.35 4.75C11.35 3.94 12 3.29 12.81 3.29H16.32V2.35C16.32 1.61 16.92 1 17.67 1C18.42 1 19.02 1.6 19.02 2.35V3.29H25.65V2.35C25.65 1.61 26.25 1 27 1C27.75 1 28.35 1.6 28.35 2.35V3.29H31.86C32.66 3.29 33.32 3.94 33.32 4.75C33.32 5.56 32.67 6.21 31.86 6.21H28.35V8.66C30.53 9.37 32.53 10.46 34.29 11.85L38.24 7.34C38.37 7.19 38.54 7.06 38.72 6.98C40.09 6.33 42.81 5.75 44.32 7.74C45.79 9.66 44.71 12.2 43.85 13.4V13.41ZM36.96 27.02C36.96 24.37 36.24 21.88 35 19.74L25.34 26.54C25.08 26.72 24.78 26.81 24.48 26.81C24.07 26.81 23.66 26.64 23.36 26.31C22.85 25.75 22.85 24.89 23.35 24.32L31.18 15.4C28.72 13.52 25.66 12.4 22.34 12.4C14.27 12.4 7.71 18.96 7.71 27.03C7.71 35.1 14.27 41.66 22.34 41.66C30.41 41.66 36.97 35.1 36.97 27.03L36.96 27.02ZM19.01 7.99C20.09 7.8 21.19 7.69 22.32 7.69C23.45 7.69 24.56 7.81 25.63 7.99V6.2H19V7.99H19.01Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function HomeDecorTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3847"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3847)">
        <path
          d="M39.94 22.12L35.08 6.37C34.85 5.66 34.43 5.09 33.83 4.66C33.23 4.22 32.55 4 31.81 4H16.23C15.48 4 14.81 4.22 14.21 4.66C13.61 5.1 13.19 5.67 12.96 6.37L8.10003 22.12C7.91003 22.65 7.99003 23.15 8.34003 23.62C8.69003 24.09 9.15003 24.33 9.74003 24.33H22.33V39.82H16.74C16.06 39.82 15.5 40.05 15.04 40.5C14.58 40.95 14.35 41.52 14.35 42.2C14.35 42.88 14.58 43.45 15.04 43.91C15.5 44.37 16.06 44.6 16.74 44.6H31.31C31.99 44.6 32.55 44.37 33.01 43.92C33.47 43.47 33.7 42.9 33.7 42.22C33.7 41.54 33.47 40.97 33.01 40.51C32.55 40.05 31.99 39.82 31.31 39.82H25.72V24.33H38.31C38.89 24.33 39.36 24.1 39.71 23.62C40.06 23.15 40.14 22.65 39.95 22.12H39.94Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function HtvrontTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4320"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4320)">
        <path
          d="M21.44 32.79C21.07 32.34 20.73 31.93 20.52 31.68C21.09 31.17 21.63 30.72 22.11 30.23C22.64 29.69 22.58 29.49 21.87 29.11C21.63 28.98 21.39 28.87 21.16 28.74C19.87 28.01 19.56 27.04 20.3 25.96C20.89 25.1 21.82 24.48 22.91 23.9C23.28 24.33 23.62 24.74 23.85 25.01C23.29 25.51 22.74 25.96 22.26 26.44C21.71 26.99 21.8 27.19 22.53 27.6C23.01 27.87 23.53 28.12 23.9 28.46C24.69 29.17 24.56 29.97 24.03 30.75C23.44 31.6 22.53 32.21 21.44 32.78V32.79ZM30.23 31.33C30.79 30.84 31.15 30.25 31.13 29.57C31.11 28.62 30.29 28.13 29.38 27.67C28.4 27.18 28.35 26.96 29.12 26.28C29.58 25.88 30.12 25.53 30.64 25.14C30.3 24.74 29.96 24.33 29.6 23.89C28.46 24.51 27.48 25.16 26.9 26.09C26.39 26.93 26.5 27.73 27.26 28.31C27.63 28.6 28.07 28.83 28.5 29.06C29.24 29.46 29.32 29.7 28.77 30.26C28.3 30.73 27.79 31.18 27.24 31.7C27.43 31.93 27.78 32.34 28.2 32.85C28.92 32.32 29.61 31.85 30.22 31.33H30.23ZM34.58 25.05C34.07 25.58 33.56 26.19 33.37 26.82C33.06 27.85 33.98 28.48 35.01 28.99C36.04 29.5 36.09 29.75 35.28 30.46C34.84 30.85 34.31 31.18 33.8 31.55C34.15 31.97 34.48 32.37 34.84 32.79C35.91 32.22 36.82 31.62 37.42 30.77C38.21 29.65 37.9 28.66 36.55 27.93C36.32 27.8 36.08 27.68 35.84 27.56C35.19 27.21 35.12 27.01 35.6 26.52C35.97 26.14 36.44 25.83 36.87 25.49C37.02 25.38 37.19 25.28 37.36 25.17C36.99 24.73 36.66 24.33 36.27 23.86C35.66 24.28 35.01 24.6 34.57 25.05H34.58ZM46.83 37.98V43.51C46.83 44.28 46.21 44.9 45.44 44.9H3.41999C2.64999 44.9 2.02999 44.28 2.02999 43.51L1.98999 7.04C1.99999 5.36 3.35999 4 5.03999 4H31.33C32.64 4 33.83 4.83 34.28 6.06L35.8 10.23C35.84 10.35 35.87 10.48 35.87 10.62C35.87 12.3 34.51 13.66 32.83 13.66H32.45V14.88H43.27C45.06 14.88 46.57 16.31 46.57 18.01V19.9C46.57 21.6 45.06 23.03 43.27 23.03H15.51C13.79 23.03 12.38 21.63 12.38 19.9V16.01C12.38 15.39 12.89 14.88 13.51 14.88H15.69V13.66H11.09V33.9H42.76C45.01 33.9 46.84 35.73 46.84 37.98H46.83ZM43.27 17.14H14.64V19.9C14.64 20.37 15.04 20.77 15.51 20.77H43.27C43.8 20.77 44.31 20.34 44.31 19.9V18.01C44.31 17.57 43.8 17.14 43.27 17.14ZM4.25999 11.4H32.83C33.2 11.4 33.52 11.13 33.6 10.77L32.17 6.83C32.04 6.48 31.71 6.25 31.34 6.25H5.03999C4.61999 6.25 4.25999 6.61 4.25999 7.03V11.39V11.4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IllustratingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3958"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3958)">
        <path
          d="M29.64 19.48C28.51 17.17 24.77 11.25 24.14 11.25C23.51 11.25 20.11 16.72 18.99 18.72C18.09 20.33 17.69 22.49 17.71 24.34C17.76 27.7 17.72 36.26 17.72 37.74H30.5C30.5 32.33 30.54 28.07 30.46 22.82C30.45 21.85 30.07 20.36 29.63 19.47L29.64 19.48ZM20.34 22.16L24.14 15.3L27.93 22.16H20.34ZM30.43 40.68C30.43 41.83 30.58 43.03 30.39 44.16C30.19 45.32 29.23 45.93 28.06 45.95C25.43 46 22.8 46.03 20.18 45.95C18.61 45.9 17.8 44.94 17.74 43.34C17.71 42.48 17.74 41.61 17.74 40.68H30.44H30.43ZM41.49 7.04H34.3C39.5 10.24 43.08 15.79 43.55 22.21H44.79C45.28 22.21 45.68 22.61 45.68 23.1V28.44C45.68 28.93 45.28 29.33 44.79 29.33H39.45C38.96 29.33 38.56 28.93 38.56 28.44V23.1C38.56 22.61 38.96 22.21 39.45 22.21H40.54C39.91 14.97 34.6 9.06 27.65 7.53V8.38C27.65 8.87 27.25 9.27 26.76 9.27H21.42C20.93 9.27 20.53 8.87 20.53 8.38V7.53C13.58 9.06 8.26999 14.97 7.63999 22.21H8.73999C9.22999 22.21 9.62999 22.61 9.62999 23.1V28.44C9.62999 28.93 9.22999 29.33 8.73999 29.33H3.41999C2.92999 29.33 2.52999 28.93 2.52999 28.44V23.1C2.52999 22.61 2.92999 22.21 3.41999 22.21H4.65999C5.12999 15.79 8.71999 10.24 13.91 7.04H6.71999C6.14999 8.24 4.93999 9.08 3.52999 9.08C1.57999 9.08 -0.0100098 7.5 -0.0100098 5.54C-0.0100098 3.58 1.57999 2 3.53999 2C4.95999 2 6.16999 2.84 6.72999 4.04H20.55V3.05C20.55 2.56 20.95 2.16 21.44 2.16H26.78C27.27 2.16 27.67 2.56 27.67 3.05V4.04H41.49C42.06 2.84 43.27 2 44.68 2C46.63 2 48.22 3.58 48.22 5.54C48.22 7.5 46.64 9.08 44.68 9.08C43.26 9.08 42.05 8.24 41.49 7.04Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function JewelryMakingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3964"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <path d="M0 0H48V48H0V0Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3964)">
        <path
          d="M39.69 30.65C39.69 39.13 32.82 46 24.34 46C15.86 46 9 39.13 9 30.65C9 25.56 11.49 21.07 15.3 18.28L18.01 21.54C15.13 23.55 13.23 26.88 13.23 30.66C13.23 36.79 18.21 41.77 24.34 41.77C30.47 41.77 35.45 36.79 35.45 30.66C35.45 26.89 33.56 23.55 30.67 21.55L33.38 18.29C37.19 21.08 39.68 25.58 39.68 30.66L39.69 30.65ZM23.8 2H24.89L28.27 8.91H20.43L23.8 2ZM12.16 10.52H23.54V24.18L12.16 10.52ZM25.15 10.52H36.53L25.15 24.18V10.52ZM26.69 2H32.16C32.52 2 32.86 2.1 33.17 2.29C33.48 2.48 33.72 2.74 33.89 3.06L36.78 8.91H30.06L26.68 2H26.69ZM14.8 3.06C14.97 2.74 15.21 2.48 15.52 2.29C15.83 2.1 16.17 2 16.53 2H22L18.62 8.91H11.9L14.8 3.06Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function JournalingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3976"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <path d="M0 0H48V48H0V0Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3976)">
        <path
          d="M43.2699 9.16C42.9899 8.87 42.6299 8.73 42.1999 8.73C41.7699 8.73 41.4099 8.87 41.1199 9.16C40.8299 9.45 40.6899 9.8 40.6899 10.23V18.07H34.7699C34.0399 18.07 33.3499 18.41 32.8099 19.02C32.2399 19.68 31.9099 20.59 31.9099 21.54C31.9099 22.49 32.2399 23.4 32.8099 24.06C33.3399 24.67 34.0399 25.01 34.7699 25.01H40.6899V41.74H15.1899C14.8499 41.74 14.5299 41.68 14.2299 41.58L12.7899 44.22C13.5199 44.56 14.3199 44.75 15.1899 44.75H40.6899C41.5099 44.75 42.2199 44.46 42.8099 43.87C43.3999 43.28 43.6899 42.58 43.6899 41.75V10.22C43.6899 9.8 43.5499 9.44 43.2599 9.15L43.2699 9.16ZM37.4299 21.82C37.3699 22.11 37.2299 22.38 37.0199 22.59C36.8099 22.8 36.5399 22.94 36.2499 23C35.9599 23.06 35.6599 23.03 35.3799 22.91C35.1099 22.8 34.8699 22.6 34.7099 22.36C34.5399 22.11 34.4599 21.82 34.4599 21.52C34.4599 21.12 34.6199 20.74 34.8999 20.46C35.1799 20.18 35.5699 20.02 35.9599 20.02C36.2599 20.02 36.5499 20.11 36.7999 20.27C37.0499 20.44 37.2399 20.67 37.3499 20.95C37.4599 21.22 37.4899 21.53 37.4399 21.82H37.4299ZM17.9299 11.1L9.68995 26.16V5.99C9.68995 4.34 11.0399 3 12.6799 3H35.7299C37.3799 3 38.7199 4.35 38.7199 5.99V15.56H34.7599C33.3199 15.56 31.9199 16.22 30.9199 17.37C29.9499 18.49 29.4099 19.97 29.4099 21.53C29.4099 23.09 29.9499 24.57 30.9199 25.69C31.9199 26.84 33.3199 27.5 34.7599 27.5H38.7199V34.31C38.7199 35.96 37.3699 37.3 35.7299 37.3H16.5599L27.9099 16.55C28.1799 16.06 28.3499 15.52 28.4199 14.93C28.4899 14.39 28.4599 13.86 28.3399 13.35L27.9999 9.78L27.9799 9.59L27.9299 9.41C27.6799 8.56 27.1499 7.89 26.3899 7.47C25.9199 7.21 25.4099 7.08 24.8699 7.08C24.5599 7.08 24.2399 7.13 23.9299 7.22L23.7499 7.27L23.5799 7.36L20.3899 9C19.8899 9.17 19.4299 9.44 19.0199 9.78C18.5699 10.16 18.1999 10.6 17.9299 11.09V11.1ZM26.1599 15.6C26.3099 15.33 26.3999 15.03 26.4499 14.69C26.4899 14.35 26.4699 14.03 26.3799 13.71L26.0199 9.98C25.9199 9.64 25.7299 9.39 25.4399 9.24C25.2599 9.14 25.0799 9.1 24.8799 9.1C24.7599 9.1 24.6299 9.12 24.4999 9.16L21.1599 10.87C20.8499 10.96 20.5599 11.12 20.2999 11.33C20.0399 11.55 19.8299 11.79 19.6899 12.06L4.38995 40.02C4.18995 40.39 4.05995 40.75 4.01995 41.08C3.97995 41.41 4.00995 41.76 4.09995 42.1C4.18995 42.41 4.34995 42.7 4.55995 42.96C4.77995 43.22 5.06995 43.45 5.43995 43.66L7.20995 44.63C7.54995 44.84 7.89995 44.97 8.22995 45.01C8.32995 45.02 8.42995 45.03 8.52995 45.03C8.76995 45.03 8.99995 45 9.23995 44.93C9.54995 44.84 9.84995 44.68 10.1199 44.46C10.3899 44.24 10.6299 43.94 10.8399 43.57L26.1399 15.61L26.1599 15.6ZM7.51995 39.67L20.5899 15.79L22.5199 16.85L9.44995 40.73L7.51995 39.67Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function JunkJournalingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4054"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4054)">
        <path
          d="M12.15 17.63C11.77 17.26 11.56 16.75 11.56 16.22C11.56 15.82 11.68 15.44 11.9 15.11C12.12 14.78 12.43 14.52 12.8 14.37C13.16 14.22 13.57 14.18 13.96 14.26C14.35 14.34 14.7 14.53 14.98 14.81C15.26 15.09 15.45 15.45 15.53 15.83C15.61 16.22 15.57 16.62 15.42 16.99C15.27 17.36 15.01 17.67 14.68 17.89C14.35 18.11 13.97 18.23 13.57 18.23C13.04 18.23 12.53 18.02 12.16 17.64L12.15 17.63ZM41 10.22V41.72C41 42.55 40.71 43.25 40.12 43.84C39.53 44.43 38.83 44.72 38 44.72H12.5C11 44.72 9.71 44.23 8.62 43.24C7.54 42.25 7 41.03 7 39.57V5.99C7 4.35 8.35 3 9.99 3H33.04C34.69 3 36.03 4.35 36.03 5.99V15.56H32.07C30.63 15.56 29.23 16.22 28.23 17.37C27.26 18.49 26.72 19.97 26.72 21.53C26.72 23.09 27.26 24.57 28.23 25.69C29.23 26.84 30.63 27.5 32.07 27.5H36.03V34.31C36.03 35.96 34.68 37.3 33.04 37.3H28.71C28.27 38.08 27.52 38.68 26.57 38.87L15.06 41.16C14.86 41.2 14.65 41.22 14.44 41.22C12.93 41.22 11.62 40.14 11.33 38.66L11.11 37.56C10.92 37.69 10.73 37.85 10.57 38.04C10.19 38.5 10 39.01 10 39.56C10 40.19 10.25 40.71 10.75 41.11C11.25 41.51 11.83 41.71 12.5 41.71H38V24.98H32.08C31.35 24.98 30.66 24.64 30.12 24.03C29.55 23.38 29.22 22.46 29.22 21.51C29.22 20.56 29.55 19.65 30.12 18.99C30.65 18.38 31.35 18.04 32.08 18.04H38V10.2C38 9.78 38.15 9.42 38.43 9.13C38.72 8.84 39.08 8.7 39.51 8.7C39.94 8.7 40.29 8.84 40.58 9.13C40.86 9.42 41.01 9.77 41.01 10.2L41 10.22ZM34.65 20.95C34.54 20.67 34.34 20.44 34.1 20.27C33.85 20.1 33.56 20.02 33.26 20.02C32.86 20.02 32.48 20.18 32.2 20.46C31.92 20.74 31.76 21.13 31.76 21.52C31.76 21.82 31.85 22.11 32.01 22.36C32.17 22.61 32.41 22.8 32.68 22.91C32.96 23.02 33.26 23.05 33.55 23C33.84 22.94 34.11 22.8 34.32 22.59C34.53 22.38 34.67 22.11 34.73 21.82C34.79 21.53 34.76 21.23 34.64 20.95H34.65ZM26.99 35.56L24.34 22.24C24.24 21.74 23.8 21.39 23.3 21.39C23.23 21.39 23.16 21.39 23.09 21.41L11.58 23.7C11.01 23.81 10.63 24.37 10.75 24.95L13.4 38.27C13.5 38.77 13.94 39.12 14.44 39.12C14.51 39.12 14.58 39.12 14.65 39.1L26.16 36.81C26.73 36.7 27.11 36.14 26.99 35.56ZM13.57 8.22C13.57 8.4 13.64 8.57 13.77 8.69C13.89 8.82 14.06 8.89 14.24 8.89C14.61 8.89 14.76 8.98 15.01 9.13C15.44 9.41 15.95 9.56 16.46 9.56C16.97 9.56 17.48 9.41 17.91 9.13C18.16 8.98 18.31 8.89 18.68 8.89C19.05 8.89 19.2 8.98 19.45 9.13C19.88 9.42 20.39 9.57 20.9 9.56C21.08 9.56 21.25 9.49 21.37 9.36C21.49 9.23 21.56 9.07 21.56 8.89C21.56 8.71 21.49 8.54 21.37 8.42C21.25 8.3 21.08 8.22 20.9 8.22C20.53 8.22 20.38 8.13 20.13 7.98C19.7 7.7 19.19 7.55 18.68 7.55C18.17 7.55 17.66 7.7 17.23 7.98C16.98 8.13 16.83 8.22 16.46 8.22C16.09 8.22 15.94 8.13 15.69 7.98C15.26 7.69 14.75 7.54 14.24 7.55C14.06 7.55 13.89 7.62 13.77 7.75C13.65 7.88 13.57 8.04 13.57 8.22ZM13.57 10.88C13.57 11.06 13.64 11.23 13.77 11.35C13.89 11.48 14.06 11.55 14.24 11.55C14.61 11.55 14.76 11.64 15.01 11.79C15.44 12.07 15.95 12.22 16.46 12.22C16.97 12.22 17.48 12.07 17.91 11.79C18.16 11.64 18.31 11.55 18.68 11.55C19.05 11.55 19.2 11.64 19.45 11.79C19.88 12.08 20.39 12.23 20.9 12.22C21.08 12.22 21.25 12.15 21.37 12.02C21.49 11.89 21.56 11.73 21.56 11.55C21.56 11.37 21.49 11.2 21.37 11.08C21.25 10.96 21.08 10.88 20.9 10.88C20.53 10.88 20.38 10.79 20.13 10.64C19.7 10.36 19.19 10.21 18.68 10.21C18.17 10.21 17.66 10.36 17.23 10.64C16.98 10.79 16.83 10.88 16.46 10.88C16.09 10.88 15.94 10.79 15.69 10.64C15.26 10.35 14.75 10.2 14.24 10.21C14.06 10.21 13.89 10.28 13.77 10.41C13.65 10.54 13.57 10.7 13.57 10.88ZM10.25 16.58C10.32 17.25 10.6 17.89 11.05 18.4C11.5 18.91 12.09 19.28 12.75 19.44C13.41 19.61 14.1 19.57 14.74 19.33C15.38 19.09 15.92 18.67 16.31 18.11C16.7 17.55 16.9 16.89 16.9 16.21C16.9 15.75 16.8 15.29 16.62 14.87C17.08 14.85 17.53 14.7 17.91 14.45C18.16 14.3 18.31 14.21 18.68 14.21C19.05 14.21 19.2 14.3 19.45 14.45C19.88 14.74 20.39 14.89 20.9 14.88C21.08 14.88 21.25 14.81 21.37 14.68C21.49 14.56 21.56 14.39 21.56 14.21C21.56 14.03 21.49 13.86 21.37 13.74C21.25 13.62 21.07 13.54 20.9 13.54C20.53 13.54 20.38 13.45 20.13 13.3C19.7 13.02 19.19 12.87 18.68 12.87C18.17 12.87 17.66 13.02 17.23 13.3C16.98 13.45 16.83 13.54 16.46 13.54C16.09 13.54 15.94 13.45 15.69 13.3C15.26 13.01 14.75 12.86 14.24 12.87C14.17 12.87 14.1 12.88 14.04 12.9C13.37 12.81 12.68 12.92 12.08 13.23C11.47 13.54 10.98 14.02 10.65 14.62C10.33 15.22 10.19 15.9 10.27 16.57L10.25 16.58ZM21.5 23.81L13.88 25.32C13.51 25.39 13.27 25.75 13.34 26.12L14.85 33.74C14.92 34.11 15.28 34.35 15.65 34.28L23.27 32.77C23.64 32.7 23.88 32.34 23.81 31.97L22.3 24.35C22.23 23.98 21.87 23.74 21.5 23.81Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function KdpTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4091"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4091)">
        <path
          d="M45.38 9.16C45.1 8.87 44.74 8.73 44.31 8.73C43.88 8.73 43.52 8.87 43.23 9.16C42.94 9.45 42.8 9.8 42.8 10.23V41.73H19.31C18.64 41.73 18.06 41.53 17.56 41.13C17.06 40.73 16.81 40.21 16.81 39.58C16.81 39.03 17 38.52 17.38 38.06C17.66 37.72 18 37.47 18.38 37.32H37.85C39.5 37.32 40.84 35.97 40.84 34.33V5.99C40.84 4.34 39.49 3 37.85 3H16.8C15.15 3 13.81 4.35 13.81 5.99V6.87C8.62 9.26 5 14.49 5 20.56C5 26.63 8.62 31.87 13.81 34.25V39.57C13.81 41.03 14.35 42.25 15.43 43.24C16.51 44.23 17.81 44.72 19.31 44.72H42.81C43.63 44.72 44.34 44.43 44.93 43.84C45.52 43.25 45.81 42.55 45.81 41.72V10.22C45.81 9.8 45.67 9.44 45.38 9.15V9.16ZM13.81 30.87C10.33 28.75 8 24.93 8 20.56C8 16.19 10.33 12.37 13.81 10.25C15.64 9.14 17.78 8.48 20.08 8.48C26.75 8.48 32.15 13.89 32.15 20.55C32.15 27.21 26.74 32.62 20.08 32.62C17.78 32.62 15.64 31.97 13.81 30.85V30.87ZM29.15 20.56C29.15 15.56 25.08 11.49 20.08 11.49C15.08 11.49 11.01 15.56 11.01 20.56C11.01 25.56 15.08 29.63 20.08 29.63C25.08 29.63 29.15 25.56 29.15 20.56ZM18.04 24.07C17.69 23.62 17.5 23.06 17.5 22.49H18.79C18.79 22.75 18.87 23 19.01 23.21C19.15 23.42 19.35 23.59 19.59 23.68C19.83 23.78 20.09 23.8 20.34 23.75C20.59 23.7 20.82 23.58 21 23.4C21.18 23.22 21.3 22.99 21.35 22.74C21.4 22.49 21.37 22.23 21.28 22C21.18 21.76 21.02 21.56 20.8 21.42C20.59 21.28 20.34 21.2 20.08 21.2C19.46 21.2 18.86 20.96 18.39 20.55C17.92 20.14 17.63 19.57 17.55 18.95C17.47 18.33 17.62 17.71 17.97 17.19C18.32 16.67 18.84 16.3 19.44 16.13V14.75H20.73V16.13C21.28 16.27 21.77 16.59 22.12 17.04C22.47 17.49 22.66 18.05 22.66 18.62H21.37C21.37 18.28 21.23 17.95 20.99 17.71C20.75 17.47 20.42 17.33 20.08 17.33C19.74 17.33 19.41 17.47 19.17 17.71C18.93 17.95 18.79 18.28 18.79 18.62C18.79 18.96 18.93 19.29 19.17 19.53C19.41 19.77 19.74 19.91 20.08 19.91C20.7 19.91 21.3 20.15 21.77 20.56C22.23 20.97 22.53 21.54 22.61 22.16C22.69 22.78 22.54 23.4 22.2 23.92C21.85 24.44 21.33 24.81 20.73 24.98V26.36H19.44V24.98C18.89 24.84 18.4 24.51 18.05 24.07H18.04Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function KidsCraftsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4364"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4364)">
        <path
          d="M7.35 30.2C5.85 30.2 4.58 29.68 3.55 28.64C2.52 27.6 2 26.34 2 24.85C2 23.36 2.52 22.1 3.56 21.06C4.6 20.02 5.86 19.5 7.35 19.5V13.35C7.35 12.55 7.65 11.85 8.25 11.25C8.85 10.65 9.55 10.35 10.35 10.35H18.65C18.65 8.85 19.17 7.58 20.21 6.55C21.25 5.52 22.51 5 24 5C25.49 5 26.75 5.52 27.79 6.56C28.83 7.6 29.35 8.86 29.35 10.35H37.65C38.45 10.35 39.15 10.65 39.75 11.25C40.35 11.85 40.65 12.55 40.65 13.35V19.5C42.15 19.5 43.42 20.02 44.45 21.06C45.48 22.1 46 23.36 46 24.85C46 26.34 45.48 27.6 44.44 28.64C43.4 29.68 42.14 30.2 40.65 30.2V40C40.65 40.8 40.35 41.5 39.75 42.1C39.15 42.7 38.45 43 37.65 43H10.35C9.55 43 8.85 42.7 8.25 42.1C7.65 41.5 7.35 40.8 7.35 40V30.2ZM17.17 25.7C17.87 25.7 18.46 25.46 18.94 24.97C19.42 24.48 19.66 23.89 19.66 23.19C19.66 22.49 19.42 21.9 18.93 21.42C18.44 20.94 17.85 20.7 17.15 20.7C16.45 20.7 15.86 20.95 15.38 21.43C14.9 21.92 14.66 22.51 14.66 23.21C14.66 23.91 14.9 24.5 15.39 24.98C15.88 25.46 16.47 25.7 17.17 25.7ZM30.86 25.7C31.56 25.7 32.15 25.46 32.63 24.97C33.11 24.48 33.35 23.89 33.35 23.19C33.35 22.49 33.11 21.9 32.62 21.42C32.13 20.94 31.54 20.7 30.84 20.7C30.14 20.7 29.55 20.95 29.07 21.43C28.59 21.91 28.35 22.51 28.35 23.21C28.35 23.91 28.59 24.5 29.08 24.98C29.57 25.46 30.16 25.7 30.86 25.7ZM15.56 35.74H32.57C33.09 35.74 33.53 35.5 33.89 35.02C34.24 34.54 34.42 33.94 34.42 33.23C34.42 32.52 34.24 31.93 33.89 31.45C33.54 30.98 33.1 30.74 32.57 30.74H15.56C15.04 30.74 14.6 30.98 14.24 31.46C13.89 31.94 13.71 32.54 13.71 33.25C13.71 33.96 13.89 34.55 14.24 35.03C14.59 35.5 15.03 35.74 15.56 35.74Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function KnittingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4421"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4421)">
        <path
          d="M41.66 8.94C34.32 1.6 22.54 1.39 14.92 8.25C14.9 8.23 14.89 8.2 14.87 8.18L11.77 5.08C11.86 4.79 11.92 4.48 11.92 4.16C11.92 2.41 10.5 1 8.76 1C7.02 1 5.6 2.42 5.6 4.16C5.6 5.9 7.02 7.32 8.76 7.32C9.08 7.32 9.39 7.26 9.68 7.17L12.78 10.27C12.78 10.27 12.85 10.31 12.89 10.34C7.39 17.02 7.03 26.54 11.82 33.6H10.69C6.52 33.6 5.64 35.74 5.64 37.53C5.64 39.32 6.53 41.51 10.75 41.51H13.37C13.68 41.51 14.4 41.57 14.4 42.09C14.4 42.19 14.38 42.23 14.38 42.23C14.38 42.23 14.14 42.46 13.22 42.46H4.55C3.69 42.46 3 43.15 3 44.01C3 44.87 3.69 45.56 4.55 45.56H13.22C16.37 45.56 17.5 43.77 17.5 42.1C17.5 40.27 16.08 38.42 13.37 38.42H10.75C8.74 38.42 8.74 38.01 8.74 37.54C8.74 37.13 8.74 36.71 10.69 36.71H14.44C18.2 40.32 23.05 42.14 27.91 42.14C32.77 42.14 37.87 40.24 41.66 36.45C49.24 28.87 49.24 16.53 41.66 8.95V8.94ZM13.96 17.15C14.13 16.62 14.69 16.34 15.22 16.5C15.28 16.52 21.28 18.42 27.16 17.8C26.99 12.93 25.55 9.31 25.53 9.28C25.32 8.77 25.57 8.19 26.08 7.98C26.59 7.77 27.17 8.02 27.38 8.53C27.45 8.7 28.94 12.39 29.15 17.5C30.14 17.31 31.13 17.06 32.08 16.79C31.81 12.4 30.54 9.96 30.53 9.94C30.27 9.45 30.45 8.85 30.94 8.59C31.42 8.33 32.03 8.51 32.29 8.99C32.35 9.1 33.68 11.62 34.04 16.18C36.25 15.43 38.09 14.59 39.04 14.02C39.51 13.73 40.13 13.88 40.41 14.36C40.7 14.83 40.55 15.45 40.07 15.73C38.19 16.87 33.41 18.84 28.65 19.63C28.52 19.65 28.38 19.66 28.25 19.68C28.22 19.68 28.2 19.7 28.17 19.7C28.17 19.7 28.16 19.7 28.15 19.7C26.97 19.87 25.79 19.95 24.65 19.95C19.39 19.95 14.84 18.51 14.6 18.43C14.07 18.26 13.79 17.7 13.95 17.17L13.96 17.15ZM41.45 27.01C41.27 27.13 37.75 29.35 32.89 30.78C31.63 34.57 29.87 36.97 29.79 37.08C29.59 37.34 29.29 37.48 28.99 37.48C28.78 37.48 28.57 37.42 28.39 37.28C27.95 36.95 27.86 36.32 28.18 35.88C28.2 35.86 29.46 34.13 30.54 31.38C30.09 31.48 29.64 31.57 29.18 31.64C28.57 31.74 27.94 31.81 27.32 31.86C26.16 34.69 24.89 36.44 24.83 36.51C24.63 36.77 24.33 36.91 24.03 36.91C23.82 36.91 23.61 36.85 23.43 36.71C22.99 36.38 22.9 35.75 23.22 35.31C23.23 35.3 24.16 34.02 25.1 31.94C19.73 31.94 14.87 30.5 14.62 30.43C14.09 30.27 13.79 29.71 13.95 29.18C14.11 28.65 14.66 28.35 15.2 28.51C15.27 28.53 22.6 30.69 28.85 29.65C35.14 28.6 40.32 25.33 40.37 25.3C40.84 25 41.45 25.14 41.75 25.6C42.05 26.06 41.91 26.68 41.45 26.98V27.01ZM42.2 21.09C41.92 21.23 35.37 24.58 28.73 25.68C27.39 25.9 25.99 25.99 24.62 25.99C19.12 25.99 13.92 24.56 13.65 24.48C13.12 24.33 12.81 23.78 12.96 23.25C13.11 22.72 13.66 22.41 14.19 22.56C14.27 22.58 22.16 24.75 28.41 23.71C34.73 22.66 41.23 19.35 41.3 19.31C41.79 19.06 42.39 19.25 42.65 19.74C42.9 20.23 42.71 20.83 42.22 21.09H42.2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function LaserCuttingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4017"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4017)">
        <path
          d="M0.5 29.3V26.64C0.5 25.81 1.17 25.14 2 25.14C2.83 25.14 3.5 25.81 3.5 26.64V29.3C3.5 30.13 2.83 30.8 2 30.8C1.17 30.8 0.5 30.13 0.5 29.3ZM2 21.94C2.83 21.94 3.5 21.27 3.5 20.44V17.78C3.5 16.95 2.83 16.28 2 16.28C1.17 16.28 0.5 16.95 0.5 17.78V20.44C0.5 21.27 1.17 21.94 2 21.94ZM9.67 10.88H12.33C13.16 10.88 13.83 10.21 13.83 9.38C13.83 8.55 13.16 7.88 12.33 7.88H9.67C8.84 7.88 8.17 8.55 8.17 9.38C8.17 10.21 8.84 10.88 9.67 10.88ZM1.9 13.08C1.9 13.08 1.97 13.08 2 13.08C2.78 13.08 3.44 12.47 3.49 11.68C3.51 11.35 3.73 11.06 4.04 10.94C4.81 10.63 5.18 9.76 4.87 8.99C4.56 8.22 3.69 7.85 2.92 8.16C1.55 8.71 0.59 10.02 0.5 11.49C0.44 12.32 1.07 13.03 1.89 13.09L1.9 13.08ZM48.8 2V21.46H41.98V29.13C41.98 29.96 41.73 30.78 41.26 31.47L38.75 35.15C38.75 35.15 38.7 35.21 38.68 35.24V41.69C38.68 44.1 36.72 46.06 34.31 46.06H4.37C1.96 46.06 0 44.1 0 41.69V36.12C0 35.4 0.39 34.77 0.96 34.42C1.23 34.16 1.6 34 2 34C2.4 34 2.77 34.16 3.04 34.42C3.61 34.77 4 35.4 4 36.12V41.69C4 41.88 4.17 42.06 4.37 42.06H34.31C34.5 42.06 34.68 41.89 34.68 41.69V36.9C33.56 36.72 32.55 36.1 31.9 35.15L29.39 31.47C28.92 30.78 28.67 29.97 28.67 29.13V21.46H21.85V10.73C21.65 10.83 21.43 10.89 21.2 10.89H18.54C17.71 10.89 17.04 10.22 17.04 9.39C17.04 8.56 17.71 7.89 18.54 7.89H21.2C21.44 7.89 21.66 7.95 21.85 8.05V2H48.81H48.8ZM37.83 13.61H32.81V29.13L35.32 32.81L37.83 29.13V13.61Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function LeatherworkingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4023"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4023)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.2599 11C43.4899 10.69 43.4599 10.27 43.1999 9.99001L38.6099 5.20001C38.3699 4.95001 37.9899 4.88001 37.6799 5.05001C35.9499 5.96001 34.3499 6.17001 32.9299 5.70001C30.5999 4.91001 29.4499 2.49001 29.4399 2.47001C29.3099 2.19001 29.0299 2.01001 28.7299 2.01001H19.6899C19.3799 2.01001 19.1099 2.19001 18.9799 2.47001C18.9699 2.49001 17.8199 4.92001 15.4899 5.70001C14.0699 6.18001 12.4799 5.96001 10.7399 5.05001C10.4299 4.89001 10.0499 4.95001 9.80994 5.20001L5.21994 9.99001C4.95994 10.27 4.92994 10.69 5.15994 11C5.49994 11.47 13.4399 22.56 5.24994 36.29C5.10994 36.53 5.09994 36.82 5.22994 37.07L8.59994 43.31C8.81994 43.73 9.41994 43.86 9.77994 43.55C10.0199 43.36 15.8099 38.91 23.6799 45.81C23.8299 45.94 24.0099 46 24.1999 46C24.3899 46 24.5699 45.94 24.7199 45.81C32.5899 38.91 38.3799 43.36 38.6199 43.55C38.9799 43.86 39.5899 43.74 39.7999 43.31L43.1699 37.07C43.2999 36.83 43.2999 36.53 43.1499 36.29C34.9599 22.56 42.8999 11.47 43.2399 11H43.2599ZM13.7699 38.89C12.9699 39.01 12.1999 39.21 11.4599 39.49C11.3499 39.53 11.2299 39.55 11.1099 39.55C10.7599 39.55 10.4199 39.36 10.2399 39.03L8.87994 36.5C8.71994 36.21 8.71994 35.86 8.87994 35.56C9.27994 34.81 9.64994 34.05 9.97994 33.29C10.2399 32.7 10.8199 32.59 11.2699 32.78C11.7199 32.97 12.0399 33.47 11.7999 34.06C11.5199 34.71 11.2099 35.37 10.8799 36.02L11.5999 37.35C12.2199 37.16 12.8599 37.02 13.4999 36.92C14.1399 36.83 14.5399 37.28 14.6099 37.76C14.6799 38.23 14.4199 38.77 13.7899 38.88L13.7699 38.89ZM11.9099 25.75C11.9299 25.49 12.0599 25.25 12.2599 25.08C12.4599 24.91 12.7099 24.83 12.9799 24.86C13.5199 24.91 13.9199 25.39 13.8699 25.93C13.7399 27.32 13.4999 28.72 13.1399 30.09C13.0799 30.34 12.9099 30.56 12.6799 30.69C12.5299 30.78 12.3499 30.83 12.1799 30.83C12.0999 30.83 12.0099 30.82 11.9299 30.8C11.6799 30.73 11.4599 30.57 11.3299 30.35C11.1999 30.12 11.1599 29.86 11.2299 29.6C11.5599 28.33 11.7799 27.04 11.8999 25.76L11.9099 25.75ZM12.0599 16.82C12.5299 16.71 13.0899 16.92 13.2499 17.53C13.5799 18.91 13.8099 20.31 13.9099 21.7C13.9299 21.97 13.8399 22.24 13.6499 22.45C13.4599 22.65 13.1999 22.77 12.9299 22.77C12.4199 22.77 11.9899 22.37 11.9499 21.86C11.8499 20.58 11.6499 19.28 11.3399 18.01C11.1999 17.38 11.5999 16.94 12.0699 16.83L12.0599 16.82ZM14.8699 10.89C14.2899 11.3 13.2699 11.06 12.4499 10.86C12.2899 10.82 12.1499 10.79 12.0299 10.76C11.8199 10.98 11.3199 11.51 11.0899 11.74C11.1599 11.89 11.2599 12.07 11.3499 12.24C11.7399 12.97 12.1899 13.8 11.8899 14.38C11.7499 14.66 11.4699 14.83 11.0499 14.89C10.6199 14.89 10.2599 14.65 10.1099 14.28C9.77994 13.49 9.41994 12.73 9.02994 12.03C8.81994 11.65 8.88994 11.19 9.17994 10.87L10.9999 8.97001C11.2599 8.70001 11.6599 8.59001 12.0199 8.71001C12.7899 8.96001 13.5599 9.10001 14.2999 9.12001C14.5599 9.12001 14.8099 9.24001 14.9899 9.43001C15.1699 9.62001 15.2699 9.87001 15.2599 10.14C15.2299 10.48 15.0899 10.72 14.8599 10.89H14.8699ZM19.7599 38.64C19.6799 38.89 19.5099 39.1 19.2799 39.22C19.1399 39.3 18.9799 39.33 18.8199 39.33C18.7199 39.33 18.6199 39.32 18.5299 39.29L18.1999 39.19C17.9466 39.11 17.7099 39.0467 17.4899 39L17.1299 38.92C16.5199 38.86 16.2299 38.34 16.2699 37.85C16.3099 37.37 16.6799 36.9 17.3199 36.96C17.3399 36.96 17.3499 36.96 17.3599 36.96C17.8199 37.09 18.0099 37.12 18.1799 37.16C18.3899 37.2 18.5499 37.23 19.0999 37.4C19.6199 37.56 19.9099 38.12 19.7499 38.64H19.7599ZM26.8799 40.38C26.5199 40.52 26.0999 40.81 25.7399 41.07C25.2099 41.44 24.7099 41.79 24.2599 41.88C24.2399 41.88 24.2299 41.88 24.2099 41.88C24.1899 41.88 24.1799 41.88 24.1599 41.88C23.7099 41.78 23.1899 41.42 22.6799 41.07C22.3099 40.82 21.8999 40.53 21.5599 40.39C21.2999 40.26 21.1299 40.05 21.0599 39.8C20.9799 39.55 21.0099 39.28 21.1299 39.05C21.3799 38.57 21.9799 38.39 22.4599 38.64C23.0399 38.95 23.6199 39.3 24.1999 39.69C24.7799 39.3 25.3699 38.94 25.9399 38.64C26.5099 38.35 27.0399 38.64 27.2599 39.06C27.4899 39.48 27.4199 40.08 26.8699 40.39L26.8799 40.38ZM26.8999 7.73001C26.7899 7.60001 26.6899 7.48001 26.5899 7.37001H21.8099C21.7099 7.48001 21.6099 7.61001 21.4999 7.73001C20.9599 8.37001 20.3499 9.10001 19.5999 9.25001C19.1599 9.28001 18.7799 9.01001 18.6299 8.59001C18.4799 8.17001 18.5999 7.74001 18.9399 7.49001C19.5299 7.01001 20.0699 6.44001 20.5399 5.79001C20.7199 5.54001 21.0199 5.38001 21.3399 5.38001C22.9099 5.38001 25.5099 5.38001 27.0699 5.38001C27.3899 5.38001 27.6899 5.53001 27.8699 5.79001C28.3399 6.43001 28.8799 7.00001 29.4699 7.49001C29.7999 7.74001 29.9199 8.16001 29.7699 8.58001C29.6299 8.99001 29.2799 9.25001 28.8699 9.25001C28.8499 9.25001 28.8199 9.25001 28.7999 9.25001C28.0499 9.10001 27.4299 8.37001 26.8899 7.73001H26.8999ZM31.9499 38.58C31.7799 38.78 31.5399 38.9 31.2799 38.93L30.5499 39.12C30.1299 39.22 29.8099 39.31 29.6599 39.34H29.6499C29.1699 39.34 28.7999 39.06 28.6699 38.65C28.5899 38.4 28.6199 38.13 28.7399 37.9C28.8599 37.67 29.0699 37.49 29.3199 37.42C30.1099 37.18 30.1199 37.17 30.5899 37.08L31.0899 36.98C31.3699 36.95 31.6299 37.03 31.8299 37.2C32.0299 37.37 32.1599 37.62 32.1899 37.88C32.2099 38.14 32.1299 38.4 31.9599 38.6L31.9499 38.58ZM33.5399 10.88C33.3099 10.72 33.1799 10.47 33.1499 10.15C33.1499 9.87001 33.2399 9.62001 33.4199 9.43001C33.5999 9.24001 33.8499 9.13001 34.1099 9.12001C34.8499 9.10001 35.6199 8.96001 36.3899 8.71001C36.7499 8.59001 37.1399 8.69001 37.4099 8.97001L39.2299 10.87C39.5299 11.18 39.5899 11.65 39.3799 12.03C38.9899 12.75 38.6199 13.51 38.2999 14.29C38.1499 14.66 37.7899 14.9 37.3899 14.9C36.9399 14.84 36.6599 14.66 36.5199 14.39C36.2299 13.81 36.6699 12.98 37.0599 12.25C37.1599 12.07 37.2499 11.89 37.3199 11.74L36.3799 10.76C36.2599 10.78 36.1299 10.82 35.9899 10.85C35.1899 11.04 34.1199 11.3 33.5299 10.88H33.5399ZM35.4399 24.87C35.9199 24.84 36.4399 25.12 36.5099 25.75C36.6299 27.04 36.8499 28.33 37.1799 29.59C37.2599 29.88 37.1999 30.19 37.0099 30.44C36.8199 30.69 36.5399 30.83 36.2399 30.83H36.2299C35.7799 30.83 35.3899 30.53 35.2799 30.09C34.9199 28.72 34.6799 27.32 34.5499 25.93C34.4999 25.29 34.9699 24.91 35.4499 24.87H35.4399ZM34.5099 21.7C34.6199 20.31 34.8399 18.9 35.1699 17.53C35.3299 16.91 35.8899 16.7 36.3599 16.81C36.8299 16.92 37.2299 17.36 37.0899 17.99C36.7799 19.27 36.5699 20.56 36.4799 21.85C36.4399 22.36 36.0099 22.76 35.4999 22.76C35.2299 22.76 34.9699 22.65 34.7799 22.45C34.5899 22.25 34.4999 21.98 34.5199 21.7H34.5099ZM39.5399 36.51L38.1799 39.04C38.0099 39.36 37.6699 39.56 37.3099 39.56C36.9399 39.48 36.6399 39.38 36.3299 39.29C35.7899 39.12 35.2299 38.95 34.6599 38.9C34.0199 38.79 33.7599 38.26 33.8299 37.78C33.8999 37.3 34.2999 36.86 34.9399 36.94C35.5799 37.03 36.2199 37.18 36.8499 37.37L37.5699 36.04C37.2399 35.4 36.9299 34.74 36.6499 34.09C36.4099 33.5 36.7299 33 37.1699 32.81C37.6099 32.62 38.1999 32.73 38.4599 33.31C38.7899 34.07 39.1499 34.84 39.5599 35.59C39.7199 35.88 39.7199 36.23 39.5599 36.53L39.5399 36.51Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function MachineEmbroideryTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4206"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4206)">
        <path
          d="M35.07 18.01H40.46V24.98H35.07V18.01ZM45.47 19.33C45.47 19.46 45.45 19.59 45.42 19.72C45.45 19.82 45.47 19.93 45.47 20.04V34.84C45.47 34.96 45.44 35.08 45.4 35.19C45.4 35.22 45.4 35.25 45.4 35.28V44.5C45.4 45.33 44.73 46 43.9 46H3.56C2.73 46 2.06 45.33 2.06 44.5V37.97C2.06 35.66 3.94 33.78 6.25 33.78H29.8V20.89H19.56V21.44C19.56 23.19 18.13 24.62 16.38 24.62H13.88V26.51C13.88 27.34 13.21 28.01 12.38 28.01C11.55 28.01 10.88 27.34 10.88 26.51V24.62H8.38C6.63 24.62 5.2 23.19 5.2 21.44V20.74C3.36 20.27 2 18.62 2 16.64V9.44C2 7.1 3.91 5.2 6.25 5.2H10.89V3.5C10.89 2.67 11.56 2 12.39 2C13.22 2 13.89 2.67 13.89 3.5V5.2H29.9V4.56C29.9 3.17 31.03 2.05 32.41 2.05H35.24C36.63 2.05 37.75 3.18 37.75 4.56V5.2H41.22C43.56 5.2 45.47 7.11 45.47 9.45V19.34V19.33ZM16.56 20.89H8.2V21.44C8.2 21.54 8.28 21.62 8.38 21.62H16.38C16.48 21.62 16.56 21.54 16.56 21.44V20.89ZM42.41 36.78H6.25C5.59 36.78 5.06 37.31 5.06 37.97V43H42.41V36.78ZM33.43 33.18C33.8 33.55 34.29 33.74 34.8 33.74C34.92 33.74 35.05 33.73 35.17 33.71C35.93 33.56 36.55 32.95 36.69 32.19C36.81 31.56 36.61 30.91 36.16 30.45C35.71 30 35.06 29.8 34.42 29.92C33.66 30.07 33.04 30.68 32.9 31.44C32.78 32.07 32.98 32.72 33.43 33.18ZM42.09 30.45C41.64 30 40.99 29.79 40.35 29.92C39.59 30.07 38.98 30.68 38.83 31.44C38.71 32.07 38.91 32.72 39.36 33.18C39.73 33.55 40.22 33.75 40.73 33.75C40.85 33.75 40.98 33.74 41.1 33.72C41.86 33.57 42.48 32.96 42.62 32.2C42.74 31.57 42.54 30.92 42.09 30.46V30.45ZM43.39 17.62C43.39 16.22 42.25 15.08 40.85 15.08H34.68C33.28 15.08 32.14 16.22 32.14 17.62V25.37C32.14 26.77 33.28 27.91 34.68 27.91H40.85C42.25 27.91 43.39 26.77 43.39 25.37V17.62Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function MacrameTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4035"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D09129" />
      </mask>
      <g mask="url(#mask0_5063_4035)">
        <path
          d="M44.15 3C43.27 3 42.49 3.45 42.03 4.12H5.7C5.24 3.44 4.46 3 3.58 3C2.15 3 1 4.15 1 5.57C1 6.99 2.15 8.14 3.57 8.14C4.45 8.14 5.23 7.69 5.69 7.02H7.86V15.14H7.81L7.86 15.36V29.38C6.66 29.93 5.81 31.14 5.81 32.55C5.81 34.48 7.37 36.04 9.3 36.04C11.23 36.04 12.79 34.48 12.79 32.55C12.79 31.14 11.95 29.93 10.74 29.38V25.9L15.12 26.99V34.39C13.92 34.94 13.07 36.15 13.07 37.56C13.07 39.49 14.63 41.05 16.56 41.05C18.49 41.05 20.05 39.49 20.05 37.56C20.05 36.15 19.21 34.94 18 34.39V27.71L22.38 28.8V39.33C21.18 39.88 20.33 41.09 20.33 42.5C20.33 44.43 21.89 45.99 23.82 45.99C25.75 45.99 27.31 44.43 27.31 42.5C27.31 41.09 26.47 39.88 25.26 39.33V28.73L29.64 27.64V34.4C28.44 34.95 27.59 36.16 27.59 37.57C27.59 39.5 29.15 41.06 31.08 41.06C33.01 41.06 34.57 39.5 34.57 37.57C34.57 36.16 33.73 34.95 32.52 34.4V26.92L36.9 25.83V29.39C35.7 29.94 34.85 31.15 34.85 32.56C34.85 34.49 36.41 36.05 38.34 36.05C40.27 36.05 41.83 34.49 41.83 32.56C41.83 31.15 40.99 29.94 39.78 29.39V7.02H41.95C42.41 7.7 43.19 8.14 44.07 8.14C45.49 8.14 46.64 6.99 46.64 5.57C46.64 4.15 45.49 3 44.07 3H44.15ZM22.41 11.5L18.03 12.59V7.02H22.41V11.5ZM25.31 7.02H29.69V12.74L25.31 11.65V7.03V7.02ZM10.76 7.02H15.14V13.32L10.76 14.41V7.02ZM10.76 22.91V17.4L15.14 16.31V24.01L10.76 22.92V22.91ZM18.04 24.73V15.58L22.42 14.49V25.83L18.04 24.74V24.73ZM25.31 25.75V14.63L29.69 15.72V24.65L25.31 25.74V25.75ZM32.58 23.93V16.45L36.96 17.54V22.84L32.58 23.93ZM36.96 14.55L32.58 13.46V7.02H36.96V14.55Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function MetalCraftsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4260"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4260)">
        <path
          d="M42.64 40.1C41.85 39.32 40.18 37.58 38.49 35.81C39.05 34.21 39.37 32.5 39.37 30.72V14.42C39.37 10.33 36.38 6.92999 32.48 6.26999C31.75 2.71999 27.9 -0.0100098 23.26 -0.0100098C18.62 -0.0100098 14.76 2.70999 14.04 6.26999C10.13 6.92999 7.14997 10.33 7.14997 14.42V30.71C7.14997 32.62 7.50997 34.45 8.14997 36.14C6.62997 38.67 4.81997 41.76 4.78997 41.8C4.68997 41.98 4.59997 42.16 4.47997 42.42L4.31997 42.76C3.73997 43.95 4.00997 45.39 4.98997 46.28C5.55997 46.8 6.27997 47.07 7.01997 47.07C7.54997 47.07 8.07997 46.93 8.55997 46.64L13.87 43.46C16.37 45.19 19.41 46.22 22.68 46.22H23.87C26.67 46.22 29.28 45.47 31.55 44.17C32.95 45.62 34.23 46.95 34.85 47.58C35.43 48.18 36.21 48.49 37 48.49C37.63 48.49 38.27 48.29 38.81 47.88C39.15 47.62 39.78 47.05 41.74 45.22C42.13 44.85 42.45 44.56 42.56 44.46C43.18 43.91 43.53 43.13 43.55 42.3C43.57 41.47 43.25 40.68 42.66 40.09L42.64 40.1ZM23.25 2.99999C26.04 2.99999 28.48 4.34999 29.31 6.14999H17.2C18.03 4.34999 20.47 2.99999 23.26 2.99999H23.25ZM12.87 16.43C12.87 15.12 13.94 14.06 15.24 14.06H31.25C32.56 14.06 33.62 15.13 33.62 16.43V23.55C33.62 24.86 32.55 25.92 31.25 25.92H15.25C13.94 25.92 12.88 24.85 12.88 23.55V16.43H12.87ZM16.05 38.76L7.92997 43.62C7.86997 43.65 7.80997 43.67 7.74997 43.67C7.65997 43.67 7.57997 43.64 7.50997 43.58C7.38997 43.47 7.35997 43.3 7.42997 43.16L7.58997 42.83C7.66997 42.66 7.72997 42.54 7.78997 42.42C8.02997 41.99 12.02 35.25 12.33 34.88C13.05 34.01 13.99 33.7 15.05 33.96C16.16 34.24 16.86 34.97 17.08 36.08C17.3 37.17 16.94 38.09 16.05 38.75V38.76ZM40.82 42.56C40.7 42.67 40.37 42.98 39.96 43.36C38.7 44.54 37.54 45.62 37.24 45.85C37.16 45.91 37.07 45.94 36.98 45.94C36.87 45.94 36.75 45.9 36.67 45.81C34.89 43.98 27.66 36.48 27.66 36.48C27.5 36.26 26.54 34.82 26.75 33.69C26.78 33.54 26.67 33.21 26.5 33.04L25.78 32.31C25.4666 31.99 25.2933 31.8133 25.26 31.78C25.2 31.72 25.06 31.59 24 30.54C23.63 30.17 23.36 30 23.16 30C22.96 30 22.68 30.18 22.31 30.57C21.33 31.58 19.45 33.61 19.45 33.61C19.37 33.69 19.26 33.75 19.14 33.75C19.02 33.75 18.91 33.71 18.82 33.63L17.44 32.34C17.35 32.26 17.3 32.14 17.3 32.02C17.3 31.9 17.35 31.78 17.43 31.7C17.43 31.7 19.45 29.75 20.43 28.81C22.63 26.69 23.66 26.7 25.91 28.83L26.84 29.71C27.11 29.96 27.11 29.96 27.15 30.06C27.15 30.02 27.26 30.16 28.14 31.06C28.47 31.39 28.71 31.48 29.3 31.48H29.31C30.14 31.48 31.53 32.27 31.69 32.36C31.73 32.38 31.76 32.41 31.79 32.44C31.86 32.52 38.9 40 40.85 41.92C40.94 42 40.98 42.12 40.98 42.24C40.98 42.36 40.92 42.47 40.84 42.55L40.82 42.56Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function MixedMediaTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4041"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4041)">
        <path
          d="M32.4297 35.09C33.2097 35.35 33.9997 35.56 34.7897 35.79C36.3697 36.24 36.9797 35.91 37.4397 34.33C39.1897 28.29 43.1197 14.71 43.1797 14.5C41.1897 13.92 39.2397 13.35 37.2697 12.78C37.2697 12.78 36.9497 13.83 36.9397 13.85C35.8997 17.4 34.8697 20.96 33.8397 24.51V4.68996C33.8397 4.06996 33.6097 3.51996 33.1397 3.04996C32.6697 2.57996 32.1197 2.34996 31.4997 2.34996H8.05967C7.43967 2.34996 6.88967 2.57996 6.41967 3.04996C5.94967 3.51996 5.71967 4.06996 5.71967 4.68996V21.42C5.52967 21.48 5.33967 21.55 5.14967 21.6C4.80967 21.7 4.49967 21.65 4.20967 21.44C3.95967 21.26 3.82967 21.01 3.82967 20.71C3.82967 20.41 3.82967 20.08 3.83967 19.72C3.83967 18.95 3.73967 18.19 3.50967 17.44C3.27967 16.69 2.83967 16.1 2.19967 15.65C1.87967 15.44 1.51967 15.37 1.12967 15.43C0.739671 15.49 0.439671 15.68 0.239671 16C0.0296714 16.32 -0.0403286 16.68 0.0196714 17.07C0.0796714 17.46 0.269671 17.76 0.589671 17.96C0.879671 18.17 1.01967 18.42 1.01967 18.71C1.01967 19 1.01967 19.32 0.999671 19.67C0.999671 20.44 1.09967 21.2 1.30967 21.95C1.51967 22.7 1.94967 23.3 2.59967 23.74C3.24967 24.18 3.94967 24.39 4.71967 24.37C5.04967 24.36 5.37967 24.32 5.70967 24.27V28.12C5.70967 28.74 5.93967 29.29 6.40967 29.76C6.87967 30.23 7.42967 30.46 8.04967 30.46H17.6397C17.6397 30.74 17.6397 31.04 17.6297 31.37C17.6297 32.14 17.7297 32.9 17.9597 33.65C18.1897 34.4 18.6097 35 19.2297 35.44C19.8797 35.88 20.5897 36.08 21.3697 36.04C22.1497 36 22.8997 35.85 23.6297 35.61C23.9597 35.49 24.2997 35.38 24.6397 35.28C24.9797 35.18 25.2897 35.23 25.5797 35.44C25.8297 35.62 25.9597 35.87 25.9597 36.17C25.9597 36.47 25.9597 36.8 25.9497 37.16C25.9497 37.93 26.0497 38.69 26.2797 39.44C26.5097 40.19 26.9297 40.79 27.5497 41.23C28.1997 41.67 28.9097 41.87 29.6897 41.83C30.4697 41.79 31.2197 41.64 31.9497 41.4C32.2797 41.28 32.6197 41.18 32.9597 41.1C33.2997 41.02 33.6097 41.08 33.8997 41.29C34.1497 41.47 34.2797 41.71 34.2797 42C34.2797 42.29 34.2797 42.61 34.2597 42.96C34.2597 43.73 34.3597 44.49 34.5897 45.24C34.8197 45.99 35.2397 46.59 35.8597 47.03C36.1797 47.24 36.5397 47.31 36.9297 47.25C37.3197 47.19 37.6197 47 37.8197 46.68C37.9497 46.5 38.0397 46.33 38.0697 46.16C38.1097 45.99 38.1097 45.82 38.0797 45.63C38.0497 45.44 37.9897 45.27 37.8997 45.11C37.8097 44.95 37.6797 44.8 37.4897 44.67C37.2397 44.49 37.0997 44.25 37.0897 43.96C37.0797 43.67 37.0697 43.35 37.0897 43C37.0897 42.23 36.9897 41.47 36.7597 40.72C36.5297 39.97 36.1097 39.37 35.4897 38.93C34.8397 38.49 34.1397 38.28 33.3697 38.3C32.6097 38.32 31.8397 38.46 31.0797 38.71C30.7497 38.83 30.4197 38.93 30.0997 39.03C29.7797 39.13 29.4697 39.07 29.1897 38.86C28.9397 38.68 28.7997 38.44 28.7897 38.15C28.7797 37.86 28.7697 37.54 28.7897 37.19C28.7897 36.42 28.6897 35.65 28.4797 34.89C28.2697 34.13 27.8297 33.52 27.1897 33.08C26.5497 32.64 25.8297 32.44 25.0497 32.48C24.2697 32.52 23.5197 32.67 22.7897 32.91C22.4597 33.03 22.1297 33.13 21.7997 33.21C21.4797 33.29 21.1697 33.23 20.8797 33.02C20.6297 32.84 20.4897 32.6 20.4797 32.31C20.4697 32.02 20.4597 31.7 20.4797 31.35C20.4797 31.05 20.4497 30.75 20.4197 30.46H31.5097C31.7297 30.46 31.9397 30.42 32.1497 30.36C31.8897 31.27 31.6197 32.18 31.3497 33.1C31.0797 34.04 31.5197 34.78 32.4497 35.08L32.4297 35.09ZM30.8797 27.51H8.67967V5.29996H30.8797V27.5V27.51ZM46.2897 5.12996C46.9797 6.49996 47.0297 7.89996 46.3897 9.29996C45.5697 11.12 43.8397 12.18 41.8597 12.1C39.8897 12.02 38.1697 10.76 37.5097 8.88996C36.0897 4.88996 38.3297 1.00996 42.5497 0.169959C44.1897 -0.150041 45.7897 -0.040041 47.4297 0.669959C47.1597 0.919959 46.9497 1.07996 46.7697 1.26996C45.7197 2.43996 45.5797 3.71996 46.2797 5.11996L46.2897 5.12996ZM9.85967 24.42C9.73967 24.19 9.76967 23.95 9.94967 23.72L13.7097 18.83C13.8597 18.66 14.0297 18.57 14.2297 18.57C14.4297 18.57 14.6097 18.66 14.7497 18.83L18.2897 23.68L23.5297 16.91C23.6797 16.74 23.8497 16.65 24.0497 16.65C24.2497 16.65 24.4297 16.74 24.5697 16.91L29.6797 23.72C29.8297 23.95 29.8397 24.19 29.7197 24.42C29.5997 24.65 29.4097 24.77 29.1497 24.77H10.4297C10.1697 24.77 9.97967 24.65 9.85967 24.42ZM12.9997 13.55C12.5197 13.07 12.2697 12.47 12.2697 11.77C12.2697 11.07 12.5097 10.48 12.9997 9.98996C13.4797 9.50996 14.0797 9.25996 14.7797 9.25996C15.4797 9.25996 16.0697 9.49996 16.5597 9.98996C17.0397 10.47 17.2897 11.07 17.2897 11.77C17.2897 12.47 17.0497 13.06 16.5597 13.55C16.0697 14.04 15.4797 14.28 14.7797 14.28C14.0797 14.28 13.4897 14.04 12.9997 13.55ZM16.2097 35.93C17.3097 37.03 17.8597 38.37 17.8597 39.96C17.8597 41.55 17.3097 42.9 16.2097 43.99C15.1097 45.08 13.7697 45.64 12.1797 45.64C10.5897 45.64 9.23967 45.09 8.14967 43.99C7.05967 42.89 6.49967 41.55 6.49967 39.96C6.49967 38.37 7.04967 37.02 8.14967 35.93C9.24967 34.83 10.5897 34.28 12.1797 34.28C13.7697 34.28 15.1197 34.83 16.2097 35.93Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ModelBuildingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3835"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3835)">
        <path
          d="M14.45 27.95V44.66C14.45 45.22 14 45.67 13.44 45.67H2.01C1.45 45.67 1 45.22 1 44.66V27.95C1 27.39 1.45 26.94 2.01 26.94H13.43C13.99 26.94 14.44 27.39 14.44 27.95H14.45ZM46.83 27.56V44.17C46.83 45 46.16 45.67 45.33 45.67H18.55C17.72 45.67 17.05 45 17.05 44.17V27.56C17.05 27.17 17.2 26.79 17.48 26.51L30.87 12.83C31.15 12.54 31.54 12.38 31.94 12.38C32.34 12.38 32.73 12.54 33.01 12.83L46.4 26.51C46.67 26.79 46.83 27.17 46.83 27.56ZM43.83 28.17L31.94 16.02L20.05 28.17V42.67H26V32.29C26 30.56 27.41 29.16 29.13 29.16H34.74C36.47 29.16 37.87 30.57 37.87 32.29V42.67H43.82V28.17H43.83ZM26.47 4.08004C26.3 3.73004 25.95 3.50004 25.56 3.50004H14.14C13.84 3.50004 13.56 3.63004 13.37 3.86004L1.91 17.56C1.66 17.86 1.61 18.27 1.77 18.62C1.94 18.97 2.29 19.2 2.68 19.2H14.1C14.4 19.2 14.68 19.07 14.87 18.84L26.33 5.14004C26.58 4.84004 26.63 4.43004 26.47 4.08004ZM45.08 19.28C45.67 18.7 45.68 17.75 45.1 17.16L31.63 3.45004C31.05 2.86004 30.1 2.85004 29.51 3.43004C28.92 4.01004 28.91 4.96004 29.49 5.55004L42.96 19.26C43.25 19.56 43.64 19.71 44.03 19.71C44.42 19.71 44.79 19.57 45.08 19.28Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function MosaicTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3865"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3865)">
        <path
          d="M29.15 26.11L16.46 28.81L24.89 17.91L29.16 26.11H29.15ZM25.34 42.14L29.43 29.12L16.76 31.82L22.3 42.15H25.34V42.14ZM21.13 17.86L6 21.38V23.95L13.43 27.83L21.13 17.86ZM42.05 29.73V12.99L27.47 16.38L32.37 25.79L42.05 29.72V29.73ZM12.88 30.93L6 27.34V39.14C6 39.94 6.3 40.64 6.9 41.24C7.5 41.84 8.2 42.14 9 42.14H18.9L12.89 30.93H12.88ZM26.04 13.64L42.05 9.92V8.01C42.05 7.21 41.75 6.51 41.15 5.91C40.55 5.31 39.85 5.01 39.05 5.01H21.55L26.04 13.65V13.64ZM32.58 29.12L28.49 42.14H39.06C39.86 42.14 40.56 41.84 41.16 41.24C41.76 40.64 42.06 39.94 42.06 39.14V32.97L32.59 29.12H32.58ZM23.02 14.34L18.16 5H9C8.2 5 7.5 5.3 6.9 5.9C6.3 6.5 6 7.2 6 8V18.3L23.02 14.34Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function NeedleFeltingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4414"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4414)">
        <path
          d="M36.89 22.8899C38.35 22.4299 39.69 21.6199 40.81 20.5099C44.58 16.7399 44.58 10.5999 40.81 6.82994C37.04 3.05994 30.9 3.05994 27.13 6.82994C25.47 8.48994 24.54 10.6099 24.34 12.7899C22.4 9.64994 18.94 7.53994 14.99 7.53994C8.93 7.53994 4 12.4699 4 18.5199C4 24.5699 8.93 29.5099 14.99 29.5099C16.74 29.5099 18.4 29.0899 19.87 28.3499C19.37 29.6399 19.09 31.0299 19.09 32.4899C19.09 38.8299 24.25 43.9899 30.59 43.9899C36.93 43.9899 42.09 38.8299 42.09 32.4899C42.09 28.4799 40.02 24.9499 36.9 22.8899H36.89ZM29.25 8.94994C30.55 7.64994 32.26 6.99994 33.97 6.99994C35 6.99994 36.03 7.23994 36.98 7.71994C37 7.74994 37.01 7.77994 37.04 7.80994C37.44 8.20994 38.1 10.0199 37.94 12.0599C37.85 13.1799 37.48 14.6999 36.23 15.5999C34.45 16.8899 32.91 16.8499 31.52 15.4999C31 14.9899 30.68 14.2499 30.68 13.5199C30.68 13.0699 30.8 12.4199 31.37 11.8399C32.35 10.8599 33.3 10.7599 34.1 11.5699C34.3 11.7699 34.4 12.0699 34.37 12.3899C34.35 12.5899 34.26 12.9699 33.88 13.2299C33.2 13.6999 33.03 14.6399 33.5 15.3199C33.97 15.9999 34.91 16.1699 35.59 15.6999C36.6 14.9999 37.25 13.8899 37.36 12.6599C37.47 11.4499 37.05 10.2799 36.22 9.44994C34.55 7.77994 31.75 7.21994 29.24 9.71994C28.22 10.7399 27.66 12.0999 27.67 13.5299C27.67 15.0599 28.31 16.5599 29.41 17.6399C30.15 18.3599 31.68 19.5599 33.79 19.5599C35.01 19.5599 36.42 19.1599 37.97 18.0399C39.24 17.1199 40.15 15.7499 40.6 14.0799C40.51 15.6599 39.87 17.1999 38.67 18.3999C37.41 19.6599 35.73 20.3599 33.95 20.3599C32.17 20.3599 30.49 19.6699 29.23 18.3999C26.63 15.7999 26.63 11.5599 29.23 8.95994L29.25 8.94994ZM28.02 21.2899C27.06 21.5099 26.15 21.8499 25.29 22.2899C25.66 21.2799 25.89 20.1999 25.94 19.0699C26.28 19.5799 26.67 20.0599 27.12 20.5099C27.4 20.7899 27.7 21.0499 28.01 21.2899H28.02ZM7.4 20.9999C7.4 20.9399 7.42 20.8799 7.42 20.8199C7.42 20.0999 8.37 18.0199 10.25 16.4099C11.28 15.5299 12.89 14.5499 14.75 14.8499C17.4 15.2799 18.71 16.6499 18.73 19.0299C18.73 19.9399 18.36 20.8699 17.72 21.5199C17.32 21.9199 16.63 22.3999 15.6 22.3999C13.86 22.3999 12.9 21.5999 12.9 20.1399C12.9 19.7399 13.09 19.3399 13.43 19.0599C13.79 18.7599 14.26 18.6399 14.72 18.7199C15.54 18.8699 16.32 18.3299 16.46 17.5099C16.6 16.6899 16.07 15.9099 15.25 15.7699C13.92 15.5299 12.55 15.8899 11.5 16.7599C10.48 17.6099 9.89 18.8499 9.89 20.1399C9.89 22.7599 11.65 25.3999 15.59 25.3999C17.2 25.3999 18.71 24.7699 19.84 23.6299C21.05 22.4099 21.73 20.7199 21.71 18.9999C21.69 17.1699 21.02 12.8299 15.21 11.8899C12.87 11.5099 10.49 12.2699 8.33 14.0899C9.76 11.9499 12.2 10.5399 14.97 10.5399C19.37 10.5399 22.96 14.1199 22.96 18.5299C22.96 22.9399 19.38 26.5199 14.97 26.5199C11.43 26.5199 8.43 24.1999 7.38 21.0099L7.4 20.9999ZM33.2 40.5799C33.13 40.5799 33.07 40.5599 33 40.5599C32.23 40.5599 30 39.5499 28.29 37.5499C27.35 36.4499 26.31 34.7199 26.63 32.7399C27.08 29.9399 28.59 28.4999 31.12 28.4799H31.15C32.12 28.4799 33.11 28.8799 33.79 29.5599C34.22 29.9899 34.74 30.7299 34.74 31.8499C34.74 33.7399 33.86 34.7799 32.28 34.7799C31.83 34.7799 31.39 34.5599 31.08 34.1899C30.75 33.7899 30.61 33.2699 30.7 32.7699C30.85 31.9499 30.31 31.1699 29.49 31.0299C28.68 30.8799 27.89 31.4199 27.75 32.2399C27.5 33.6199 27.87 35.0399 28.78 36.1199C29.66 37.1799 30.94 37.7899 32.28 37.7899C35 37.7899 37.74 35.9599 37.74 31.8599C37.74 30.1799 37.09 28.6099 35.9 27.4399C34.63 26.1799 32.87 25.5099 31.08 25.4899C29.18 25.5099 24.64 26.2099 23.66 32.2699C23.26 34.7299 24.07 37.2399 26 39.4999C26.11 39.6299 26.23 39.7499 26.34 39.8699C23.79 38.3999 22.07 35.6499 22.07 32.5099C22.07 27.8199 25.88 24.0099 30.57 24.0099C35.26 24.0099 39.07 27.8199 39.07 32.5099C39.07 36.2799 36.6 39.4799 33.19 40.5899L33.2 40.5799Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function NeedlepointTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3990"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3990)">
        <path
          d="M29.34 8.66V6.21H32.85C33.65 6.21 34.31 5.56 34.31 4.75C34.31 3.94 33.66 3.29 32.85 3.29H29.34V2.35C29.34 1.6 28.74 1 27.99 1C27.24 1 26.64 1.6 26.64 2.35V3.29H20.01V2.35C20.01 1.6 19.41 1 18.66 1C17.91 1 17.31 1.6 17.31 2.35V3.29H13.8C13 3.29 12.34 3.94 12.34 4.75C12.34 5.56 12.99 6.21 13.8 6.21H17.31V8.66C9.59 11.19 4 18.45 4 27.02C4 37.69 12.65 46.35 23.33 46.35C34.01 46.35 42.66 37.7 42.66 27.02C42.66 18.45 37.07 11.19 29.34 8.66ZM23.33 41.65C15.26 41.65 8.7 35.09 8.7 27.02C8.7 18.95 15.26 12.39 23.33 12.39C31.4 12.39 37.96 18.95 37.96 27.02C37.96 35.09 31.4 41.65 23.33 41.65ZM20.01 6.21H26.64V8C25.56 7.81 24.46 7.7 23.33 7.7C22.2 7.7 21.09 7.82 20.02 8V6.21H20.01ZM22.18 23.58C22.63 24.04 22.63 24.89 22.18 25.35C21.9 25.63 21.6 25.77 21.3 25.77C21 25.77 20.69 25.63 20.42 25.35L18.62 23.55L16.82 25.35C16.26 25.91 15.61 25.91 15.05 25.35C14.6 24.89 14.6 24.04 15.05 23.58L16.85 21.78L15.05 19.98C14.6 19.52 14.6 18.67 15.05 18.21C15.5 17.76 16.36 17.76 16.82 18.21L18.62 20.01L20.42 18.21C20.88 17.76 21.73 17.76 22.19 18.21C22.63 18.65 22.65 19.38 22.22 19.94L22.19 19.98L20.39 21.78L22.19 23.58H22.18ZM22.18 30.38L20.38 32.18L22.18 33.98C22.63 34.44 22.63 35.29 22.18 35.75C21.9 36.03 21.6 36.17 21.3 36.17C21 36.17 20.69 36.03 20.42 35.75L18.62 33.95L16.82 35.75C16.26 36.31 15.61 36.31 15.05 35.75C14.59 35.29 14.59 34.44 15.05 33.98L16.85 32.18L15.05 30.38C14.6 29.92 14.6 29.06 15.05 28.61C15.5 28.16 16.36 28.16 16.82 28.61L18.62 30.41L20.42 28.61C20.88 28.16 21.73 28.16 22.19 28.61C22.64 29.07 22.64 29.93 22.19 30.38H22.18ZM32.56 30.4L30.78 32.18L32.58 33.98C33.03 34.44 33.03 35.29 32.58 35.75C32.3 36.03 32 36.17 31.7 36.17C31.4 36.17 31.09 36.03 30.82 35.75L29.02 33.95L27.22 35.75C26.66 36.31 26.01 36.31 25.45 35.75C25 35.29 25 34.44 25.45 33.98L27.25 32.18L25.45 30.38C25 29.92 25 29.06 25.45 28.61C25.91 28.16 26.76 28.16 27.22 28.61L29.02 30.41L30.82 28.61C31.27 28.16 32.13 28.16 32.59 28.61C32.85 28.87 33 29.26 32.97 29.63C32.95 29.94 32.81 30.21 32.57 30.4H32.56Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function NeedleworkTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4048"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4048)">
        <path
          d="M40.8999 14.3899C41.3899 13.5399 41.6499 12.5699 41.6499 11.5699C41.6499 10.0699 41.0499 8.65991 39.9699 7.60991C37.7399 5.43991 34.1099 5.46991 31.8699 7.67991C31.5799 7.96991 30.8499 8.83991 29.5899 10.3899C28.3099 10.9999 21.9399 13.7499 17.5399 10.3899C16.9499 9.93991 16.0999 10.0499 15.6399 10.6399C15.1899 11.2299 15.2999 12.0799 15.8899 12.5399C17.7899 13.9899 20.1399 14.7299 22.7999 14.7299C23.8099 14.7299 24.8699 14.6199 25.9599 14.4099C26.1099 14.3799 26.2599 14.3499 26.4099 14.3099C26.0999 14.6999 25.7799 15.0999 25.4399 15.5199C19.9799 22.3299 11.7199 32.5999 5.47994 39.7999C4.80994 40.5699 4.84994 41.6999 5.55994 42.4199C5.93994 42.8099 6.43994 42.9999 6.93994 42.9999C7.38994 42.9999 7.83994 42.8399 8.20994 42.5299C12.0699 39.2599 16.6899 35.3599 21.1599 31.5999C29.3399 24.6999 36.5699 18.6099 39.0799 16.4099C40.0099 17.3699 40.6799 18.5899 40.4999 20.0699C40.2499 22.1499 39.2199 22.7099 37.7899 23.4799C36.2999 24.2899 34.4499 25.2899 33.9399 28.1599C32.7999 34.5799 37.3699 38.9999 37.5699 39.1899C37.8299 39.4399 38.1599 39.5599 38.4999 39.5599C38.8599 39.5599 39.2099 39.4199 39.4799 39.1399C39.9899 38.5999 39.9699 37.7499 39.4399 37.2299C39.2899 37.0799 35.7299 33.5999 36.6099 28.6399C36.8899 27.0599 37.7699 26.5799 39.0899 25.8699C40.6399 25.0299 42.7699 23.8799 43.1899 20.4099C43.4599 18.1999 42.6699 16.1499 40.8999 14.3999V14.3899ZM19.4099 29.5299C17.4299 31.1999 15.4299 32.8899 13.4699 34.5399C18.4299 28.5699 23.6799 22.0299 27.5399 17.2299C29.0199 15.3899 30.3999 13.6699 31.4899 12.3299C32.6799 10.8599 33.5199 9.83991 33.7599 9.60991C34.3699 9.00991 35.1699 8.69991 35.9699 8.69991C36.7699 8.69991 37.4999 8.97991 38.0699 9.53991C38.6199 10.0799 38.9299 10.7999 38.9299 11.5699C38.9299 11.9599 38.8499 12.3399 38.7099 12.6899C38.1199 12.3199 37.5499 12.0299 37.0599 11.7999C36.9699 11.5599 36.8199 11.3299 36.6199 11.1299C35.8699 10.3999 34.6599 10.4199 33.9099 11.1599C33.1599 11.8999 33.1499 13.0999 33.8999 13.8199C34.4399 14.3499 35.2199 14.4799 35.8999 14.2399C36.1899 14.3699 36.5099 14.5399 36.8599 14.7299C33.9899 17.2099 26.5999 23.4499 19.4099 29.5099V29.5299Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function OrganizingAndPlanningTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="img"
    >
      <mask
        id="mask0_5063_3817"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3817)">
        <path
          d="M7 44C6.2 44 5.5 43.7 4.9 43.1C4.3 42.5 4 41.8 4 41V10C4 9.2 4.3 8.5 4.9 7.9C5.5 7.3 6.2 7 7 7H10.25V5.6C10.25 5.15 10.4 4.77 10.71 4.46C11.02 4.15 11.4 4 11.85 4C12.3 4 12.71 4.15 13.03 4.46C13.35 4.77 13.5 5.15 13.5 5.6V7H30.5V5.6C30.5 5.15 30.65 4.77 30.96 4.46C31.27 4.15 31.65 4 32.1 4C32.55 4 32.96 4.15 33.28 4.46C33.6 4.77 33.75 5.15 33.75 5.6V7H37C37.8 7 38.5 7.3 39.1 7.9C39.7 8.5 40 9.2 40 10V19.55C40 19.97 39.85 20.33 39.57 20.62C39.28 20.91 38.92 21.05 38.5 21.05C38.08 21.05 37.72 20.9 37.43 20.61C37.15 20.32 37 19.96 37 19.53V19.49H7V40.99H21.5C21.93 40.99 22.28 41.13 22.57 41.42C22.86 41.71 23 42.07 23 42.5C23 42.93 22.86 43.28 22.57 43.57C22.28 43.85 21.93 44 21.5 44H7ZM26 42.5V38.45C26 38.26 26.03 38.09 26.1 37.91C26.17 37.74 26.28 37.57 26.45 37.4L37.03 26.86C37.33 26.56 37.67 26.34 38.04 26.2C38.41 26.06 38.78 26 39.15 26C39.55 26 39.93 26.07 40.3 26.22C40.67 26.37 41 26.6 41.3 26.9L43.15 28.75C43.45 29.05 43.67 29.38 43.8 29.75C43.93 30.12 44 30.48 44 30.85C44 31.22 43.93 31.59 43.77 31.97C43.62 32.35 43.39 32.7 43.09 33L32.59 43.54C32.42 43.71 32.25 43.82 32.08 43.89C31.91 43.96 31.73 43.99 31.54 43.99H27.49C27.06 43.99 26.71 43.85 26.42 43.56C26.13 43.27 25.99 42.92 25.99 42.49L26 42.5ZM39.15 32.8L41 30.85L39.15 29L37.25 30.9L39.15 32.8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function OrigamiTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4139"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4139)">
        <path
          d="M46.57 15.79L39.02 10.78C38.8 10.64 38.56 10.54 38.3 10.51C38.16 10.47 37.99 10.45 37.79 10.45H37.43C37.07 10.45 36.72 10.57 36.44 10.78C36.28 10.89 36.14 11.02 36.02 11.17H36.01C36.01 11.17 35.96 11.24 35.93 11.27L31.6 16.15C31.42 16.31 31.28 16.5 31.17 16.71L28.76 21.57L22.95 6.51C22.59 5.6 21.7 5 20.73 5C19.68 5 18.8 5.63 18.5 6.53L12.65 21.78L4.47998 6.33C3.90998 5.2 2.48998 4.72 1.36998 5.28C0.299983 5.81 -0.240017 7.03 0.099983 8.06L9.69998 41.39C9.71998 41.55 9.76998 41.75 9.87998 41.95C9.97998 42.18 10.14 42.4 10.35 42.61C10.47 42.73 10.58 42.82 10.68 42.88C10.78 42.96 10.88 43.03 11 43.09C11.46 43.32 11.83 43.32 12.01 43.32H29.43C29.59 43.32 29.89 43.32 30.27 43.17C30.52 43.08 30.74 42.94 30.92 42.75C31 42.68 31.08 42.62 31.13 42.57C31.22 42.48 31.33 42.34 31.41 42.21C31.45 42.16 31.48 42.11 31.51 42.05C31.65 41.83 31.72 41.6 31.75 41.41L38.04 20.14H45.3C46.31 20.14 47.22 19.47 47.52 18.57C47.91 17.58 47.49 16.37 46.56 15.78L46.57 15.79ZM14.74 29.6L20.73 14L26.72 29.6L20.73 37.08L14.74 29.6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function OtherTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3744"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3744)">
        <path
          d="M28.24 42C26.71 42 25.41 41.46 24.35 40.39C23.28 39.32 22.75 38.02 22.75 36.49C22.75 34.96 23.29 33.66 24.36 32.6C25.43 31.53 26.73 31 28.26 31C29.79 31 31.09 31.54 32.15 32.61C33.22 33.68 33.75 34.98 33.75 36.51C33.75 38.04 33.21 39.34 32.14 40.4C31.07 41.47 29.77 42 28.24 42ZM32.25 27.5C29.25 27.5 26.71 26.46 24.63 24.37C22.55 22.28 21.51 19.74 21.51 16.74C21.51 13.74 22.55 11.2 24.64 9.12C26.73 7.04 29.27 6 32.26 6C35.25 6 37.8 7.04 39.88 9.13C41.96 11.22 43 13.76 43 16.75C43 19.74 41.96 22.29 39.87 24.37C37.78 26.45 35.24 27.49 32.25 27.49V27.5ZM12.75 36.15C10.58 36.15 8.75 35.4 7.25 33.9C5.75 32.4 5 30.57 5 28.4C5 26.23 5.75 24.4 7.25 22.9C8.75 21.4 10.58 20.65 12.75 20.65C14.92 20.65 16.75 21.4 18.25 22.9C19.75 24.4 20.5 26.23 20.5 28.4C20.5 30.57 19.75 32.4 18.25 33.9C16.75 35.4 14.92 36.15 12.75 36.15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function PaintingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3853"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3853)">
        <path
          d="M21.85 43C21.05 43 20.35 42.71 19.75 42.12C19.15 41.53 18.85 40.83 18.85 40V30H11C10.2 30 9.5 29.7 8.9 29.1C8.3 28.5 8 27.8 8 27V11.85C8 10.02 8.66 8.42 9.98 7.05C11.3 5.68 12.89 5 14.75 5H38.5C38.93 5 39.28 5.14 39.57 5.43C39.86 5.72 40 6.07 40 6.5V27C40 27.8 39.7 28.5 39.1 29.1C38.5 29.7 37.8 30 37 30H29.15V40C29.15 40.82 28.85 41.53 28.25 42.12C27.65 42.71 26.95 43 26.15 43H21.85ZM11 19.3H37V8H34.2V15.05C34.2 15.47 34.05 15.83 33.77 16.12C33.48 16.41 33.12 16.55 32.69 16.55C32.26 16.55 31.91 16.41 31.62 16.12C31.34 15.83 31.19 15.48 31.19 15.05V8H27.64V10.75C27.64 11.18 27.5 11.53 27.21 11.82C26.92 12.11 26.56 12.25 26.14 12.25C25.72 12.25 25.36 12.11 25.07 11.82C24.79 11.53 24.64 11.18 24.64 10.75V8H14.75C13.68 8 12.79 8.38 12.07 9.15C11.35 9.92 11 10.82 11 11.85V19.3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function PaperCraftingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4133"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4133)">
        <path
          d="M46.36 14.8599L38.76 6.48991C38.26 5.93991 37.43 5.83991 36.81 6.24991L28.46 11.8499V9.39991C28.46 8.19991 27.49 7.22991 26.29 7.22991H23.18C21.98 7.22991 21.01 8.19991 21.01 9.39991V12.3499L11.94 6.24991C11.32 5.82991 10.49 5.93991 9.99001 6.48991L2.39001 14.8599C2.04001 15.2499 1.91001 15.7899 2.06001 16.2899L4.77001 25.5399C4.96001 26.1799 5.54001 26.6199 6.21001 26.6199H7.97001C7.97001 26.6199 7.92001 26.7099 7.90001 26.7599L5.72001 33.1199C5.64001 33.2599 5.57001 33.3999 5.54001 33.5599C5.45001 34.0099 5.56001 34.4799 5.86001 34.8299L12.24 42.4599C12.51 42.7899 12.91 42.9799 13.34 42.9999C13.36 42.9999 13.38 42.9999 13.39 42.9999C13.8 42.9999 14.18 42.8299 14.47 42.5399L21.29 35.4799L22.64 41.1599C22.87 42.1399 23.74 42.8299 24.75 42.8299C25.75 42.8299 26.63 42.1399 26.86 41.1599L28.06 36.0999L34.29 42.5399C34.57 42.8299 34.96 42.9999 35.37 42.9999C35.39 42.9999 35.41 42.9999 35.42 42.9999C35.84 42.9799 36.24 42.7899 36.52 42.4599L42.9 34.8299C43.19 34.4799 43.31 34.0099 43.22 33.5599C43.19 33.3999 43.12 33.2499 43.04 33.1199L40.86 26.7599C40.84 26.7099 40.81 26.6699 40.79 26.6199H42.55C43.22 26.6199 43.8 26.1799 43.99 25.5399L46.7 16.2899C46.85 15.7899 46.72 15.2499 46.37 14.8599H46.36ZM5.18001 16.2499L11.35 9.46991L19.74 15.0899V23.6199H7.34001L5.18001 16.2499ZM19.73 32.7799L13.47 39.2599L9.38001 34.3699L19.73 29.2399V32.7899V32.7799ZM35.28 39.2599L29.02 32.7799V29.2399L39.37 34.3699L35.28 39.2599ZM41.42 23.6199H29.02V15.0899L37.41 9.46991L43.58 16.2499L41.42 23.6199Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function PaperModellingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4066"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4066)">
        <path
          d="M46.7701 22.43C46.5701 22.34 46.3601 22.3 46.1601 22.3L32.0601 18.21L25.5901 6.75C25.3201 6.28 24.8501 6 24.3201 6C23.7901 6 23.3201 6.28 23.0501 6.75L16.6101 18.16L2.44007 22.3C2.25007 22.3 2.06007 22.35 1.88007 22.43C1.13007 22.77 0.790067 23.66 1.14007 24.42L8.23007 40L8.71007 41.05C8.95007 41.59 9.49007 41.93 10.0801 41.93H38.5901C39.1801 41.93 39.7101 41.59 39.9601 41.05L40.4201 40.05L47.5301 24.42C47.8701 23.67 47.5301 22.78 46.7901 22.43H46.7701ZM41.6701 23.97L36.1501 25.47L34.0501 21.74L41.6701 23.96V23.97ZM33.2301 26.27L25.0301 28.5L24.2501 28.71L23.9101 28.62L23.5301 28.51L15.9801 26.44L29.0301 18.8L33.2401 26.26L33.2301 26.27ZM24.3201 10.49L27.6101 16.32L17.7901 22.07L24.3201 10.49ZM14.6001 21.73L12.7401 25.03L12.4801 25.49L6.95007 23.97L14.6001 21.72V21.73ZM37.4101 39.36C37.4101 39.36 37.3701 39.41 37.3501 39.43H34.7101L24.2701 31.6L13.8301 39.43H11.2801C11.2801 39.43 11.2401 39.38 11.2201 39.36L10.6701 38.15L21.4801 30.04L22.6901 30.37L23.9601 30.72C24.1301 30.77 24.3201 30.77 24.4901 30.72L27.0401 30.03L37.9301 38.2L37.4001 39.36H37.4101Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function PapermakingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3889"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3889)">
        <path
          d="M11 44C10.2 44 9.5 43.7 8.9 43.1C8.3 42.5 8 41.8 8 41V7C8 6.2 8.3 5.5 8.9 4.9C9.5 4.3 10.2 4 11 4H27.8C28.2 4 28.59 4.08 28.98 4.25C29.36 4.42 29.69 4.63 29.95 4.9L39.1 14.05C39.37 14.32 39.58 14.64 39.75 15.02C39.92 15.4 40 15.8 40 16.19V40.99C40 41.79 39.7 42.49 39.1 43.09C38.5 43.69 37.8 43.99 37 43.99H11V44ZM27.55 14.8C27.55 15.23 27.69 15.59 27.98 15.87C28.26 16.15 28.62 16.3 29.05 16.3H37L27.55 7V14.8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function PartyDecorationsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3762"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3762)">
        <path
          d="M3.08996 41.55L10.54 20.75C10.67 20.42 10.86 20.17 11.11 20C11.36 19.83 11.64 19.75 11.93 19.75C12.1 19.75 12.27 19.78 12.46 19.85C12.64 19.92 12.82 20.03 12.98 20.2L26.48 33.5C26.65 33.67 26.76 33.84 26.83 34.03C26.9 34.21 26.93 34.41 26.93 34.61C26.93 34.91 26.85 35.18 26.68 35.43C26.51 35.68 26.26 35.87 25.93 36L5.02996 43.5C4.72996 43.6 4.43996 43.62 4.14996 43.55C3.86996 43.48 3.62996 43.35 3.41996 43.15C3.21996 42.95 3.08996 42.71 3.01996 42.43C2.94996 42.15 2.96996 41.86 3.06996 41.55H3.08996ZM44.29 14.25C44.06 14.48 43.77 14.6 43.44 14.6C43.11 14.6 42.82 14.48 42.59 14.25L42.49 14.15C41.86 13.52 41.12 13.19 40.29 13.18C39.46 13.17 38.71 13.49 38.04 14.15L26.74 25.45C26.51 25.68 26.22 25.8 25.89 25.8C25.56 25.8 25.27 25.68 25.04 25.45C24.81 25.22 24.69 24.93 24.69 24.6C24.69 24.27 24.81 23.98 25.04 23.75L36.19 12.6C37.26 11.53 38.61 10.99 40.24 10.98C41.87 10.97 43.22 11.49 44.29 12.55C44.52 12.78 44.64 13.07 44.64 13.4C44.64 13.73 44.52 14.02 44.29 14.25ZM17.19 8C17.42 7.77 17.71 7.65 18.04 7.65C18.37 7.65 18.66 7.77 18.89 8L19.34 8.45C20.51 9.62 21.08 11.07 21.06 12.83C21.04 14.58 20.45 16.04 19.29 17.21L18.79 17.71C18.56 17.94 18.27 18.06 17.94 18.06C17.61 18.06 17.32 17.94 17.09 17.71C16.86 17.48 16.74 17.19 16.74 16.86C16.74 16.53 16.86 16.24 17.09 16.01L17.74 15.36C18.51 14.59 18.86 13.72 18.81 12.74C18.76 11.76 18.4 10.93 17.74 10.27L17.19 9.72C16.96 9.49 16.84 9.2 16.84 8.87C16.84 8.54 16.96 8.25 17.19 8.02V8ZM25.64 4.35C25.87 4.12 26.16 4 26.49 4C26.82 4 27.11 4.12 27.34 4.35L29.64 6.65C30.67 7.72 31.21 9.06 31.24 10.68C31.27 12.3 30.76 13.64 29.69 14.71L22.84 21.56C22.61 21.79 22.32 21.91 21.99 21.91C21.66 21.91 21.37 21.79 21.14 21.56C20.91 21.33 20.79 21.04 20.79 20.71C20.79 20.38 20.91 20.09 21.14 19.86L27.89 13.11C28.52 12.48 28.83 11.67 28.81 10.68C28.79 9.7 28.47 8.89 27.84 8.26L25.64 6.06C25.41 5.83 25.29 5.54 25.29 5.21C25.29 4.88 25.41 4.59 25.64 4.36V4.35ZM40.64 29.6C40.41 29.83 40.12 29.95 39.79 29.95C39.46 29.95 39.17 29.83 38.94 29.6L37.19 27.85C36.42 27.08 35.62 26.7 34.79 26.7C33.96 26.7 33.16 27.08 32.39 27.85L30.74 29.5C30.51 29.73 30.22 29.85 29.89 29.85C29.56 29.85 29.27 29.73 29.04 29.5C28.81 29.27 28.69 28.98 28.69 28.65C28.69 28.32 28.81 28.03 29.04 27.8L30.54 26.3C31.71 25.13 33.11 24.53 34.74 24.5C36.37 24.47 37.77 25.03 38.94 26.2L40.64 27.9C40.87 28.13 40.99 28.42 40.99 28.75C40.99 29.08 40.87 29.37 40.64 29.6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function PatchworkTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4146"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4146)">
        <path
          d="M41.6 25.05C42.43 25.05 43.1 24.38 43.1 23.55C43.1 22.72 42.43 22.05 41.6 22.05H38.57V18.05H41.6C42.43 18.05 43.1 17.38 43.1 16.55C43.1 15.72 42.43 15.05 41.6 15.05H38.57V12.44C38.57 10.58 37.04 9.05 35.18 9.05H32.57V5.5C32.57 4.67 31.9 4 31.07 4C30.24 4 29.57 4.67 29.57 5.5V9.05H25.57V5.5C25.57 4.67 24.9 4 24.07 4C23.24 4 22.57 4.67 22.57 5.5V9.05H18.57V5.5C18.57 4.67 17.9 4 17.07 4C16.24 4 15.57 4.67 15.57 5.5V9.05H12.96C11.1 9.05 9.57 10.58 9.57 12.44V15.05H5.5C4.67 15.05 4 15.72 4 16.55C4 17.38 4.67 18.05 5.5 18.05H9.56V22.05H5.5C4.67 22.05 4 22.72 4 23.55C4 24.38 4.67 25.05 5.5 25.05H9.56V29.05H5.5C4.67 29.05 4 29.72 4 30.55C4 31.38 4.67 32.05 5.5 32.05H9.56V34.66C9.56 36.52 11.09 38.05 12.95 38.05H15.56V41.6C15.56 42.43 16.23 43.1 17.06 43.1C17.89 43.1 18.56 42.43 18.56 41.6V38.05H22.56V41.6C22.56 42.43 23.23 43.1 24.06 43.1C24.89 43.1 25.56 42.43 25.56 41.6V38.05H29.56V41.6C29.56 42.43 30.23 43.1 31.06 43.1C31.89 43.1 32.56 42.43 32.56 41.6V38.05H35.17C37.03 38.05 38.56 36.52 38.56 34.66V32.05H41.59C42.42 32.05 43.09 31.38 43.09 30.55C43.09 29.72 42.42 29.05 41.59 29.05H38.56V25.05H41.59H41.6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function PhotographyTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3907"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3907)">
        <path
          d="M24 34.65C26.4 34.65 28.42 33.83 30.05 32.2C31.68 30.57 32.5 28.55 32.5 26.15C32.5 23.75 31.68 21.69 30.05 20.07C28.42 18.45 26.4 17.65 24 17.65C21.6 17.65 19.54 18.46 17.93 20.07C16.31 21.69 15.5 23.71 15.5 26.15C15.5 28.59 16.31 30.57 17.93 32.2C19.55 33.83 21.57 34.65 24 34.65ZM24 31.65C22.4 31.65 21.08 31.12 20.05 30.07C19.02 29.02 18.5 27.71 18.5 26.15C18.5 24.59 19.02 23.23 20.05 22.2C21.08 21.17 22.4 20.65 24 20.65C25.6 20.65 26.88 21.17 27.93 22.2C28.98 23.23 29.5 24.55 29.5 26.15C29.5 27.75 28.98 29.03 27.93 30.07C26.88 31.12 25.57 31.65 24 31.65ZM7 42C6.2 42 5.5 41.7 4.9 41.1C4.3 40.5 4 39.8 4 39V13.35C4 12.58 4.3 11.89 4.9 11.28C5.5 10.66 6.2 10.35 7 10.35H14.35L17.1 7.05C17.37 6.68 17.7 6.42 18.1 6.25C18.5 6.08 18.93 6 19.4 6H28.6C29.07 6 29.5 6.08 29.9 6.25C30.3 6.42 30.63 6.68 30.9 7.05L33.65 10.35H41C41.77 10.35 42.46 10.66 43.07 11.28C43.68 11.9 44 12.59 44 13.35V39C44 39.8 43.69 40.5 43.07 41.1C42.45 41.7 41.76 42 41 42H7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function PngsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4158"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#996B07" />
      </mask>
      <g mask="url(#mask0_5063_4158)">
        <path
          d="M38.96 9C38.96 9 38.97 9.01 38.98 9.02L39 9.04V38.95C39 38.95 38.99 38.96 38.98 38.97L38.96 38.99H9.04C9.04 38.99 9.03 38.98 9.02 38.97L9 38.95V9.04C9 9.04 9.01 9.03 9.02 9.02L9.04 9H38.95M39 6H9C8.2 6 7.5 6.3 6.9 6.9C6.3 7.5 6 8.2 6 9V39C6 39.8 6.3 40.5 6.9 41.1C7.5 41.7 8.2 42 9 42H39C39.8 42 40.5 41.7 41.1 41.1C41.7 40.5 42 39.8 42 39V9C42 8.2 41.7 7.5 41.1 6.9C40.5 6.3 39.8 6 39 6ZM10.92 35.18H37.13C37.5 35.18 37.76 35.02 37.92 34.69C38.08 34.36 38.06 34.04 37.86 33.71L30.71 24.18C30.51 23.94 30.26 23.81 29.98 23.81C29.7 23.81 29.45 23.93 29.25 24.18L21.92 33.65L16.97 26.87C16.77 26.63 16.52 26.5 16.24 26.5C15.96 26.5 15.71 26.62 15.51 26.87L10.26 33.71C10.02 34.04 9.98 34.36 10.14 34.69C10.3 35.02 10.57 35.18 10.93 35.18H10.92ZM17 20.5C17.98 20.5 18.81 20.16 19.48 19.49C20.16 18.81 20.5 17.98 20.5 17C20.5 16.02 20.16 15.19 19.48 14.51C18.8 13.83 17.98 13.5 17 13.5C16.02 13.5 15.19 13.84 14.52 14.51C13.84 15.19 13.5 16.02 13.5 17C13.5 17.98 13.84 18.81 14.52 19.49C15.2 20.17 16.02 20.5 17 20.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function PodTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4164"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4164)">
        <path
          d="M46.15 12.97C46.04 12.62 45.76 12.3 45.31 12.02L33.27 5H29.89C29.5 5 29.2 5.11 28.97 5.34C28.74 5.57 28.63 5.88 28.63 6.26V7.05C28.63 8.39 28.22 9.48 27.39 10.32C26.56 11.16 25.48 11.59 24.14 11.59C22.8 11.59 21.71 11.17 20.87 10.32C20.03 9.48 19.6 8.38 19.6 7.05V6.26C19.6 5.87 19.49 5.57 19.26 5.34C19.03 5.11 18.72 5 18.34 5H14.96L2.92998 12.02C2.46998 12.3 2.17998 12.62 2.05998 12.97C1.93998 13.32 2.01998 13.74 2.29998 14.24L5.93998 20.52C6.14998 20.98 6.52998 21.27 7.06998 21.39C7.61998 21.51 8.12998 21.43 8.62998 21.15L11.96 19.3V40.94C11.96 41.5 12.16 41.99 12.57 42.39C12.97 42.79 13.46 43 14.02 43H33.97C34.53 43 35.03 42.8 35.45 42.39C35.87 41.99 36.08 41.5 36.08 40.94V19.2L39.35 21.26C39.74 21.51 40.27 21.56 40.93 21.42C41.59 21.28 42.04 20.98 42.25 20.52L45.94 14.24C46.19 13.75 46.26 13.33 46.15 12.97ZM22.28 17.39H26.17V19.06H22.28V17.39ZM24.57 22.74C24.57 23.31 24.11 23.77 23.54 23.77C22.97 23.77 22.51 23.31 22.51 22.74C22.51 22.17 22.97 21.71 23.54 21.71C24.11 21.71 24.57 22.17 24.57 22.74ZM16.17 22.95H17.84V26.84H16.17V22.95ZM19.25 32.64H17.84C16.93 32.64 16.17 31.9 16.17 30.97V28.49H17.84V30.97H19.25V32.64ZM19.5 19.05H17.83V21.28H16.16V19.05C16.16 18.13 16.92 17.38 17.83 17.38H19.5V19.05ZM26.16 32.64H22.27V30.97H26.16V32.64ZM27.69 28.32H20.51C19.73 28.32 19.29 27.42 19.77 26.81L21.1 25.1C21.43 24.67 22.05 24.61 22.45 24.96L23.07 25.5C23.46 25.84 24.06 25.79 24.4 25.4L25.85 23.69C26.31 23.14 27.2 23.3 27.45 23.97L28.58 27.06C28.8 27.67 28.35 28.32 27.7 28.32H27.69ZM32.03 30.98C32.03 31.9 31.27 32.65 30.37 32.65H28.96V30.98H30.37V28.5H32.03V30.98ZM32.03 26.84H30.37V22.95H32.03V26.84ZM32.03 21.29H30.37V19.06H28.7V17.39H30.37C31.28 17.39 32.03 18.13 32.03 19.06V21.29Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function PotteryTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3952"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3952)">
        <path
          d="M38 22.09C38 16.54 35.13 13.34 30.49 11.11L30.96 9.70999H32.2C33.8 9.70999 35.1 8.42999 35.1 6.84999C35.1 5.26999 33.8 3.98999 32.2 3.98999H14.8C13.2 3.98999 11.9 5.26999 11.9 6.84999C11.9 8.42999 13.2 9.70999 14.8 9.70999H16.04L16.52 11.12C11.91 13.37 9 16.58 9 22.09C9 22.97 9.08 23.9 9.24 24.85C9.24 24.88 9.23 24.91 9.23 24.94C9.23 25.09 9.27 25.24 9.34 25.36C10.16 29.59 12.42 34.22 15.53 37.32C15.53 37.32 15.54 37.34 15.55 37.34C15.94 37.7 15.96 38.29 15.6 38.68L15.12 39.2C14.34 40.04 14.14 41.24 14.6 42.28C15.06 43.32 16.11 43.99 17.25 43.99H29.73C30.88 43.99 31.92 43.32 32.38 42.28C32.84 41.24 32.64 40.04 31.86 39.2C31.72 39.05 31.58 38.9 31.46 38.74C31.44 38.72 31.42 38.69 31.4 38.67C31.05 38.3 31.07 37.71 31.45 37.37L31.48 37.34C34.56 34.23 36.82 29.62 37.65 25.39C37.72 25.26 37.77 25.1 37.77 24.94C37.77 24.9 37.77 24.86 37.76 24.82C37.92 23.88 38 22.96 38 22.08V22.09ZM14.8 7.80999C14.27 7.80999 13.83 7.37999 13.83 6.85999C13.83 6.33999 14.26 5.90999 14.8 5.90999H32.2C32.73 5.90999 33.17 6.33999 33.17 6.85999C33.17 7.37999 32.74 7.80999 32.2 7.80999H14.8ZM35.93 24H11.07C10.98 23.35 10.93 22.71 10.93 22.09C10.93 21.41 10.99 20.78 11.09 20.19H35.91C36.01 20.79 36.07 21.42 36.07 22.09C36.07 22.7 36.02 23.34 35.93 24Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function PrintingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3925"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3925)">
        <path
          d="M15.1 42C14.27 42 13.57 41.71 12.98 41.12C12.39 40.53 12.1 39.83 12.1 39V33.2H7C6.18 33.2 5.47 32.91 4.88 32.32C4.29 31.73 4 31.03 4 30.2V20.9C4 19.4 4.51 18.14 5.52 17.12C6.54 16.1 7.8 15.6 9.3 15.6H38.7C40.2 15.6 41.46 16.11 42.48 17.12C43.5 18.14 44 19.39 44 20.9V30.2C44 31.03 43.71 31.73 43.12 32.32C42.53 32.91 41.83 33.2 41 33.2H35.9V39C35.9 39.82 35.61 40.53 35.02 41.12C34.43 41.71 33.73 42 32.9 42H15.1ZM35.9 14.1H12.1V9C12.1 8.18 12.39 7.47 12.98 6.88C13.57 6.29 14.27 6 15.1 6H32.9C33.73 6 34.43 6.29 35.02 6.88C35.61 7.47 35.9 8.17 35.9 9V14.1ZM36.95 23.85C37.48 23.85 37.95 23.65 38.35 23.25C38.75 22.85 38.95 22.38 38.95 21.85C38.95 21.32 38.75 20.85 38.35 20.45C37.95 20.05 37.48 19.85 36.95 19.85C36.42 19.85 35.95 20.05 35.55 20.45C35.15 20.85 34.95 21.32 34.95 21.85C34.95 22.38 35.15 22.85 35.55 23.25C35.95 23.65 36.42 23.85 36.95 23.85ZM15.1 39H32.9V29.4H15.1V39Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function PunchNeedlingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4284"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4284)">
        <path
          d="M22.86 24.03C23.33 24.5 23.33 25.39 22.86 25.87C22.57 26.16 22.26 26.3 21.94 26.3C21.62 26.3 21.31 26.15 21.02 25.87L19.15 24L17.28 25.87C16.7 26.45 16.03 26.45 15.45 25.87C14.98 25.4 14.98 24.51 15.45 24.03L17.32 22.16L15.45 20.29C14.98 19.82 14.98 18.93 15.45 18.45C15.92 17.98 16.81 17.98 17.29 18.45L19.16 20.32L21.03 18.45C21.5 17.98 22.39 17.98 22.87 18.45C23.33 18.91 23.34 19.66 22.91 20.24L22.87 20.28L21 22.15L22.87 24.02L22.86 24.03ZM22.86 29.25C22.39 28.78 21.5 28.78 21.02 29.25L19.15 31.12L17.28 29.25C16.81 28.78 15.92 28.78 15.44 29.25C14.97 29.72 14.97 30.61 15.44 31.09L17.31 32.96L15.44 34.83C14.97 35.3 14.97 36.19 15.44 36.67C16.02 37.25 16.7 37.25 17.27 36.67L19.14 34.8L21.01 36.67C21.3 36.96 21.61 37.1 21.93 37.1C22.25 37.1 22.56 36.95 22.85 36.67C23.32 36.2 23.32 35.31 22.85 34.83L20.98 32.96L22.85 31.09C23.32 30.62 23.32 29.73 22.85 29.25H22.86ZM44.11 27.6C44.11 38.68 35.13 47.65 24.06 47.65C12.99 47.65 4 38.67 4 27.6C4 18.7 9.8 11.17 17.82 8.55V6.01H14.18C13.35 6.01 12.67 5.33 12.67 4.5C12.67 3.67 13.35 2.99 14.18 2.99H17.82V2.01C17.82 1.24 18.45 0.61 19.22 0.61C19.99 0.61 20.62 1.24 20.62 2.01V2.99H26.13C26.39 1.31 28.04 0 30.02 0C32.18 0 33.94 1.56 33.94 3.46V10.17C40.01 13.62 44.11 20.13 44.11 27.61V27.6ZM20.62 7.86C21.74 7.67 22.88 7.54 24.06 7.54C24.75 7.54 25.42 7.59 26.09 7.65V6H20.62V7.86ZM39.23 27.6C39.23 23.01 37.17 18.89 33.93 16.11V18.99C33.93 19.44 33.56 19.81 33.11 19.81H26.91C26.46 19.81 26.09 19.44 26.09 18.99V15.69H33.94V13.7H26.09V12.58C25.42 12.49 24.75 12.43 24.06 12.43C15.69 12.43 8.88 19.24 8.88 27.61C8.88 35.98 15.69 42.79 24.06 42.79C32.43 42.79 39.24 35.98 39.24 27.61L39.23 27.6ZM28.08 21.81C28.08 23.35 28.08 33.84 28.08 33.84L30.02 38.25L32.08 33.84V21.81C32.08 21.81 29.42 21.81 28.08 21.81Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function QuillingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4188"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4188)">
        <path
          d="M23.5 1C10.54 1 0 11.54 0 24.5C0 37.46 10.54 48 23.5 48C36.46 48 47 37.46 47 24.5C47 11.54 36.46 1 23.5 1ZM11.72 40.47C9.57 38.9 9.11 35.87 10.68 33.73C11.79 32.22 17.09 29.37 21.36 27.32C20.7 32 19.57 37.92 18.47 39.43C17.71 40.47 16.59 41.15 15.31 41.35C14.03 41.55 12.76 41.23 11.72 40.47ZM8.27 31.96C7.31 33.27 6.82 34.78 6.77 36.3C4.46 33.02 3.07 29.05 3.02 24.75C3.98 25.83 5.22 26.62 6.64 27.03C7.24 27.21 8.05 27.28 8.99 27.28C11.08 27.28 13.81 26.91 16.34 26.47C13.03 28.2 9.46 30.32 8.27 31.95V31.96ZM23.5 4.03C26.16 4.03 28.32 6.2 28.32 8.86C28.32 10.73 25.73 16.17 23.5 20.34C21.26 16.17 18.67 10.73 18.67 8.86C18.67 6.2 20.84 4.03 23.5 4.03ZM42.8 18.17C43.55 20.72 42.07 23.41 39.52 24.15C37.73 24.68 31.78 23.71 27.15 22.73C30.53 19.42 35.02 15.41 36.82 14.88C39.38 14.13 42.06 15.61 42.8 18.16V18.17ZM8.83 14.7C9.28 14.7 9.73 14.76 10.18 14.89C11.98 15.41 16.47 19.42 19.85 22.74C15.22 23.72 9.28 24.68 7.48 24.16C6.24 23.8 5.22 22.98 4.6 21.85C3.98 20.72 3.84 19.42 4.2 18.18C4.81 16.08 6.74 14.71 8.83 14.71V14.7ZM31.69 41.35C30.42 41.15 29.3 40.47 28.53 39.43C27.42 37.92 26.3 32.01 25.64 27.32C29.91 29.36 35.21 32.22 36.32 33.73C37.08 34.77 37.39 36.04 37.2 37.32C37.01 38.6 36.32 39.71 35.28 40.48C34.24 41.24 32.97 41.56 31.69 41.36V41.35ZM38.73 31.96C37.53 30.33 33.97 28.21 30.66 26.48C33.19 26.92 35.92 27.29 38.01 27.29C38.95 27.29 39.76 27.22 40.36 27.04C41.81 26.62 43.04 25.8 43.98 24.75C43.93 29.05 42.55 33.02 40.23 36.3C40.17 34.75 39.66 33.25 38.72 31.97L38.73 31.96ZM39.59 11.84C38.42 11.62 37.19 11.66 35.98 12.01C34.1 12.56 31.02 15.05 28.32 17.5C29.87 14.28 31.32 10.77 31.32 8.86C31.32 7.55 30.99 6.32 30.42 5.24C34.06 6.55 37.23 8.86 39.58 11.85L39.59 11.84ZM16.57 5.23C16 6.31 15.67 7.55 15.67 8.85C15.67 10.76 17.12 14.28 18.67 17.49C15.97 15.04 12.89 12.55 11.01 12C9.8 11.65 8.57 11.61 7.4 11.83C9.76 8.84 12.92 6.54 16.56 5.22L16.57 5.23ZM17.13 43.97C18.59 43.47 19.91 42.54 20.89 41.21C21.98 39.73 22.86 36.26 23.5 32.88C24.14 36.26 25.02 39.73 26.11 41.21C27.06 42.51 28.37 43.46 29.86 43.98C27.85 44.64 25.72 45 23.49 45C21.26 45 19.13 44.63 17.12 43.97H17.13ZM27.37 9.42C27.37 7.32 25.66 5.61 23.56 5.61C21.46 5.61 19.75 7.32 19.75 9.42C19.75 11.52 21.46 13.23 23.56 13.23C25.66 13.23 27.37 11.52 27.37 9.42ZM21.75 9.42C21.75 8.42 22.56 7.61 23.56 7.61C24.56 7.61 25.37 8.42 25.37 9.42C25.37 10.42 24.56 11.23 23.56 11.23C22.56 11.23 21.75 10.42 21.75 9.42ZM34.05 19.42C34.05 21.52 35.76 23.23 37.86 23.23C39.96 23.23 41.67 21.52 41.67 19.42C41.67 17.32 39.96 15.61 37.86 15.61C35.76 15.61 34.05 17.32 34.05 19.42ZM37.86 17.61C38.86 17.61 39.67 18.42 39.67 19.42C39.67 20.42 38.86 21.23 37.86 21.23C36.86 21.23 36.05 20.42 36.05 19.42C36.05 18.42 36.86 17.61 37.86 17.61ZM8.89 23.3C10.99 23.3 12.7 21.59 12.7 19.49C12.7 17.39 10.99 15.68 8.89 15.68C6.79 15.68 5.08 17.39 5.08 19.49C5.08 21.59 6.79 23.3 8.89 23.3ZM8.89 17.68C9.89 17.68 10.7 18.49 10.7 19.49C10.7 20.49 9.89 21.3 8.89 21.3C7.89 21.3 7.08 20.49 7.08 19.49C7.08 18.49 7.89 17.68 8.89 17.68ZM14.51 32.48C12.41 32.48 10.7 34.19 10.7 36.29C10.7 38.39 12.41 40.1 14.51 40.1C16.61 40.1 18.32 38.39 18.32 36.29C18.32 34.19 16.61 32.48 14.51 32.48ZM14.51 38.1C13.51 38.1 12.7 37.29 12.7 36.29C12.7 35.29 13.51 34.48 14.51 34.48C15.51 34.48 16.32 35.29 16.32 36.29C16.32 37.29 15.51 38.1 14.51 38.1ZM36.44 36.29C36.44 34.19 34.73 32.48 32.63 32.48C30.53 32.48 28.82 34.19 28.82 36.29C28.82 38.39 30.53 40.1 32.63 40.1C34.73 40.1 36.44 38.39 36.44 36.29ZM32.63 38.1C31.63 38.1 30.82 37.29 30.82 36.29C30.82 35.29 31.63 34.48 32.63 34.48C33.63 34.48 34.44 35.29 34.44 36.29C34.44 37.29 33.63 38.1 32.63 38.1Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function QuiltingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4152"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4152)">
        <path
          d="M46 24C46 23.23 45.74 22.58 45.23 22.07L41.75 18.59L43.96 16.36C44.55 15.77 44.55 14.81 43.96 14.22C43.37 13.63 42.42 13.63 41.84 14.22L39.62 16.45L36.78 13.61L39.01 11.36C39.6 10.77 39.6 9.80999 39.01 9.21999C38.42 8.62999 37.47 8.62999 36.89 9.21999L34.65 11.48L31.81 8.63999L34.06 6.36999C34.65 5.77999 34.65 4.81999 34.06 4.22999C33.47 3.63999 32.52 3.63999 31.94 4.22999L29.68 6.50999L25.93 2.75999C25.42 2.24999 24.77 1.98999 24 1.98999C23.23 1.98999 22.58 2.24999 22.07 2.75999L18.51 6.31999L16.07 3.85999C15.48 3.26999 14.53 3.26999 13.95 3.85999C13.36 4.44999 13.36 5.40999 13.95 5.99999L16.38 8.44999L13.54 11.29L11.12 8.84999C10.53 8.25999 9.58001 8.25999 9.00001 8.84999C8.41001 9.43999 8.41001 10.4 9.00001 10.99L11.41 13.42L8.57001 16.26L6.17001 13.84C5.58001 13.25 4.63001 13.25 4.05001 13.84C3.46001 14.43 3.46001 15.39 4.05001 15.98L6.44001 18.39L2.78001 22.05C2.27001 22.56 2.01001 23.21 2.01001 23.98C2.01001 24.75 2.27001 25.4 2.78001 25.91L6.63001 29.76L4.42001 31.99C3.83001 32.58 3.83001 33.54 4.42001 34.13C4.71001 34.43 5.10001 34.57 5.48001 34.57C5.86001 34.57 6.25001 34.42 6.54001 34.13L8.76001 31.89L11.6 34.73L9.37001 36.98C8.78001 37.57 8.78001 38.53 9.37001 39.12C9.66001 39.42 10.05 39.56 10.43 39.56C10.81 39.56 11.2 39.41 11.49 39.12L13.73 36.86L16.57 39.7L14.32 41.97C13.73 42.56 13.73 43.52 14.32 44.11C14.61 44.41 15 44.55 15.38 44.55C15.76 44.55 16.15 44.4 16.44 44.11L18.7 41.83L22.08 45.21C22.59 45.72 23.24 45.98 24.01 45.98C24.78 45.98 25.43 45.72 25.94 45.21L29.5 41.65L31.58 43.74C31.87 44.04 32.26 44.18 32.64 44.18C33.02 44.18 33.41 44.03 33.7 43.74C34.29 43.15 34.29 42.19 33.7 41.6L31.63 39.51L34.47 36.67L36.53 38.74C36.82 39.04 37.21 39.18 37.59 39.18C37.97 39.18 38.36 39.03 38.65 38.74C39.24 38.15 39.24 37.19 38.65 36.6L36.6 34.54L39.44 31.7L41.47 33.75C41.76 34.05 42.15 34.19 42.53 34.19C42.91 34.19 43.3 34.04 43.59 33.75C44.18 33.16 44.18 32.2 43.59 31.61L41.56 29.57L45.22 25.91C45.73 25.4 45.99 24.75 45.99 23.98L46 24ZM25.32 38.48C24.97 38.83 24.53 39.01 24 39.01C23.47 39.01 23.03 38.83 22.68 38.48L9.51001 25.31C9.16001 24.96 8.98001 24.52 8.98001 23.99C8.98001 23.46 9.16001 23.02 9.51001 22.67L22.68 9.49999C23.03 9.14999 23.47 8.96999 24 8.96999C24.53 8.96999 24.97 9.14999 25.32 9.49999L38.49 22.67C38.84 23.02 39.02 23.46 39.02 23.99C39.02 24.52 38.84 24.96 38.49 25.31L25.32 38.48ZM25.5 27V30.09C25.5 30.46 25.39 30.77 25.16 31.04C24.94 31.31 24.65 31.47 24.3 31.55C23.83 31.65 23.41 31.55 23.04 31.25C22.67 30.95 22.49 30.57 22.49 30.1V27.01C22.49 26.64 22.6 26.33 22.83 26.06C23.05 25.79 23.34 25.63 23.69 25.55C24.16 25.45 24.58 25.55 24.95 25.85C25.32 26.15 25.5 26.53 25.5 27ZM25.5 17.91V21C25.5 21.37 25.39 21.68 25.16 21.95C24.94 22.22 24.65 22.38 24.3 22.46C23.83 22.56 23.41 22.46 23.04 22.16C22.67 21.86 22.49 21.48 22.49 21.01V17.92C22.49 17.55 22.6 17.24 22.83 16.97C23.05 16.7 23.34 16.54 23.69 16.46C24.16 16.36 24.58 16.46 24.95 16.76C25.32 17.06 25.5 17.44 25.5 17.91ZM31.55 23.68C31.65 24.15 31.55 24.57 31.25 24.94C30.95 25.31 30.57 25.49 30.1 25.49H27.01C26.64 25.49 26.33 25.38 26.06 25.15C25.79 24.93 25.63 24.64 25.55 24.29C25.45 23.82 25.55 23.4 25.85 23.03C26.15 22.66 26.53 22.48 27 22.48H30.09C30.46 22.48 30.77 22.59 31.04 22.82C31.31 23.04 31.47 23.33 31.55 23.68ZM22.46 23.68C22.56 24.15 22.46 24.57 22.16 24.94C21.86 25.31 21.48 25.49 21.01 25.49H17.92C17.55 25.49 17.24 25.38 16.97 25.15C16.7 24.93 16.54 24.64 16.46 24.29C16.36 23.82 16.46 23.4 16.76 23.03C17.06 22.66 17.44 22.48 17.91 22.48H21C21.37 22.48 21.68 22.59 21.95 22.82C22.22 23.04 22.38 23.33 22.46 23.68Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ResinTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4254"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4254)">
        <path
          d="M7 3L12.18 11.21V40.91C12.18 41.75 12.45 42.49 13 43.12C13.54 43.75 14.18 44.07 14.91 44.07H38.5C38.86 44.07 39.2 43.99 39.52 43.83C39.84 43.67 40.13 43.44 40.4 43.12C40.54 42.96 40.66 42.8 40.76 42.63C41.07 42.12 41.22 41.55 41.22 40.92V3H7ZM30.44 34.78C29.41 35.81 28.01 36.39 26.55 36.39C25.09 36.39 23.69 35.81 22.66 34.78C21.63 33.75 21.05 32.35 21.05 30.89C21.05 28.23 24.64 24.31 26.55 22.52C28.46 24.31 32.05 28.22 32.05 30.89C32.05 32.35 31.47 33.75 30.44 34.78ZM38.21 16.92C36.67 16.81 35.05 17.18 34.34 17.43C34.11 17.51 33.88 17.59 33.64 17.68C32.74 18.01 31.89 18.32 31.15 18.25C30.63 18.21 30.04 17.96 29.43 17.71C28.61 17.37 27.69 16.99 26.62 16.94H26.55H26.48C25.41 16.99 24.49 17.37 23.67 17.71C23.05 17.97 22.47 18.21 21.95 18.25C21.2 18.32 20.36 18 19.46 17.68C19.23 17.6 18.99 17.51 18.76 17.43C18.1 17.2 16.63 16.85 15.18 16.9V10.34L14.72 9.61L12.44 6.01H38.21V16.93V16.92Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function RhinestonesTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3786"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3786)">
        <path
          d="M18.25 17.75H30.45L25.2 7H23.5L18.25 17.75ZM23.1 41.5V20.25H5.4L23.1 41.5ZM25.6 41.5L43.3 20.25H25.6V41.5ZM33.25 17.75H43.7L39.2 8.65C38.93 8.15 38.56 7.75 38.08 7.45C37.6 7.15 37.07 7 36.5 7H28L33.25 17.75ZM5 17.75H15.45L20.7 7H12.2C11.63 7 11.11 7.15 10.62 7.45C10.14 7.75 9.76 8.15 9.5 8.65L5 17.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function RugmakingAndTuftingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4176"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4176)">
        <path
          d="M35.5 2C34.67 2 34 2.67 34 3.5V7.68H31V3.5C31 2.67 30.33 2 29.5 2C28.67 2 28 2.67 28 3.5V7.68H25V3.5C25 2.67 24.33 2 23.5 2C22.67 2 22 2.67 22 3.5V7.68H19V3.5C19 2.67 18.33 2 17.5 2C16.67 2 16 2.67 16 3.5V7.68H13V3.5C13 2.67 12.33 2 11.5 2C10.67 2 10 2.67 10 3.5V45.5C10 46.33 10.67 47 11.5 47C12.33 47 13 46.33 13 45.5V41.32H16V45.5C16 46.33 16.67 47 17.5 47C18.33 47 19 46.33 19 45.5V41.32H22V45.5C22 46.33 22.67 47 23.5 47C24.33 47 25 46.33 25 45.5V41.32H28V45.5C28 46.33 28.67 47 29.5 47C30.33 47 31 46.33 31 45.5V41.32H34V45.5C34 46.33 34.67 47 35.5 47C36.33 47 37 46.33 37 45.5V3.5C37 2.67 36.33 2 35.5 2ZM34.01 10.66V14.21H12.99V10.66H34.01ZM29.69 24.5L23.5 30.69L17.31 24.5L23.5 18.31L29.69 24.5ZM12.99 38.34V34.79H34.01V38.34H12.99Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function SawgrassTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3932"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3932)">
        <path
          d="M15.1 42C14.27 42 13.57 41.71 12.98 41.12C12.39 40.53 12.1 39.83 12.1 39V33.2H7C6.18 33.2 5.47 32.91 4.88 32.32C4.29 31.73 4 31.03 4 30.2V20.9C4 19.4 4.51 18.14 5.52 17.12C6.54 16.1 7.8 15.6 9.3 15.6H38.7C40.2 15.6 41.46 16.11 42.48 17.12C43.5 18.14 44 19.39 44 20.9V30.2C44 31.03 43.71 31.73 43.12 32.32C42.53 32.91 41.83 33.2 41 33.2H35.9V39C35.9 39.82 35.61 40.53 35.02 41.12C34.43 41.71 33.73 42 32.9 42H15.1ZM35.9 14.1H12.1V9C12.1 8.18 12.39 7.47 12.98 6.88C13.57 6.29 14.27 6 15.1 6H32.9C33.73 6 34.43 6.29 35.02 6.88C35.61 7.47 35.9 8.17 35.9 9V14.1ZM36.95 23.85C37.48 23.85 37.95 23.65 38.35 23.25C38.75 22.85 38.95 22.38 38.95 21.85C38.95 21.32 38.75 20.85 38.35 20.45C37.95 20.05 37.48 19.85 36.95 19.85C36.42 19.85 35.95 20.05 35.55 20.45C35.15 20.85 34.95 21.32 34.95 21.85C34.95 22.38 35.15 22.85 35.55 23.25C35.95 23.65 36.42 23.85 36.95 23.85ZM15.1 39H32.9V29.4H15.1V39Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ScrapbookingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4182"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4182)">
        <path
          d="M40.57 9.16C40.29 8.87 39.93 8.73 39.5 8.73C39.07 8.73 38.71 8.87 38.42 9.16C38.13 9.45 37.99 9.8 37.99 10.23V41.73H12.5C11.83 41.73 11.25 41.53 10.75 41.13C10.25 40.73 10 40.21 10 39.58C10 39.03 10.19 38.52 10.57 38.06C10.85 37.72 11.19 37.47 11.57 37.32H33.04C34.69 37.32 36.03 35.97 36.03 34.33V5.99C36.03 4.34 34.68 3 33.04 3H9.99C8.35 3 7 4.35 7 5.99V39.57C7 41.03 7.54 42.25 8.62 43.24C9.7 44.23 11 44.72 12.5 44.72H38C38.82 44.72 39.53 44.43 40.12 43.84C40.71 43.25 41 42.55 41 41.72V10.22C41 9.8 40.86 9.44 40.57 9.15V9.16ZM22.22 9.63C22.35 9.06 22.71 8.6 23.23 8.31C23.51 8.16 23.83 8.08 24.15 8.08C24.28 8.08 24.41 8.09 24.54 8.12C25.12 8.23 25.65 8.58 25.99 9.07L26.97 10.51L28.41 9.53C28.91 9.19 29.53 9.06 30.11 9.17C30.57 9.26 30.98 9.49 31.26 9.83C31.64 10.28 31.8 10.84 31.72 11.42C31.64 11.99 31.33 12.5 30.85 12.83L25.9 16.18L22.52 11.25C22.19 10.77 22.08 10.18 22.22 9.63ZM25.86 22.27L23.53 26.08L25.41 30.17L21.01 29.13L17.7 32.15L17.34 27.67L13.46 25.44L17.58 23.71L18.5 19.33L21.4 22.72L25.85 22.25L25.86 22.27ZM12.01 9.98C12.01 9.38 12.5 8.89 13.1 8.89H20.37C20.34 8.98 20.3 9.06 20.28 9.16C20.02 10.27 20.23 11.44 20.88 12.38L23.81 16.65V20.48L22.26 20.64L19.91 17.9C19.45 17.36 18.73 17.12 18.03 17.28C17.3 17.45 16.75 18.01 16.61 18.74L15.86 22.29L13.38 23.33H13.12C12.52 23.33 12.03 22.84 12.03 22.24V9.98H12.01Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function SculpturesTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4230"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4230)">
        <path
          d="M36.92 41.4H30.63C30.65 41.28 30.66 41.16 30.68 41.04C30.85 40.19 31.21 39.39 31.74 38.7C32.27 38.01 32.95 37.45 33.72 37.07C34.5 36.68 35.35 36.48 36.22 36.48C36.9 36.48 37.58 36.61 38.22 36.85C38.34 36.89 38.47 36.91 38.6 36.89C38.73 36.87 38.85 36.82 38.96 36.75C39.06 36.67 39.15 36.57 39.2 36.46C39.26 36.34 39.28 36.22 39.28 36.09C39.19 33.92 38.26 31.86 36.68 30.36C35.11 28.86 33.02 28.02 30.84 28.02H27.64V26.1C28.11 25.86 28.37 25.66 28.37 25.66C30.19 24.45 31.46 22.57 31.91 20.44C32.48 20.46 33.06 20.37 33.59 20.17C34.13 19.97 34.62 19.66 35.03 19.26C35.45 18.86 35.78 18.39 36.01 17.86C36.24 17.33 36.36 16.77 36.36 16.19C37.08 8.63 32.05 2.1 24.26 2C16.46 2.11 11.43 8.65 12.17 16.22C12.19 17.34 12.65 18.41 13.45 19.19C14.25 19.98 15.32 20.42 16.44 20.42H16.62C17.06 22.56 18.34 24.44 20.16 25.64C20.16 25.64 20.42 25.84 20.89 26.08V28H17.69C15.51 28 13.42 28.84 11.85 30.34C10.28 31.84 9.35 33.9 9.25 36.07C9.25 36.2 9.27 36.33 9.33 36.44C9.39 36.56 9.47 36.66 9.57 36.73C9.67 36.81 9.8 36.86 9.93 36.87C10.06 36.89 10.19 36.87 10.31 36.83C10.95 36.59 11.63 36.46 12.31 36.46C13.18 36.46 14.03 36.66 14.81 37.05C15.59 37.44 16.27 37.99 16.79 38.68C17.32 39.37 17.68 40.17 17.85 41.02C17.87 41.14 17.88 41.26 17.9 41.38H11.61C10.18 41.38 9 42.55 9 43.99V45.81H39.53V43.99C39.53 42.56 38.36 41.38 36.92 41.38V41.4ZM18.38 19.36C18.35 19.13 18.24 18.91 18.07 18.75C17.9 18.59 17.67 18.51 17.43 18.51H16.44C15.91 18.51 15.4 18.33 14.98 18C14.56 17.67 14.27 17.21 14.15 16.7C16.04 15.73 21.82 12.58 24.43 9.13C26.59 11.23 31.47 15.76 34.34 16.86C34.19 17.34 33.89 17.75 33.49 18.05C33.09 18.35 32.6 18.51 32.1 18.51H31.11C30.88 18.51 30.65 18.6 30.47 18.75C30.29 18.91 30.18 19.12 30.16 19.36C29.18 26.79 19.36 26.79 18.39 19.36H18.38Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function SeasonalCraftsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3720"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3720)">
        <path
          d="M43.5 22.04H35.25L41.56 15.73C41.65 15.64 41.71 15.51 41.71 15.37C41.71 15.23 41.66 15.11 41.56 15.02L39.46 12.97C39.26 12.78 38.95 12.78 38.76 12.97L29.69 22.04H25.96V18.31L35.17 9.1C35.36 8.91 35.37 8.59 35.17 8.4L33.12 6.3C33.03 6.2 32.87 6.11 32.76 6.15C32.63 6.15 32.5 6.2 32.41 6.3L25.95 12.76V4.5C25.95 4.22 25.73 4 25.45 4H22.53C22.25 4 22.03 4.22 22.03 4.5V12.75L15.77 6.44C15.68 6.35 15.55 6.29 15.42 6.29C15.3 6.31 15.15 6.35 15.06 6.45L13.01 8.6C12.82 8.8 12.83 9.11 13.01 9.3L22.03 18.32V22.05H18.35L9.14 12.78C9.05 12.69 8.92 12.63 8.79 12.63C8.66 12.63 8.53 12.68 8.44 12.78L6.34 14.88C6.14 15.08 6.14 15.39 6.34 15.59L12.8 22.05H4.5C4.22 22.05 4 22.27 4 22.55V25.48C4 25.76 4.22 25.98 4.5 25.98H12.8L6.49 32.29C6.39 32.39 6.34 32.52 6.34 32.65C6.34 32.79 6.4 32.91 6.5 33.01L8.65 35.01C8.85 35.19 9.15 35.19 9.34 35L18.36 25.98H22.04V29.66L12.83 38.87C12.74 38.96 12.68 39.09 12.68 39.23C12.68 39.37 12.73 39.49 12.83 39.58L14.93 41.63C15.13 41.82 15.44 41.82 15.63 41.63L22.04 35.22V43.52C22.04 43.8 22.26 44.02 22.54 44.02H25.46C25.74 44.02 25.96 43.8 25.96 43.52V35.22L32.47 41.73C32.57 41.82 32.71 41.89 32.83 41.88C32.96 41.88 33.09 41.82 33.19 41.72L35.19 39.62C35.38 39.42 35.37 39.12 35.19 38.92L25.98 29.66V25.98H29.71L38.92 35.19C39.01 35.28 39.12 35.35 39.28 35.34C39.41 35.34 39.54 35.28 39.64 35.18L41.64 33.08C41.83 32.88 41.82 32.58 41.64 32.38L35.27 25.97H43.53C43.81 25.97 44.03 25.75 44.03 25.47V22.54C44.03 22.26 43.81 22.04 43.53 22.04H43.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function SewingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4200"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4200)">
        <path
          d="M45.47 9.43999C45.47 7.09999 43.56 5.18999 41.22 5.18999H37.75V4.54999C37.75 3.15999 36.62 2.02999 35.23 2.02999H32.4C31.01 2.02999 29.88 3.15999 29.88 4.54999V5.18999H13.88V3.48999C13.88 2.65999 13.21 1.98999 12.38 1.98999C11.55 1.98999 10.88 2.65999 10.88 3.48999V5.18999H6.24C3.91 5.19999 2 7.09999 2 9.43999V16.64C2 18.62 3.37 20.27 5.2 20.74V21.43C5.2 23.18 6.63 24.61 8.38 24.61H10.88V26.5C10.88 27.33 11.55 28 12.38 28C13.21 28 13.88 27.33 13.88 26.5V24.61H16.38C18.13 24.61 19.56 23.18 19.56 21.43V20.88H29.8V33.77H6.25C3.94 33.78 2.06 35.66 2.06 37.97V44.5C2.06 45.33 2.73 46 3.56 46H43.91C44.74 46 45.41 45.33 45.41 44.5V38.6C45.44 38.47 45.47 38.34 45.47 38.21V20.31C45.47 20.14 45.44 19.98 45.38 19.82C45.43 19.67 45.47 19.5 45.47 19.33V9.43999ZM16.56 21.44C16.56 21.54 16.48 21.62 16.38 21.62H8.38C8.28 21.62 8.2 21.54 8.2 21.44V20.89H16.56V21.44ZM37.63 21.11C40.23 21.11 42.35 23.23 42.35 25.83C42.35 28.43 40.23 30.55 37.63 30.55C35.03 30.55 32.91 28.43 32.91 25.83C32.91 23.23 35.03 21.11 37.63 21.11ZM42.41 43H5.06V37.97C5.06 37.31 5.59 36.78 6.25 36.78H42.41V43ZM35.84 25.83C35.84 24.84 36.64 24.04 37.63 24.04C38.62 24.04 39.42 24.84 39.42 25.83C39.42 26.82 38.62 27.62 37.63 27.62C36.64 27.62 35.84 26.82 35.84 25.83Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function SilhouetteTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4338"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4338)">
        <path
          d="M42.39 12.58H5.34V8.73C5.34 7.7 5.71 6.83 6.44 6.1C7.17 5.37 8.05 5 9.07 5H38.66C39.69 5 40.56 5.37 41.29 6.1C42.02 6.83 42.39 7.71 42.39 8.73V12.58ZM48.73 21.04V31.36C48.73 32.39 48.36 33.26 47.63 33.99C46.9 34.72 46.02 35.09 45 35.09H43.63V39.81C43.63 40.84 43.26 41.71 42.53 42.44C41.8 43.17 40.92 43.54 39.9 43.54H7.83C6.8 43.54 5.93 43.17 5.2 42.44C4.47 41.71 4.1 40.83 4.1 39.81V35.09H2.73C1.7 35.09 0.83 34.72 0.1 33.99C-0.63 33.26 -1 32.38 -1 31.36V21.04C-1 19.17 -0.37 17.61 0.9 16.35C2.16 15.09 3.73 14.46 5.59 14.46H42.14C44.01 14.46 45.57 15.09 46.83 16.35C48.09 17.61 48.72 19.18 48.72 21.04H48.73ZM8.19 27.56H11.53V33.36C11.53 33.64 12.32 35.11 12.6 35.11H12.82C13.02 35.11 13.91 33.44 13.91 33.36V27.56H17.58C18.17 27.56 18.68 27.19 18.89 26.67V19.86H8.88C6.77 19.86 6.77 21.45 6.77 21.87V26.15C6.77 26.93 7.4 27.56 8.18 27.56H8.19ZM39.9 30.36H16.4V33.39C16.4 34.1 15.17 37.59 12.82 37.59H12.6C10.19 37.59 9.04 34.19 9.04 33.36V30.36H7.82V39.81H39.9V30.36ZM40.59 21.73C40.59 20.7 39.76 19.87 38.72 19.87H21.9V23.6H38.72C39.75 23.6 40.59 22.77 40.59 21.74V21.73Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function SizzixTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4302"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4302)">
        <path
          d="M23.5 1C10.54 1 0 11.54 0 24.5C0 37.46 10.54 48 23.5 48C36.46 48 47 37.46 47 24.5C47 11.54 36.46 1 23.5 1ZM23.5 4C34.8 4 44 13.2 44 24.5C44 26.36 43.73 28.16 43.26 29.87C43.01 29.43 42.7 29 42.29 28.58C40.87 27.07 38.99 26.47 37.01 26.84C35.46 27.19 33.93 28.19 32.42 29.98C33.88 29.99 37.09 30.12 38.56 32.24C38.99 32.86 39.44 33.55 39.51 34.85C39.59 36.15 39 36.92 38.65 37.45C38.13 38.16 36.58 39.76 33.88 39.73C32.15 39.71 31.29 38.78 30.7 38.04C32.31 37.69 33.65 36.69 34.27 36.01C35.37 34.82 34.14 32.49 34.13 32.5V32.48C32.41 34 31.32 34.6 29.58 34.46C27.84 34.32 26.48 31.93 26.33 31.64C26.62 31.5 28.41 30.17 28.52 29.72C28.62 29.34 26.96 27.4 26.96 27.4C26.96 27.4 27.42 24.48 29.07 21.85C29.51 21.15 31.33 19.96 32.98 22.1C33.67 23.41 33.38 25.19 33.02 26.23C33.14 26.19 37.16 24.93 36.88 21.69C36.66 19.12 34.66 17.02 32.17 16.75C28.35 16.33 26.59 18.87 25.64 19.82C25.46 16.89 26.19 13.29 32.02 11.44C31.04 9.27 29.85 8.96 28.03 9C27.69 9.02 26.55 9.28 26.55 9.28C26.55 9.28 25.32 4.75 23.51 4.74C21.69 4.76 20.47 9.28 20.47 9.28C20.47 9.28 19.33 9.02 18.99 9C17.17 8.96 15.98 9.27 15 11.44C20.82 13.29 21.55 16.9 21.38 19.82C20.43 18.88 18.67 16.33 14.85 16.75C12.36 17.02 10.36 19.12 10.14 21.69C9.86 24.93 13.88 26.19 14 26.23C13.64 25.19 13.34 23.41 14.04 22.1C15.69 19.97 17.5 21.15 17.95 21.85C19.6 24.48 20.06 27.4 20.06 27.4C20.06 27.4 18.4 29.34 18.5 29.72C18.61 30.17 20.4 31.49 20.69 31.64C20.54 31.92 19.18 34.31 17.44 34.46C15.7 34.61 14.61 34 12.89 32.48V32.5C12.88 32.49 11.65 34.82 12.75 36.01C13.38 36.69 14.71 37.69 16.32 38.04C15.73 38.78 14.87 39.71 13.14 39.73C10.45 39.76 8.89 38.16 8.37 37.45C8.03 36.93 7.44 36.15 7.51 34.85C7.59 33.55 8.03 32.86 8.46 32.24C9.93 30.12 13.14 29.99 14.6 29.98C13.09 28.2 11.56 27.19 10.01 26.84C8.04 26.47 6.15 27.07 4.73 28.58C4.33 29.01 4.01 29.44 3.76 29.87C3.29 28.15 3.02 26.36 3.02 24.5C3 13.2 12.2 4 23.5 4ZM24.76 24.97C24.76 25.55 24.52 26.84 24.47 27.1C24.42 27.35 24.43 27.4 24.27 27.53C24.12 27.65 23.9 27.61 23.67 27.64H23.32C23.08 27.61 22.87 27.65 22.72 27.53C22.57 27.41 22.57 27.36 22.52 27.1C22.47 26.85 22.23 25.55 22.23 24.97C22.23 24.39 22.81 23.64 22.95 23.56C23.09 23.48 23.21 23.5 23.32 23.48H23.67C23.78 23.5 23.9 23.48 24.04 23.56C24.18 23.64 24.76 24.39 24.76 24.97ZM16.26 43.66C20.82 41.17 23.5 32.15 23.5 32.15C23.5 32.15 26.18 41.17 30.74 43.66C28.49 44.51 26.05 45 23.5 45C20.95 45 18.52 44.51 16.26 43.66Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function SoapMakingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4452"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4452)">
        <path
          d="M33.4901 21.2C33.5501 21.26 33.5501 21.37 33.4901 21.43L18.8801 36.04C18.8201 36.1 18.7101 36.1 18.6501 36.04L13.5301 30.92C13.4701 30.86 13.4701 30.75 13.5301 30.69L28.1401 16.08C28.1401 16.08 28.2101 16.03 28.2601 16.03C28.3101 16.03 28.3401 16.05 28.3801 16.08L33.5001 21.2H33.4901ZM43.7301 23.82L21.2801 46.27C19.5401 48.01 16.7001 48.01 14.9601 46.27L3.30012 34.61C1.56012 32.87 1.56012 30.03 3.30012 28.29L5.41012 26.18C3.43012 24.96 2.11012 22.78 2.11012 20.28C2.11012 16.45 5.22012 13.34 9.05012 13.34C11.5401 13.34 13.7301 14.67 14.9501 16.64L25.7501 5.84C27.4901 4.1 30.3301 4.1 32.0701 5.84L43.7201 17.49C45.4601 19.23 45.4601 22.07 43.7201 23.81L43.7301 23.82ZM9.05012 24.08C11.1501 24.08 12.8501 22.37 12.8501 20.28C12.8501 18.19 11.1401 16.48 9.05012 16.48C6.96012 16.48 5.25012 18.19 5.25012 20.28C5.25012 22.37 6.96012 24.08 9.05012 24.08ZM34.9101 19.78L29.7901 14.66C28.9401 13.82 27.5701 13.82 26.7301 14.66L12.1201 29.27C11.2801 30.11 11.2801 31.49 12.1201 32.33L17.2401 37.45C17.6601 37.87 18.2201 38.08 18.7701 38.08C19.3201 38.08 19.8801 37.87 20.3001 37.45L34.9101 22.84C35.7501 22 35.7501 20.62 34.9101 19.78ZM11.4701 6.04C11.4701 3.26 13.7301 1 16.5101 1C19.2901 1 21.5501 3.26 21.5501 6.04C21.5501 8.82 19.2901 11.08 16.5101 11.08C13.7301 11.08 11.4701 8.82 11.4701 6.04ZM14.6101 6.04C14.6101 7.09 15.4601 7.94 16.5101 7.94C17.5601 7.94 18.4101 7.09 18.4101 6.04C18.4101 4.99 17.5601 4.14 16.5101 4.14C15.4601 4.14 14.6101 4.99 14.6101 6.04ZM42.4901 38.62C42.4901 41.4 40.2301 43.66 37.4501 43.66C34.6701 43.66 32.4101 41.4 32.4101 38.62C32.4101 35.84 34.6701 33.58 37.4501 33.58C40.2301 33.58 42.4901 35.84 42.4901 38.62ZM39.3501 38.62C39.3501 37.57 38.5001 36.72 37.4501 36.72C36.4001 36.72 35.5501 37.57 35.5501 38.62C35.5501 39.67 36.4001 40.52 37.4501 40.52C38.5001 40.52 39.3501 39.67 39.3501 38.62Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function SpinningTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4170"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4170)">
        <path
          d="M29.13 20.87C30.37 19.12 31.02 17.06 31.02 14.9C31.02 12.13 29.94 9.52 27.98 7.57L20.4 0L19.05 1.35C17.09 3.31 16.01 5.92 16.01 8.69C16.01 10.85 16.66 12.9 17.89 14.64C16.65 16.39 16 18.45 16 20.61C16 22.77 16.65 24.84 17.9 26.59C16.66 28.34 16 30.4 16 32.57C16 35.34 17.08 37.95 19.04 39.9L26.61 47.46L27.96 46.11C29.92 44.15 31 41.55 31 38.78C31 36.61 30.35 34.55 29.1 32.8C30.34 31.05 31 28.99 31 26.82C31 24.65 30.35 22.61 29.12 20.87H29.13ZM20.59 17.55L25.56 22.52C27.35 24.57 27.67 27.52 26.41 29.89L21.58 25.06L21.53 25.01C20.43 23.8 19.83 22.24 19.83 20.61C19.83 19.53 20.09 18.48 20.59 17.54V17.55ZM20.59 29.51L25.47 34.39C26.57 35.6 27.18 37.16 27.18 38.8C27.18 39.88 26.92 40.94 26.42 41.87L21.54 36.99C20.44 35.79 19.84 34.23 19.84 32.59C19.84 31.5 20.1 30.45 20.6 29.52L20.59 29.51ZM26.43 17.96L21.46 12.99C20.42 11.8 19.85 10.27 19.85 8.69C19.85 7.61 20.11 6.56 20.61 5.62L25.47 10.48C26.58 11.69 27.19 13.26 27.19 14.9C27.19 15.98 26.93 17.03 26.43 17.97V17.96Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function StainedGlassTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4218"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#F55772" />
      </mask>
      <g mask="url(#mask0_5063_4218)">
        <path
          d="M23.38 1C8.69 1 6 15.55 6 24.2V47H40.76V24.2C40.76 15.55 38.07 1 23.38 1ZM11.21 20.24L18.33 27.36H11V24.19C11 23.15 11.05 21.77 11.21 20.24ZM20.81 30.37L11 40.18V30.37H20.81ZM21.88 33.54V42H13.42L21.88 33.54ZM24.88 33.91L32.97 42H24.88V33.91ZM25.58 30.37H35.76V40.55L25.58 30.37ZM28.05 27.37L35.51 19.91C35.71 21.58 35.76 23.09 35.76 24.2V27.37H28.05ZM33.17 11.7C33.94 13.15 34.48 14.74 34.87 16.31L24.88 26.3V6.08C28.67 6.45 31.33 8.25 33.17 11.7ZM13.59 11.7C15.42 8.25 18.08 6.44 21.88 6.08V26.67L11.82 16.61C12.21 14.94 12.77 13.24 13.59 11.7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function StampingAndStampmakingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="img"
    >
      <mask
        id="mask0_5063_3732"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3732)">
        <path
          d="M11 44C10.17 44 9.46 43.71 8.88 43.12C8.3 42.53 8 41.83 8 41V31C8 30.2 8.3 29.5 8.9 28.9C9.5 28.3 10.2 28 11 28H37C37.8 28 38.5 28.3 39.1 28.9C39.7 29.5 40 30.2 40 31V41C40 41.83 39.71 42.54 39.12 43.12C38.53 43.7 37.83 44 37 44H11ZM13.5 36H34.5C35.2 36 35.79 35.76 36.27 35.28C36.75 34.8 37 34.2 37 33.5C37 32.8 36.76 32.21 36.27 31.72C35.79 31.24 35.2 31 34.5 31H13.5C12.8 31 12.21 31.24 11.73 31.72C11.25 32.2 11 32.8 11 33.5C11 34.2 11.24 34.79 11.73 35.28C12.21 35.76 12.8 36 13.5 36ZM22.8 26.3L14.75 15C14.52 14.67 14.36 14.32 14.27 13.95C14.19 13.58 14.18 13.2 14.25 12.8C14.65 10.27 15.7 8.17 17.4 6.5C19.1 4.83 21.3 4 24 4C26.7 4 28.9 4.83 30.6 6.5C32.3 8.17 33.35 10.27 33.75 12.8C33.82 13.2 33.81 13.58 33.73 13.95C33.65 14.32 33.49 14.67 33.25 15L25.2 26.3C24.9 26.73 24.5 26.95 24 26.95C23.5 26.95 23.1 26.73 22.8 26.3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function StockPhotosTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3913"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3913)">
        <path
          d="M9.66989 44.1C9.13989 44.13 8.64989 44 8.21989 43.7C7.78989 43.4 7.54989 42.98 7.51989 42.45L4.01989 15.4C3.94989 14.87 4.06989 14.39 4.36989 13.97C4.66989 13.55 5.09989 13.31 5.66989 13.25L9.96989 12.75V33.1C9.96989 34.5 10.4499 35.68 11.4199 36.65C12.3899 37.62 13.5699 38.1 14.9699 38.1H40.3699V38.45C40.3699 39.02 40.2099 39.51 39.8899 39.93C39.5699 40.35 39.1299 40.57 38.5699 40.6L9.66989 44.1ZM15.0699 35.1C14.4999 35.1 14.0099 34.9 13.5899 34.5C13.1699 34.1 12.9699 33.62 12.9699 33.05V6.10001C12.9699 5.53001 13.1799 5.04001 13.5899 4.63001C14.0099 4.21001 14.4999 4.01001 15.0699 4.01001H41.9699C42.5399 4.01001 43.0299 4.22001 43.4499 4.63001C43.8699 5.05001 44.0699 5.54001 44.0699 6.10001V33.05C44.0699 33.62 43.8599 34.1 43.4499 34.5C43.0299 34.9 42.5399 35.1 41.9699 35.1H15.0699ZM28.5199 29.8C28.4499 27.2 27.3999 24.99 25.3399 23.18C23.2899 21.36 21.0199 20.45 18.5199 20.45C18.7499 23.05 19.8499 25.23 21.8199 26.98C23.7899 28.73 26.0199 29.67 28.5199 29.81V29.8ZM28.5199 23.1C29.2199 23.1 29.7899 22.88 30.2199 22.45C30.6499 22.02 30.8699 21.45 30.8699 20.75V20.25L31.3699 20.4C32.1999 20.67 32.8899 20.73 33.4399 20.6C33.9899 20.47 34.3999 20.17 34.6599 19.7C34.9299 19.23 35.0399 18.67 34.9899 18C34.9399 17.33 34.5299 16.82 33.7599 16.45L33.2099 16.2L33.7599 15.9C34.5299 15.5 34.9399 14.98 34.9899 14.35C35.0399 13.72 34.9299 13.17 34.6599 12.7C34.3899 12.23 33.9799 11.93 33.4099 11.8C32.8399 11.67 32.1599 11.73 31.3599 12L30.8599 12.15V11.65C30.8599 10.95 30.6399 10.38 30.2099 9.95001C29.7799 9.52001 29.2099 9.30001 28.5099 9.30001C27.8099 9.30001 27.2399 9.52001 26.7799 9.95001C26.3299 10.38 26.1099 10.95 26.1099 11.65V12.15L25.6099 12C24.7799 11.73 24.0899 11.67 23.5599 11.8C23.0299 11.93 22.6099 12.23 22.3099 12.7C22.0099 13.17 21.8899 13.72 21.9599 14.35C22.0299 14.98 22.4399 15.5 23.2099 15.9L23.7599 16.2L23.2099 16.45C22.4399 16.82 22.0299 17.33 21.9899 18C21.9399 18.67 22.0499 19.23 22.3099 19.7C22.5799 20.17 22.9899 20.47 23.5599 20.6C24.1299 20.73 24.8099 20.67 25.6099 20.4L26.1099 20.25V20.75C26.1099 21.45 26.3299 22.02 26.7799 22.45C27.2299 22.88 27.8099 23.1 28.5099 23.1H28.5199ZM28.5199 18.55C27.8499 18.55 27.2899 18.32 26.8399 17.87C26.3899 17.42 26.1599 16.86 26.1599 16.19C26.1599 15.52 26.3899 14.97 26.8399 14.52C27.2899 14.07 27.8499 13.84 28.5199 13.84C29.1899 13.84 29.7499 14.06 30.1999 14.52C30.6499 14.97 30.8799 15.53 30.8799 16.19C30.8799 16.85 30.6499 17.42 30.1999 17.87C29.7499 18.32 29.1899 18.55 28.5199 18.55ZM28.5199 29.8C31.0199 29.67 33.2499 28.72 35.2199 26.97C37.1899 25.22 38.2899 23.05 38.5199 20.44C36.0199 20.44 33.7399 21.35 31.6699 23.17C29.5999 24.99 28.5499 27.19 28.5199 29.79V29.8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function SublimationTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4383"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4383)">
        <path
          d="M9.51 9.06002C10.5 7.39002 12.05 6.19002 13.88 5.08002C14.49 5.92002 15.07 6.70002 15.45 7.23002C14.51 8.20002 13.59 9.06002 12.8 10C11.89 11.07 12.02 11.44 13.26 12.24C14.06 12.76 14.93 13.25 15.56 13.91C16.88 15.29 16.67 16.84 15.78 18.34C14.8 19.98 13.26 21.16 11.45 22.26C10.83 21.4 10.26 20.6 9.91 20.11C10.86 19.11 11.76 18.25 12.57 17.31C13.46 16.27 13.36 15.87 12.16 15.14C11.77 14.9 11.35 14.68 10.97 14.43C8.81 13.02 8.29 11.15 9.53 9.06002H9.51ZM23.25 15.08C24.49 15.86 24.62 16.32 23.7 17.39C22.92 18.3 22.07 19.16 21.14 20.17C21.46 20.62 22.04 21.4 22.75 22.39C23.95 21.36 25.12 20.47 26.13 19.45C27.07 18.51 27.66 17.37 27.64 16.04C27.61 14.21 26.24 13.25 24.71 12.37C23.07 11.42 22.98 10.99 24.28 9.68002C25.05 8.90002 25.96 8.23002 26.83 7.48002C26.26 6.70002 25.69 5.91002 25.09 5.07002C23.19 6.27002 21.54 7.52002 20.58 9.33002C19.72 10.95 19.91 12.49 21.17 13.63C21.78 14.18 22.53 14.63 23.25 15.08ZM34.16 14.91C35.88 15.89 35.97 16.38 34.62 17.75C33.88 18.5 33 19.14 32.15 19.87C32.73 20.68 33.3 21.46 33.88 22.28C35.67 21.18 37.2 20.01 38.19 18.38C39.52 16.2 39 14.31 36.73 12.88C36.34 12.63 35.94 12.4 35.55 12.16C34.47 11.49 34.34 11.1 35.14 10.15C35.76 9.42002 36.55 8.81002 37.27 8.17002C37.52 7.95002 37.81 7.77002 38.09 7.55002C37.48 6.70002 36.92 5.94002 36.26 5.02002C35.24 5.83002 34.15 6.45002 33.42 7.32002C32.56 8.34002 31.72 9.52002 31.4 10.74C30.88 12.74 32.42 13.94 34.15 14.93L34.16 14.91ZM44.75 32.32V40.53C44.75 41.34 44.09 42 43.28 42H4.47C3.66 42 3 41.34 3 40.53V32.32C3 31.51 3.66 30.85 4.47 30.85H7.11V27.97C7.11 26.54 8.28 25.37 9.71 25.37H38.04C39.47 25.37 40.64 26.54 40.64 27.97V30.85H43.28C44.09 30.85 44.75 31.51 44.75 32.32ZM10.11 30.85H37.64V28.37H10.11V30.85Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function SuncatchersTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4377"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4377)">
        <path
          d="M23.9913 9.5C23.5638 9.5 23.2083 9.35625 22.925 9.06875C22.6417 8.78125 22.5 8.425 22.5 8V3.5C22.5 3.075 22.6446 2.71875 22.9338 2.43125C23.2229 2.14375 23.5813 2 24.0087 2C24.4362 2 24.7917 2.14375 25.075 2.43125C25.3583 2.71875 25.5 3.075 25.5 3.5V8C25.5 8.425 25.3554 8.78125 25.0663 9.06875C24.7771 9.35625 24.4187 9.5 23.9913 9.5ZM34.25 13.75C33.95 13.45 33.8 13.0983 33.8 12.695C33.8 12.2917 33.95 11.9433 34.25 11.65L37.4 8.45C37.7022 8.15 38.0611 8 38.4767 8C38.8922 8 39.25 8.15 39.55 8.45C39.85 8.75 40 9.1 40 9.5C40 9.9 39.85 10.25 39.55 10.55L36.35 13.75C36.05 14.05 35.7 14.2 35.3 14.2C34.9 14.2 34.55 14.05 34.25 13.75ZM40 25.5C39.575 25.5 39.2188 25.3554 38.9313 25.0663C38.6438 24.7771 38.5 24.4187 38.5 23.9913C38.5 23.5638 38.6438 23.2083 38.9313 22.925C39.2188 22.6417 39.575 22.5 40 22.5H44.5C44.925 22.5 45.2813 22.6446 45.5688 22.9338C45.8563 23.2229 46 23.5813 46 24.0087C46 24.4362 45.8563 24.7917 45.5688 25.075C45.2813 25.3583 44.925 25.5 44.5 25.5H40ZM23.9913 46C23.5638 46 23.2083 45.8563 22.925 45.5688C22.6417 45.2813 22.5 44.925 22.5 44.5V40C22.5 39.575 22.6446 39.2188 22.9338 38.9313C23.2229 38.6438 23.5813 38.5 24.0087 38.5C24.4362 38.5 24.7917 38.6438 25.075 38.9313C25.3583 39.2188 25.5 39.575 25.5 40V44.5C25.5 44.925 25.3554 45.2813 25.0663 45.5688C24.7771 45.8563 24.4187 46 23.9913 46ZM11.65 13.75L8.45 10.6C8.15 10.3043 8 9.94708 8 9.52825C8 9.10942 8.15652 8.75 8.46955 8.45C8.75652 8.15 9.1 8 9.5 8C9.9 8 10.25 8.15 10.55 8.45L13.75 11.65C14.05 11.95 14.2 12.3 14.2 12.7C14.2 13.1 14.05 13.45 13.75 13.75C13.4409 14.0167 13.0803 14.15 12.6682 14.15C12.2561 14.15 11.9167 14.0167 11.65 13.75ZM37.45 39.55L34.25 36.35C33.95 36.0567 33.8 35.7083 33.8 35.305C33.8 34.9017 33.95 34.55 34.25 34.25C34.525 33.9833 34.8688 33.85 35.2812 33.85C35.6937 33.85 36.05 33.9833 36.35 34.25L39.6 37.4C39.9 37.7 40.0438 38.0601 40.0315 38.4802C40.0191 38.9003 39.877 39.2586 39.6052 39.5552C39.3086 39.8517 38.9503 40 38.5302 40C38.1101 40 37.75 39.85 37.45 39.55ZM3.5 25.5C3.075 25.5 2.71875 25.3554 2.43125 25.0663C2.14375 24.7771 2 24.4187 2 23.9913C2 23.5638 2.14375 23.2083 2.43125 22.925C2.71875 22.6417 3.075 22.5 3.5 22.5H8C8.425 22.5 8.78125 22.6446 9.06875 22.9338C9.35625 23.2229 9.5 23.5813 9.5 24.0087C9.5 24.4362 9.35625 24.7917 9.06875 25.075C8.78125 25.3583 8.425 25.5 8 25.5H3.5ZM8.45 39.5305C8.15 39.2435 8 38.9 8 38.5C8 38.1 8.15 37.75 8.45 37.45L11.65 34.25C11.925 33.9833 12.2688 33.85 12.6813 33.85C13.0938 33.85 13.45 33.9875 13.75 34.2625C14.05 34.5625 14.2 34.9188 14.2 35.3312C14.2 35.7437 14.05 36.1 13.75 36.4L10.6 39.55C10.3043 39.85 9.94708 40 9.52825 40C9.10942 40 8.75 39.8435 8.45 39.5305ZM24 36C20.6667 36 17.8333 34.8333 15.5 32.5C13.1667 30.1667 12 27.3333 12 24C12 20.6667 13.1667 17.8333 15.5 15.5C17.8333 13.1667 20.6667 12 24 12C27.3333 12 30.1667 13.1667 32.5 15.5C34.8333 17.8333 36 20.6667 36 24C36 27.3333 34.8333 30.1667 32.5 32.5C30.1667 34.8333 27.3333 36 24 36Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function TeachingMaterialsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4352"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4352)">
        <path
          d="M43 32.3499V19.7499L25.4 29.2499C24.9333 29.5166 24.45 29.6416 23.95 29.6249C23.45 29.6082 22.9667 29.4666 22.5 29.1999L4.39999 19.2999C4.13333 19.1332 3.94166 18.9412 3.82499 18.7237C3.70833 18.5062 3.64999 18.2645 3.64999 17.9987C3.64999 17.7328 3.70833 17.4916 3.82499 17.2749C3.94166 17.0582 4.13333 16.8666 4.39999 16.6999L22.5 6.7999C22.7289 6.66657 22.9642 6.56657 23.2059 6.4999C23.4476 6.43324 23.6956 6.3999 23.95 6.3999C24.2044 6.3999 24.4524 6.43324 24.6941 6.4999C24.9358 6.56657 25.1711 6.66657 25.4 6.7999L45.2 17.5499C45.454 17.6785 45.6508 17.8649 45.7905 18.1092C45.9302 18.3535 46 18.617 46 18.8999V32.3499C46 32.7749 45.8554 33.1312 45.5662 33.4187C45.2771 33.7062 44.9187 33.8499 44.4912 33.8499C44.0637 33.8499 43.7083 33.7062 43.425 33.4187C43.1417 33.1312 43 32.7749 43 32.3499ZM22.5 41.1999L11 34.8999C10.5333 34.6332 10.1583 34.2624 9.87499 33.7874C9.59166 33.3124 9.44999 32.7999 9.44999 32.2499V23.5499L22.5 30.6999C22.9552 30.9666 23.4356 31.0999 23.9414 31.0999C24.4471 31.0999 24.9333 30.9666 25.4 30.6999L38.45 23.5499V32.2499C38.45 32.7999 38.3083 33.3124 38.025 33.7874C37.7417 34.2624 37.3667 34.6332 36.9 34.8999L25.4 41.1999C25.1711 41.3332 24.9358 41.4332 24.6941 41.4999C24.4524 41.5666 24.2044 41.5999 23.95 41.5999C23.6956 41.5999 23.4476 41.5666 23.2059 41.4999C22.9642 41.4332 22.7289 41.3332 22.5 41.1999Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function TextilesTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4115"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4115)">
        <path
          d="M41.19 5.49C39.97 4.57 38.29 4 36.45 4C34.61 4 32.93 4.57 31.71 5.49C30.43 6.45 29.64 7.79 29.64 9.28C29.57 10.29 28.95 11.22 28 11.9C27 12.62 25.63 13.07 24.12 13.07C22.61 13.07 21.24 12.63 20.24 11.9C19.3 11.22 18.68 10.29 18.61 9.28C18.61 7.79 17.82 6.45 16.54 5.49C15.32 4.57 13.64 4 11.8 4C9.96 4 8.29 4.57 7.07 5.49C5.79 6.45 5 7.8 5 9.28V38.18C5 39.86 5.77 41.28 7.06 42.25C8.28 43.17 9.96 43.74 11.8 43.74C13.64 43.74 15.32 43.17 16.54 42.25C17.08 41.84 17.54 41.36 17.88 40.84C18.24 41.47 18.75 42.04 19.38 42.51C20.6 43.43 22.28 44 24.12 44C25.96 44 27.64 43.43 28.86 42.51C30.13 41.56 30.91 40.23 30.93 38.76C30.99 37.73 31.61 36.79 32.57 36.1C33.57 35.38 34.95 34.93 36.45 34.93C37.95 34.93 39.33 35.38 40.33 36.1C41.29 36.79 41.9 37.73 41.97 38.76C41.99 39.1 42.27 39.37 42.61 39.37C42.97 39.37 43.26 39.08 43.26 38.72V9.28C43.26 7.79 42.47 6.45 41.19 5.49ZM15.78 41.22C14.77 41.98 13.37 42.45 11.81 42.45C10.25 42.45 8.85 41.98 7.84 41.22C6.93 40.54 6.35 39.61 6.3 38.6V38.3C6.35 37.29 6.93 36.37 7.84 35.68C8.85 34.92 10.25 34.45 11.81 34.45C13.37 34.45 14.77 34.92 15.78 35.68L15.81 35.7C16.75 36.42 17.32 37.39 17.32 38.44C17.32 39.49 16.73 40.49 15.77 41.21L15.78 41.22ZM13.78 36.75C13.27 36.36 12.57 36.12 11.81 36.12C11.05 36.12 10.35 36.36 9.84 36.75C9.28 37.17 8.92 37.78 8.92 38.46C8.92 39.14 9.25 39.71 9.8 40.14L9.84 40.17C10.35 40.56 11.05 40.79 11.81 40.79C12.57 40.79 13.27 40.55 13.78 40.17C14.35 39.74 14.7 39.14 14.7 38.46C14.7 37.78 14.35 37.18 13.78 36.75ZM13.01 39.14C12.71 39.36 12.29 39.5 11.81 39.5C11.33 39.5 10.91 39.36 10.61 39.14L10.58 39.12C10.35 38.94 10.21 38.71 10.21 38.46C10.21 38.21 10.36 37.97 10.61 37.78C10.91 37.56 11.33 37.42 11.81 37.42C12.29 37.42 12.71 37.56 13.01 37.78C13.25 37.96 13.41 38.21 13.41 38.46C13.41 38.71 13.26 38.95 13.01 39.14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function TieDyeTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4248"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4248)">
        <path
          d="M10.91 19.24L7.59997 21.08C7.10997 21.36 6.58997 21.44 6.04997 21.32C5.50997 21.2 5.12997 20.91 4.91997 20.45L1.28997 14.2C1.00997 13.71 0.929972 13.29 1.04997 12.94C1.16997 12.59 1.45997 12.27 1.91997 11.99L13.9 5H18.26C18.65 5 18.95 5.11 19.18 5.34C19.41 5.57 19.52 5.87 19.52 6.26V7.05C19.52 8.38 19.94 9.47 20.78 10.31C21.62 11.15 22.71 11.57 24.04 11.57C25.37 11.57 26.45 11.15 27.27 10.31C28.09 9.47 28.5 8.38 28.5 7.05V6.26C28.5 5.87 28.61 5.57 28.84 5.34C29.07 5.11 29.37 5 29.76 5H34.12L39.55 8.17C37.92 16.23 34.23 15.78 31.46 15.4C26.9 14.23 22.67 15.46 19.53 18.87C17.55 21.02 13.79 21.06 11.25 20C11.13 19.95 11.02 19.94 10.9 19.93V19.25L10.91 19.24ZM10.91 39.25V40.79C10.91 41.35 11.11 41.83 11.51 42.24C11.91 42.65 12.39 42.84 12.96 42.84H24.22C21.03 38.76 15.8 37.32 10.91 39.25ZM33.47 33.68C31.67 33.68 29.95 32.9 28.4 31.37C25.08 28.07 23.17 27.85 19.12 30.3C17.33 31.38 15.14 31.69 13.11 31.13C12.31 30.91 11.57 30.57 10.91 30.12V36.6C17.18 34.56 23.74 36.99 27.24 42.83H34.81C35.37 42.83 35.86 42.63 36.28 42.23C36.7 41.83 36.91 41.35 36.91 40.78V32.73C35.75 33.35 34.6 33.68 33.46 33.68H33.47ZM46.95 12.93C46.84 12.58 46.56 12.26 46.11 11.98L41.83 9.48C39.86 17.84 35.31 18.45 31.06 17.85L30.92 17.82C28.34 17.15 24.59 17.07 21.39 20.54C19.7 22.38 17.22 23.16 14.76 23.16C13.42 23.16 12.1 22.92 10.91 22.51V26.54C11.53 27.59 12.53 28.36 13.77 28.7C15.14 29.08 16.62 28.87 17.82 28.14C22.89 25.08 26 25.44 30.16 29.58C32.01 31.41 33.96 31.65 36.13 30.31L36.37 30.16C36.51 30.08 36.72 29.95 36.91 29.82V19.13L40.17 21.18C40.56 21.42 41.08 21.48 41.75 21.34C42.42 21.2 42.85 20.9 43.06 20.45L46.74 14.2C46.98 13.71 47.06 13.29 46.95 12.94V12.93Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ToolsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3750"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3750)">
        <path
          d="M18.27 29.75C14.86 29.75 11.97 28.56 9.58 26.19C7.19 23.83 6 20.94 6 17.54C6 16.84 6.05 16.18 6.16 15.56C6.27 14.95 6.46 14.3 6.74 13.64C6.85 13.36 7 13.15 7.21 13.01C7.42 12.87 7.65 12.76 7.89 12.69C8.14 12.62 8.38 12.62 8.63 12.69C8.88 12.76 9.1 12.9 9.31 13.11L15.26 19.06L20.11 14.53L13.9 8.32C13.69 8.11 13.55 7.88 13.48 7.64C13.41 7.4 13.41 7.15 13.48 6.9C13.55 6.65 13.66 6.43 13.8 6.24C13.94 6.05 14.15 5.9 14.43 5.79C15.1 5.51 15.73 5.31 16.33 5.18C16.93 5.06 17.58 5 18.28 5C21.76 5 24.71 6.22 27.15 8.66C29.59 11.1 30.81 14.06 30.81 17.53C30.81 18.37 30.72 19.2 30.55 20.01C30.37 20.82 30.15 21.62 29.87 22.43L41.51 34.07C42.46 34.98 42.92 36.1 42.91 37.41C42.9 38.72 42.39 39.84 41.41 40.75C40.5 41.59 39.42 42.01 38.17 41.99C36.92 41.97 35.84 41.51 34.93 40.59L23.18 28.79C22.37 29.07 21.57 29.3 20.76 29.47C19.95 29.64 19.13 29.73 18.28 29.73L18.27 29.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UpcyclingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3811"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3811)">
        <path
          d="M23.2 41.1101C21.8 41.1101 20.49 40.9801 19.27 40.7101C18.05 40.4401 16.93 40.0401 15.89 39.5101C17.46 35.2601 18.35 32.6301 20.2 28.9101C22.05 25.1901 26.07 20.7301 29.2 18.2301C25.47 20.0301 20.13 22.1801 17.38 25.3801C14.63 28.5801 13.39 32.9901 12.39 37.0501C12.26 36.9201 12.13 36.8001 12.01 36.7001C11.89 36.6001 11.77 36.4801 11.63 36.3501C10.13 34.8501 8.97998 33.1301 8.17998 31.2001C7.37998 29.2701 6.97998 27.2301 6.97998 25.1001C6.97998 22.8001 7.40998 20.5801 8.27998 18.4501C9.14998 16.3201 10.4 14.4301 12.03 12.8001C14.62 10.1701 17.95 8.47006 22.05 7.68006C26.15 6.90006 32.28 6.79006 40.45 7.36006C41.08 15.2901 40.99 21.3801 40.18 25.6101C39.36 29.8401 37.62 33.2901 34.95 35.9601C33.35 37.6301 31.53 38.9001 29.5 39.7901C27.47 40.6701 25.37 41.1101 23.2 41.1101Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function UpholsteryTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3768"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3768)">
        <path
          d="M9.65 42.05C9.22 42.05 8.86 41.91 8.58 41.62C8.3 41.34 8.15 40.98 8.15 40.55V38.4H7.2C5.7 38.4 4.46 37.86 3.48 36.78C2.5 35.7 2 34.4 2 32.9V20.8C2 19.77 2.34 18.87 3.02 18.12C3.7 17.37 4.55 17 5.55 17C6.55 17 7.39 17.38 8.07 18.12C8.75 18.86 9.1 19.76 9.1 20.8V29.45H38.9V20.8C38.9 19.77 39.24 18.87 39.93 18.12C40.61 17.37 41.45 17 42.45 17C43.45 17 44.29 17.38 44.98 18.12C45.67 18.86 46 19.76 46 20.8V32.9C46 34.4 45.51 35.69 44.52 36.78C43.54 37.86 42.31 38.4 40.85 38.4H39.85V40.55C39.85 40.98 39.71 41.34 39.42 41.62C39.14 41.9 38.78 42.05 38.35 42.05C37.92 42.05 37.56 41.91 37.27 41.62C36.99 41.34 36.85 40.98 36.85 40.55V38.4H11.15V40.55C11.15 40.98 11.01 41.34 10.73 41.62C10.45 41.9 10.09 42.05 9.65 42.05ZM12.1 26.45V20.8C12.1 19.2 11.66 17.77 10.77 16.52C9.89 15.27 8.7 14.48 7.2 14.14V11.14C7.2 9.73999 7.67 8.52999 8.6 7.51999C9.53 6.50999 10.7 5.98999 12.1 5.98999H35.9C37.3 5.98999 38.48 6.49999 39.43 7.51999C40.38 8.53999 40.86 9.73999 40.86 11.14V14.14C39.36 14.51 38.16 15.31 37.26 16.56C36.36 17.81 35.91 19.22 35.91 20.79V26.44H12.1V26.45Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function VevorTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4314"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4314)">
        <path
          d="M7.6 13.46C7.12 12.78 7.28 11.85 7.96 11.37C8.75 10.82 9.58 10.32 10.43 9.89C11.17 9.52 12.07 9.82 12.44 10.57C12.81 11.31 12.51 12.21 11.76 12.58C11.04 12.94 10.34 13.36 9.68 13.82C9.42 14.01 9.12 14.09 8.82 14.09C8.35 14.09 7.89 13.87 7.59 13.46H7.6ZM2.53 20.64C2.74 20.74 2.96 20.79 3.17 20.79C3.73 20.79 4.27 20.47 4.52 19.94C4.87 19.21 5.27 18.51 5.73 17.84C6.2 17.16 6.02 16.22 5.34 15.76C4.66 15.3 3.72 15.47 3.26 16.15C2.72 16.94 2.23 17.79 1.82 18.65C1.46 19.4 1.78 20.29 2.53 20.65V20.64ZM1.64 29.39C2.47 29.33 3.09 28.62 3.03 27.79C3.01 27.44 2.99 27.08 2.99 26.72C2.99 26.26 3.01 25.81 3.05 25.37C3.12 24.54 2.51 23.82 1.68 23.75C0.86 23.7 0.13 24.29 0.06 25.12C0.02 25.65 0 26.19 0 26.71C0 27.14 0.01 27.57 0.04 27.99C0.09 28.78 0.75 29.39 1.53 29.39C1.56 29.39 1.6 29.39 1.63 29.39H1.64ZM47.02 2V21.46H40.2V29.13C40.2 29.96 39.95 30.78 39.48 31.47L36.97 35.15C36.56 35.76 35.99 36.23 35.35 36.54C31.99 42.19 25.83 46 18.79 46C11.75 46 4.8 41.9 1.52 35.3C1.18 34.61 1.28 33.81 1.7 33.23C1.85 32.92 2.09 32.66 2.43 32.51C2.75 32.36 3.09 32.34 3.41 32.42C4.11 32.46 4.77 32.85 5.1 33.52C5.17 33.66 5.25 33.8 5.33 33.94C8 38.92 13.11 42.01 18.79 42.01C23.72 42.01 28.11 39.65 30.9 36.01C30.61 35.77 30.34 35.49 30.12 35.16L27.61 31.48C27.14 30.79 26.89 29.98 26.89 29.14V21.47H20.07V10.91C19.92 10.95 19.77 10.97 19.61 10.97C19.32 10.95 19.04 10.95 18.74 10.95C18.22 10.95 17.7 10.98 17.18 11.03C17.13 11.03 17.08 11.03 17.03 11.03C16.27 11.03 15.62 10.45 15.54 9.68C15.46 8.86 16.06 8.12 16.88 8.04C17.52 7.97 18.13 7.94 18.79 7.95C19.11 7.95 19.44 7.95 19.76 7.98C19.86 7.98 19.97 8 20.06 8.03V2H47.02ZM36.05 13.61H31.03V29.13L33.54 32.81L36.05 29.13V13.61Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function VinylTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4236"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4236)">
        <path
          d="M38.14 9.86C34.39 6.11 29.3 4 24 4C18.7 4 13.61 6.11 9.86 9.86C6.11 13.61 4 18.7 4 24C4 29.3 6.11 34.39 9.86 38.14C13.61 41.89 18.7 44 24 44C24.18 44 24.35 43.97 24.51 43.9C24.67 43.83 24.82 43.74 24.94 43.61L43.61 24.94C43.73 24.82 43.83 24.67 43.9 24.51C43.97 24.35 44 24.17 44 24C44 18.7 41.89 13.61 38.14 9.86ZM26.27 38.52C27.02 35.45 28.6 32.65 30.83 30.41C33.07 28.18 35.87 26.61 38.95 25.86L26.27 38.51V38.52ZM30.29 27.35L29.9 26.18C29.87 26.09 29.87 25.99 29.9 25.89C29.93 25.8 29.99 25.72 30.07 25.66L33.32 23.22C33.86 22.83 34.25 22.28 34.46 21.65C34.66 21.02 34.66 20.34 34.46 19.72C34.25 19.09 33.86 18.54 33.32 18.15C32.78 17.76 32.14 17.55 31.48 17.55H27.36C27.26 17.55 27.17 17.52 27.09 17.46C27.01 17.4 26.95 17.32 26.92 17.23L25.59 13.23C25.39 12.6 24.99 12.04 24.45 11.65C23.91 11.26 23.27 11.05 22.6 11.05C21.93 11.05 21.29 11.26 20.75 11.65C20.21 12.04 19.81 12.6 19.61 13.23L18.28 17.23C18.25 17.32 18.19 17.4 18.11 17.46C18.03 17.52 17.94 17.55 17.84 17.55H13.79C13.13 17.55 12.49 17.77 11.97 18.17C11.44 18.56 11.05 19.11 10.85 19.74C10.65 20.37 10.65 21.04 10.85 21.67C11.05 22.29 11.45 22.84 11.98 23.23L15.34 25.67C15.42 25.73 15.48 25.81 15.51 25.9C15.54 25.99 15.54 26.09 15.51 26.19L14.18 30.12C13.97 30.75 13.97 31.43 14.18 32.06C14.38 32.69 14.78 33.24 15.32 33.63C15.86 34.02 16.5 34.23 17.17 34.23C17.83 34.23 18.48 34.02 19.01 33.63L22.37 31.19C22.45 31.13 22.55 31.1 22.65 31.1C22.75 31.1 22.85 31.13 22.93 31.19L25.52 33.07C24.13 35.62 23.32 38.45 23.15 41.35C18.7 41.13 14.5 39.21 11.43 35.99C8.36 32.76 6.65 28.48 6.65 24.02C6.49 19.42 8.16 14.95 11.3 11.59C14.44 8.23 18.78 6.25 23.38 6.08C27.98 5.92 32.45 7.59 35.82 10.73C39.18 13.87 41.16 18.21 41.33 22.81C37.27 23.16 33.42 24.76 30.29 27.37V27.35Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function WaterslideDecalTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3970"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3970)">
        <path
          d="M12.7197 44C11.9497 44 11.2797 43.75 10.6897 43.25C10.1097 42.75 9.77971 42.12 9.71971 41.35L6.01971 7.7C5.91971 6.7 6.19971 5.83 6.86971 5.1C7.53971 4.37 8.36971 4 9.36971 4H37.8697C38.8697 4 39.6997 4.37 40.3697 5.1C41.0397 5.83 41.3197 6.7 41.2197 7.7L37.5197 41.35C37.4497 42.12 37.1297 42.75 36.5497 43.25C35.9697 43.75 35.2897 44 34.5197 44H12.7197ZM9.96971 16H37.2697L38.2697 7H8.96971L9.96971 16ZM23.6197 38.35C25.1197 38.35 26.3897 37.83 27.4397 36.8C28.4897 35.77 29.0097 34.52 29.0097 33.05C29.0097 31.35 28.5697 29.73 27.6897 28.2C26.8097 26.67 25.8097 25.32 24.7197 24.15C24.5497 23.98 24.3797 23.87 24.1897 23.8C24.0097 23.73 23.8097 23.7 23.6197 23.7C23.4297 23.7 23.2297 23.73 23.0497 23.8C22.8697 23.87 22.6897 23.98 22.5197 24.15C21.4197 25.32 20.4297 26.67 19.5497 28.2C18.6697 29.73 18.2297 31.35 18.2297 33.05C18.2297 34.52 18.7497 35.77 19.7997 36.8C20.8497 37.83 22.1197 38.35 23.6197 38.35Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function WeRTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4072"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4072)">
        <path
          d="M16.3 44H12.39C11.29 44 10.39 43.1 10.39 42V38.9H6.5C5.67 38.9 5 38.23 5 37.4C5 36.57 5.67 35.9 6.5 35.9H10.38V30.02H6.5C5.67 30.02 5 29.35 5 28.52C5 27.69 5.67 27.02 6.5 27.02H10.38V20.98H6.5C5.67 20.98 5 20.31 5 19.48C5 18.65 5.67 17.98 6.5 17.98H10.38V12.1H6.5C5.67 12.1 5 11.43 5 10.6C5 9.77 5.67 9.1 6.5 9.1H10.38V6C10.38 4.9 11.28 4 12.38 4H16.29V44H16.3ZM40.72 4H18.3V44H40.73C41.83 44 42.73 43.1 42.73 42V6C42.73 4.9 41.83 4 40.73 4H40.72Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function WeavingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4272"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4272)">
        <path
          d="M16.38 44H12.17V37.52H16.38V44ZM16.38 4H12.17V10.48H16.38V4ZM16.38 18.06H12.17V29.94H16.38V18.06ZM26.1 4H21.89V20.21H26.1V4ZM26.1 27.79H21.89V44H26.1V27.79ZM35.83 18.06H31.62V29.94H35.83V18.06ZM35.83 37.52H31.62V44H35.83V37.52ZM35.83 4H31.62V10.48H35.83V4ZM44 12.17H27.79V16.38H44V12.17ZM20.21 12.17H4V16.38H20.21V12.17ZM44 21.89H37.52V26.1H44V21.89ZM29.94 21.89H18.06V26.1H29.94V21.89ZM10.48 21.89H4V26.1H10.48V21.89ZM20.21 31.62H4V35.83H20.21V31.62ZM44 31.62H27.79V35.83H44V31.62Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function WoodCraftTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4029"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4029)">
        <path
          d="M42.91 27.08C42.91 26.02 42.92 24.96 42.92 23.89H42.93V19.67C42.92 16.56 42.91 13.45 42.95 10.34H42.94C42.91 5.1 34.6 1 24 1C13.4 1 5.45 4.93 5.08 10.01H5C5.02 18.83 5.02 27.66 5 36.48C5 38.12 5.54 39.49 6.67 40.67C8.07 42.13 9.85 43.21 12.27 44.05C15.95 45.32 19.74 45.96 23.74 45.96C24.58 45.96 25.44 45.92 26.3 45.86V32.5C26.3 31.67 26.97 31 27.8 31C28.63 31 29.3 31.67 29.3 32.5V45.56C30.04 45.46 30.78 45.34 31.53 45.2C33.26 44.88 34.79 44.45 36.17 43.91V25.4C36.17 24.57 36.84 23.9 37.67 23.9C38.5 23.9 39.17 24.57 39.17 25.4V42.38C39.43 42.21 39.68 42.04 39.93 41.86C42.02 40.34 43.01 38.4 42.95 35.94C42.88 32.99 42.89 29.98 42.91 27.08ZM13.9 31.24C13.9 32.07 13.23 32.74 12.4 32.74C11.57 32.74 10.9 32.07 10.9 31.24V19.18C10.9 18.35 11.57 17.68 12.4 17.68C13.23 17.68 13.9 18.35 13.9 19.18V31.24ZM21.22 41.12C21.22 41.95 20.55 42.62 19.72 42.62C18.89 42.62 18.22 41.95 18.22 41.12V36.32C18.22 35.49 18.89 34.82 19.72 34.82C20.55 34.82 21.22 35.49 21.22 36.32V41.12ZM21.22 29.64C21.22 30.47 20.55 31.14 19.72 31.14C18.89 31.14 18.22 30.47 18.22 29.64V21.63C18.22 20.8 18.89 20.13 19.72 20.13C20.55 20.13 21.22 20.8 21.22 21.63V29.64ZM33.45 15.65C32.44 15.94 32.36 16.56 32.01 19.2C31.83 20.58 31.38 24 30.85 25.2C29.73 24.55 28.78 21.2 28.4 19.86C27.9 18.1 27.57 16.92 26.34 16.92C26.3 16.92 26.27 16.92 26.23 16.92C25.56 16.96 24.87 16.96 23.99 16.96C14.46 16.96 7.82 13.48 7.82 10.37C7.82 7.26 14.46 3.78 23.99 3.78C33.52 3.78 40.16 7.26 40.16 10.37C40.16 12.52 37.71 14.44 33.45 15.65ZM23.19 14.12C17.97 14.12 11.87 12.97 11.87 9.73C11.87 6.74 16.89 5.79 19.89 5.5C20.71 5.4 21.45 6.02 21.53 6.84C21.61 7.66 21.01 8.4 20.19 8.48C17.43 8.76 15.82 9.33 15.15 9.73C16.13 10.32 18.92 11.12 23.2 11.12C24.39 11.12 25.55 11.06 26.65 10.93C27.46 10.84 28.22 11.42 28.31 12.25C28.41 13.07 27.82 13.82 26.99 13.91C25.78 14.05 24.5 14.12 23.19 14.12ZM32.44 12.88C31.68 12.88 31.03 12.3 30.95 11.53C30.87 10.71 31.47 9.97 32.29 9.89C33.14 9.81 33.58 9.68 33.81 9.6C33.07 9.2 31.07 8.67 28.08 8.67C27.2 8.67 26.35 8.72 25.54 8.81C24.71 8.91 23.97 8.32 23.88 7.49C23.78 6.67 24.37 5.92 25.2 5.83C26.12 5.72 27.09 5.67 28.08 5.67C29.56 5.67 36.93 5.85 36.93 9.34C36.93 11.55 35.67 12.58 32.59 12.88C32.54 12.88 32.49 12.88 32.44 12.88Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function WreathMakingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4278"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4278)">
        <path
          d="M30.1699 41.7V33.85C31.7999 33.77 33.2999 34.16 34.7599 34.74C37.4999 35.83 39.4999 37.8 41.0999 40.22C41.6099 40.99 41.1999 41.72 40.2499 41.74C39.4499 41.76 38.6499 41.74 37.8599 41.66C37.1099 41.57 36.8799 41.86 36.9099 42.57C36.9399 43.45 36.8799 44.33 36.8799 45.21C36.8799 45.74 36.7799 46.32 36.1899 46.34C35.8299 46.35 35.3099 46.02 35.1199 45.69C33.9599 43.76 32.5099 42.22 30.1899 41.7H30.1699ZM18.4799 33.84C13.8399 34.12 10.4999 36.52 8.0199 40.29C7.5399 41.01 7.9899 41.72 8.9099 41.74C9.7299 41.76 10.5599 41.73 11.3799 41.66C11.9599 41.61 12.2499 41.74 12.2399 42.4C12.2199 43.39 12.2099 44.39 12.3199 45.37C12.3599 45.73 12.6799 46.21 12.9899 46.33C13.2299 46.42 13.7999 46.12 13.9599 45.84C15.1299 43.82 16.6199 42.22 18.9699 41.69V33.88C18.7499 33.87 18.6099 33.85 18.4699 33.85L18.4799 33.84ZM20.9599 41.51C20.9699 42.46 21.3999 42.96 22.3299 42.98C23.8199 43.02 25.3199 43.02 26.8099 42.98C27.7399 42.95 28.1899 42.46 28.1999 41.52C28.2099 38.96 28.2099 36.4 28.1999 33.84C28.1999 32.8 27.7299 32.33 26.6899 32.32C25.2899 32.3 23.8899 32.3 22.4899 32.32C21.4199 32.34 20.9699 32.81 20.9599 33.92C20.9599 35.14 20.9499 40.2 20.9599 41.51ZM44.1299 27.8C44.3999 29.68 43.6699 31.29 41.9899 32.31C41.8899 32.37 41.7999 32.43 41.7099 32.49C41.6799 32.75 41.6599 33.02 41.6499 33.29C41.5999 34.56 40.9199 35.52 39.9899 36.26C39.6899 36.03 37.3899 33.92 35.0099 32.84C32.6299 31.75 30.1599 31.69 29.5399 31.56C29.6499 31.56 29.7499 31.57 29.8499 31.56C29.7899 31.55 29.7299 31.53 29.6699 31.52C30.2999 30.78 31.0999 30.25 32.0399 29.94C32.1599 29.7 32.2799 29.45 32.3899 29.18C32.6099 28.66 33.0199 28.21 33.4699 27.8C33.6599 26.82 34.0999 25.95 34.7599 25.18C34.7499 24.4 34.8199 23.62 34.9599 22.84C34.5799 21.87 34.5199 20.85 34.6899 19.83C34.0899 19.13 33.6999 18.34 33.5199 17.45C32.7899 16.8 32.2599 16.01 31.9399 15.07C31.2499 14.69 30.5799 14.23 29.9699 13.71C28.9699 13.54 28.0599 13.13 27.2799 12.46C26.3499 12.66 25.4499 12.56 24.5799 12.27C23.7099 12.56 22.8099 12.65 21.8799 12.46C21.0999 13.13 20.1899 13.54 19.1899 13.71C18.5899 14.23 17.9199 14.68 17.2199 15.07C16.8999 16.01 16.3699 16.81 15.6399 17.45C15.4599 18.34 15.0599 19.13 14.4699 19.83C14.6499 20.86 14.5799 21.87 14.1999 22.84C14.3399 23.61 14.4099 24.4 14.3999 25.18C15.0599 25.96 15.4999 26.82 15.6899 27.8C16.1299 28.21 16.5499 28.67 16.7699 29.18C16.8799 29.45 16.9999 29.7 17.1199 29.94C18.0699 30.25 18.8699 30.78 19.4899 31.52C19.4299 31.53 19.3699 31.55 19.3099 31.56C19.4099 31.56 19.5099 31.56 19.6199 31.56C19.0199 31.69 16.7399 31.67 14.4499 32.7C11.9599 33.83 9.4699 36.02 9.1699 36.26C8.2399 35.53 7.5499 34.56 7.5099 33.29C7.5099 33.02 7.4799 32.75 7.4499 32.49C7.3599 32.43 7.2599 32.36 7.1699 32.31C5.4899 31.29 4.7599 29.68 5.0299 27.8C3.9199 26.58 3.7099 24.62 4.5099 23.12C4.6099 22.94 4.6899 22.76 4.7699 22.58C4.7199 22.48 4.6699 22.37 4.6199 22.27C3.7099 20.55 3.8699 18.74 5.0299 17.31C4.7199 15.61 5.5099 13.87 7.0199 12.93C7.1599 12.84 7.2899 12.75 7.4199 12.66C7.4299 12.51 7.4499 12.37 7.4499 12.22C7.5299 10.35 8.5999 8.83998 10.2899 8.21998C10.9099 6.55998 12.4699 5.45998 14.2899 5.40998C14.4199 5.40998 14.5399 5.40998 14.6699 5.38998C14.7399 5.28998 14.8099 5.18998 14.8699 5.08998C15.8899 3.46998 17.5399 2.69998 19.3599 2.99998C20.7799 1.85998 22.5799 1.67998 24.2599 2.56998C24.3699 2.62998 24.4799 2.67998 24.5899 2.72998C24.6999 2.67998 24.8099 2.61998 24.9199 2.56998C26.5999 1.68998 28.4099 1.85998 29.8199 2.99998C31.6399 2.69998 33.2999 3.46998 34.3099 5.08998C34.3699 5.18998 34.4399 5.28998 34.5099 5.38998C34.6399 5.38998 34.7599 5.40998 34.8899 5.40998C36.7099 5.44998 38.2699 6.54998 38.8899 8.21998C40.5799 8.83998 41.6499 10.35 41.7299 12.22C41.7299 12.37 41.7499 12.52 41.7599 12.66C41.8899 12.75 42.0199 12.84 42.1599 12.93C43.6699 13.87 44.4599 15.6 44.1499 17.31C45.3099 18.75 45.4699 20.55 44.5599 22.27C44.5099 22.37 44.4499 22.48 44.3999 22.58C44.4799 22.76 44.5699 22.94 44.6599 23.12C45.4599 24.62 45.2499 26.58 44.1399 27.8H44.1299ZM11.9599 23.21C11.9599 21.94 10.9299 20.9 9.6499 20.9C8.3699 20.9 7.3399 21.93 7.3399 23.21C7.3399 24.49 8.3699 25.52 9.6499 25.52C10.9299 25.52 11.9599 24.49 11.9599 23.21ZM16.1799 11.9C16.1799 10.63 15.1499 9.58998 13.8699 9.58998C12.5899 9.58998 11.5599 10.62 11.5599 11.9C11.5599 13.18 12.5899 14.21 13.8699 14.21C15.1499 14.21 16.1799 13.18 16.1799 11.9ZM26.8699 7.23998C26.8699 5.96998 25.8399 4.92998 24.5599 4.92998C23.2799 4.92998 22.2499 5.95998 22.2499 7.23998C22.2499 8.51998 23.2799 9.54998 24.5599 9.54998C25.8399 9.54998 26.8699 8.51998 26.8699 7.23998ZM37.5599 11.9C37.5599 10.63 36.5299 9.58998 35.2499 9.58998C33.9699 9.58998 32.9399 10.62 32.9399 11.9C32.9399 13.18 33.9699 14.21 35.2499 14.21C36.5299 14.21 37.5599 13.18 37.5599 11.9ZM41.7899 23.21C41.7899 21.94 40.7599 20.9 39.4799 20.9C38.1999 20.9 37.1699 21.93 37.1699 23.21C37.1699 24.49 38.1999 25.52 39.4799 25.52C40.7599 25.52 41.7899 24.49 41.7899 23.21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function XyronTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4308"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <path d="M0 0H48V48H0V0Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4308)">
        <path
          d="M38.14 9.86C34.39 6.11 29.3 4 24 4C18.7 4 13.61 6.11 9.86 9.86C6.11 13.61 4 18.7 4 24C4 29.3 6.11 34.39 9.86 38.14C13.61 41.89 18.7 44 24 44C24.18 44 24.35 43.97 24.51 43.9C24.67 43.83 24.82 43.74 24.94 43.61L43.61 24.94C43.73 24.82 43.83 24.67 43.9 24.51C43.97 24.35 44 24.17 44 24C44 18.7 41.89 13.61 38.14 9.86ZM26.27 38.52C27.02 35.45 28.6 32.65 30.83 30.41C33.07 28.18 35.87 26.61 38.95 25.86L26.27 38.51V38.52ZM35.11 24.53C36.4 23.18 37.08 21.36 36.99 19.49C36.89 17.57 36.01 15.83 34.51 14.59C33.35 13.64 31.86 13.12 30.31 13.12C28.41 13.12 26.53 13.9 25.17 15.26L24 16.43L22.83 15.26C21.46 13.9 19.59 13.12 17.69 13.12C16.14 13.12 14.64 13.64 13.49 14.59C11.98 15.83 11.1 17.58 11.01 19.5C10.92 21.4 11.64 23.27 13 24.61L22.81 34.37C23.14 34.7 23.58 34.87 24.01 34.87C24.28 34.87 24.54 34.8 24.78 34.68C23.67 37.22 23.26 39.67 23.16 41.33C18.71 41.11 14.51 39.19 11.44 35.97C8.37 32.74 6.66 28.46 6.66 24C6.5 19.4 8.17 14.93 11.31 11.57C14.45 8.21 18.79 6.23 23.39 6.06C27.99 5.9 32.46 7.57 35.83 10.71C39.19 13.85 41.17 18.19 41.34 22.79C39.33 22.96 37.24 23.53 35.12 24.53H35.11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function SupportTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M47.886 14.3653C47.886 11.8238 47.886 8.56395 47.1314 5.80139C47.1853 5.91189 47.2392 5.96714 47.2931 6.07764C46.3229 2.92832 44.706 0.221005 40.7176 0C29.4531 0.110503 18.1885 0.0552512 6.92395 0.386759C-0.891168 0.607764 0.0789868 9.17172 0.0789868 14.8073C0.0789868 18.6197 0.0789868 22.432 0.0789868 26.2996C-0.352192 31.6037 0.83355 39.2284 7.35513 39.3942C10.3734 39.4494 13.4455 39.3942 16.4638 39.3942C16.4099 41.107 16.3021 42.9303 16.7333 44.4773C17.38 46.9636 19.2126 49.2289 21.6918 47.2399C24.0633 45.3613 26.2192 43.096 28.429 41.107C30.2615 39.4494 30.4232 39.3942 32.9025 39.3942C35.7052 39.3942 38.6156 39.5599 41.4183 39.3942C45.4606 39.1732 47.7782 35.8028 47.9399 31.88C48.1016 26.0234 47.886 20.1667 47.886 14.3653Z"
        fill="currentColor"
      />
      <path
        d="M20.8438 25.8765V25.5256C20.8528 23.8973 21.0058 22.6018 21.3026 21.6392C21.6085 20.6767 22.0403 19.903 22.5981 19.3182C23.1559 18.7245 23.8351 18.1802 24.6357 17.6854C25.1845 17.3436 25.6748 16.9702 26.1066 16.5654C26.5474 16.1516 26.8938 15.6928 27.1457 15.189C27.3976 14.6762 27.5235 14.1049 27.5235 13.4752C27.5235 12.7645 27.3571 12.1482 27.0242 11.6265C26.6914 11.1047 26.2416 10.6999 25.6748 10.412C25.117 10.1241 24.4918 9.98016 23.7991 9.98016C23.1604 9.98016 22.5531 10.1196 21.9774 10.3985C21.4106 10.6684 20.9383 11.0822 20.5605 11.64C20.1916 12.1887 19.9847 12.8859 19.9397 13.7316H15.1357C15.1807 12.0223 15.5945 10.5919 16.3772 9.44039C17.1689 8.28887 18.2124 7.42523 19.5079 6.84948C20.8124 6.27372 22.2517 5.98584 23.8261 5.98584C25.5444 5.98584 27.0557 6.28721 28.3602 6.88996C29.6736 7.49271 30.6947 8.35184 31.4234 9.46737C32.1611 10.5739 32.5299 11.8874 32.5299 13.4077C32.5299 14.4333 32.3635 15.3509 32.0306 16.1606C31.7068 16.9702 31.2435 17.6899 30.6407 18.3196C30.038 18.9494 29.3228 19.5116 28.4951 20.0064C27.7664 20.4562 27.1682 20.9241 26.7004 21.4098C26.2416 21.8956 25.8997 22.4669 25.6748 23.1236C25.4589 23.7714 25.3464 24.572 25.3374 25.5256V25.8765H20.8438ZM23.1919 34.2969C22.3822 34.2969 21.685 34.009 21.1002 33.4333C20.5155 32.8575 20.2231 32.1558 20.2231 31.3282C20.2231 30.5185 20.5155 29.8258 21.1002 29.25C21.685 28.6743 22.3822 28.3864 23.1919 28.3864C23.9925 28.3864 24.6852 28.6743 25.27 29.25C25.8637 29.8258 26.1606 30.5185 26.1606 31.3282C26.1606 31.8769 26.0212 32.3762 25.7423 32.826C25.4724 33.2759 25.1125 33.6357 24.6627 33.9056C24.2219 34.1665 23.7316 34.2969 23.1919 34.2969Z"
        fill="#DAE7F7"
      />
    </svg>
  )
}

export function HalloweenIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '50'}
      viewBox="0 0 48 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.9688 0C24.4122 7.44022e-05 24.5926 1.26343 24.8633 2.25586C25.1192 3.1943 25.779 6.55024 26.5361 7.52441C27.5437 7.91743 28.5019 8.53964 29.3926 9.35938C30.2699 9.02187 31.1857 8.8418 32.1279 8.8418C34.0174 8.8418 35.8012 9.5619 37.3789 10.8379C42.9335 11.1487 47.375 18.2557 47.375 26.9775C47.375 35.0879 43.5342 41.8007 38.5293 42.9521C36.6926 44.8876 34.4931 46.0146 32.1279 46.0146C31.2349 46.0146 30.3656 45.8539 29.5303 45.5498C27.8868 47.1123 26.0059 47.9999 24.0068 48C22.0468 48 20.2005 47.1465 18.5801 45.6406C17.8263 45.8855 17.0461 46.0146 16.2471 46.0146C13.882 46.0145 11.6823 44.8876 9.8457 42.9521C4.84097 41.8005 1.00005 35.0877 1 26.9775C1.00005 18.2564 5.4411 11.1497 10.9951 10.8379C12.5729 9.56158 14.3574 8.84188 16.2471 8.8418C17.0966 8.8418 17.9249 8.98867 18.7227 9.26465C19.5387 8.53174 20.4109 7.96409 21.3242 7.58496C21.4049 6.52656 21.2004 5.20711 20.2617 3.96973C19.8106 3.51854 19.1072 2.59849 19.54 1.80469C20.0814 0.812258 21.5252 0 22.9688 0ZM11.5449 28.3838C11.1811 28.1636 10.7043 28.4247 10.7471 28.8467C11.1896 33.1878 13.7295 36.9116 17.3418 38.9961C17.5853 39.1366 17.89 38.9863 17.9365 38.71L18.2803 36.6572L21.124 37.3779L20.2998 39.8105C20.225 40.0311 20.3485 40.2699 20.5742 40.3301C21.6735 40.622 22.8289 40.7783 24.0205 40.7783C25.2627 40.7783 26.4655 40.6084 27.6064 40.292C27.8246 40.2314 27.9466 40.0032 27.8818 39.7871L27.1748 37.4297L29.916 36.709L30.2119 38.6406C30.255 38.9217 30.564 39.0755 30.8096 38.9307C34.2534 36.899 36.7017 33.3693 37.248 29.2422C37.3027 28.8269 36.8445 28.5517 36.4756 28.7529C35.537 29.265 34.4919 29.7173 33.3613 30.1006C32.9741 30.232 32.7595 30.6514 32.8926 31.0381L33.6396 33.2061L30.8467 33.8242L30.3936 31.6348C30.3129 31.2462 29.933 30.9962 29.542 31.0645C28.2788 31.2848 26.9522 31.4273 25.582 31.4814C25.3455 31.4912 25.1622 31.6936 25.1807 31.9287L25.417 34.9062H22.5723L22.7822 31.8896C22.7982 31.6593 22.621 31.4606 22.3896 31.4463C21.1054 31.367 19.863 31.2103 18.6797 30.9844C18.4496 30.9408 18.2267 31.0923 18.1875 31.3223L17.7627 33.8242L14.9697 33.1543L15.7461 30.6797C15.8142 30.4624 15.6925 30.2318 15.4756 30.1602C14.011 29.6767 12.6864 29.0767 11.5449 28.3838ZM24.3945 25.333C24.1144 24.864 23.4343 24.8638 23.1543 25.333L21.4355 28.2139C21.1486 28.6949 21.4956 29.3055 22.0557 29.3057H25.4932C26.0534 29.3057 26.4003 28.695 26.1133 28.2139L24.3945 25.333ZM31.4043 18.1094C31.0323 17.6971 30.3531 17.8418 30.1816 18.3701L27.9521 25.2412C27.7808 25.7695 28.2459 26.2852 28.7891 26.1699L35.8555 24.665C36.3986 24.5491 36.6129 23.8883 36.2412 23.4756L31.4043 18.1094ZM17.5469 18.3594C17.3719 17.8324 16.6926 17.6919 16.3232 18.1064L11.5195 23.5029C11.1505 23.9179 11.3693 24.5769 11.9131 24.6895L18.9873 26.1514C19.5315 26.2638 19.9941 25.7443 19.8193 25.2168L17.5469 18.3594Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function SellingOnEtsyIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '38'}
      height={props.height ?? '38'}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.07847 33.0622C6.4446 33.0622 5.88997 32.8245 5.41457 32.3491C4.93916 31.8737 4.70146 31.319 4.70146 30.6852V17.2551C3.96195 16.6212 3.47334 15.8421 3.23564 14.9177C2.99794 13.9933 3.02435 13.0689 3.31488 12.1445L5.0184 6.79624C5.22969 6.08314 5.59944 5.52851 6.12767 5.13234C6.65589 4.73617 7.26335 4.53809 7.95004 4.53809H29.8581C30.5976 4.53809 31.2447 4.74277 31.7993 5.15215C32.354 5.56152 32.7369 6.10955 32.9482 6.79624L34.6914 12.1445C34.9819 13.0689 35.0017 13.9933 34.7508 14.9177C34.4999 15.8421 34.0047 16.6212 33.2652 17.2551V30.6852C33.2652 31.319 33.0275 31.8737 32.5521 32.3491C32.0767 32.8245 31.522 33.0622 30.8882 33.0622H7.07847ZM22.5686 16.0269C23.3346 16.0269 23.9816 15.776 24.5098 15.2742C25.0381 14.7724 25.2494 14.165 25.1437 13.4519L24.1533 6.91509H20.1916V13.4519C20.1916 14.1386 20.4161 14.7394 20.8651 15.2544C21.3141 15.7694 21.8819 16.0269 22.5686 16.0269ZM15.1603 16.0269C15.8998 16.0269 16.5271 15.776 17.0421 15.2742C17.5571 14.7724 17.8146 14.165 17.8146 13.4519V6.91509H13.8529L12.8625 13.4519C12.7569 14.1386 12.9418 14.7394 13.4172 15.2544C13.8926 15.7694 14.4736 16.0269 15.1603 16.0269ZM7.95004 16.0269C8.58391 16.0269 9.13194 15.8091 9.59414 15.3733C10.0563 14.9375 10.327 14.4027 10.4063 13.7688L11.4363 6.91509H7.47464L5.65227 12.6991C5.38815 13.5179 5.4938 14.2772 5.9692 14.9771C6.4446 15.677 7.10488 16.0269 7.95004 16.0269ZM30.0166 16.0269C30.8617 16.0269 31.5286 15.6836 32.0172 14.9969C32.5058 14.3102 32.6181 13.5443 32.354 12.6991L30.5316 6.91509H26.5699L27.6 13.7688C27.6792 14.4027 27.9499 14.9375 28.4121 15.3733C28.8743 15.8091 29.4091 16.0269 30.0166 16.0269Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function PrintingOnDemandIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '40'}
      height={props.height ?? '38'}
      viewBox="0 0 40 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.6716 9.30829C39.5734 8.99599 39.3236 8.71047 38.922 8.46063L28.1791 2.1969H25.1632C24.8153 2.1969 24.5476 2.29505 24.3424 2.50027C24.1371 2.70549 24.039 2.9821 24.039 3.32116V4.02605C24.039 5.22169 23.6732 6.19427 22.9326 6.94377C22.192 7.69328 21.2283 8.07696 20.0327 8.07696C18.8371 8.07696 17.8645 7.7022 17.115 6.94377C16.3655 6.19427 15.9818 5.21277 15.9818 4.02605V3.32116C15.9818 2.97317 15.8836 2.70549 15.6784 2.50027C15.4732 2.29505 15.1966 2.1969 14.8575 2.1969H11.8417L1.10766 8.46063C0.697216 8.71047 0.438458 8.99599 0.331386 9.30829C0.224313 9.62058 0.295695 9.99534 0.54553 10.4415L3.79339 16.0449C3.98077 16.4554 4.31983 16.7141 4.80166 16.8212C5.2924 16.9283 5.74746 16.8569 6.1936 16.6071L9.16486 14.9564V34.2651C9.16486 34.7647 9.34331 35.202 9.70914 35.5589C10.066 35.9158 10.5033 36.1031 11.0029 36.1031H28.8037C29.3034 36.1031 29.7495 35.9247 30.1243 35.5589C30.499 35.202 30.6864 34.7647 30.6864 34.2651V14.8671L33.6041 16.7052C33.9521 16.9283 34.425 16.9729 35.0139 16.848C35.6028 16.723 36.0043 16.4554 36.1917 16.0449L39.4842 10.4415C39.7072 10.0043 39.7697 9.6295 39.6716 9.30829ZM18.3731 13.2521H21.844V14.7422H18.3731V13.2521ZM20.4164 18.0258C20.4164 18.5344 20.0059 18.9448 19.4973 18.9448C18.9887 18.9448 18.5783 18.5344 18.5783 18.0258C18.5783 17.5172 18.9887 17.1067 19.4973 17.1067C20.0059 17.1067 20.4164 17.5172 20.4164 18.0258ZM12.9213 18.2131H14.4114V21.6841H12.9213V18.2131ZM15.6695 26.8592H14.4114C13.5994 26.8592 12.9213 26.1989 12.9213 25.3691V23.1563H14.4114V25.3691H15.6695V26.8592ZM15.8926 14.7333H14.4025V16.723H12.9124V14.7333C12.9124 13.9124 13.5905 13.2432 14.4025 13.2432H15.8926V14.7333ZM21.8351 26.8592H18.3642V25.3691H21.8351V26.8592ZM23.2003 23.0046H16.7938C16.0978 23.0046 15.7052 22.2016 16.1335 21.6573L17.3202 20.1315C17.6146 19.7478 18.1679 19.6943 18.5248 20.0066L19.078 20.4884C19.426 20.7918 19.9613 20.7472 20.2647 20.3992L21.5585 18.8734C21.9689 18.3827 22.763 18.5254 22.9861 19.1233L23.9944 21.8804C24.1907 22.4247 23.7892 23.0046 23.2092 23.0046H23.2003ZM27.0727 25.3781C27.0727 26.1989 26.3946 26.8682 25.5915 26.8682H24.3334V25.3781H25.5915V23.1652H27.0727V25.3781ZM27.0727 21.6841H25.5915V18.2131H27.0727V21.6841ZM27.0727 16.732H25.5915V14.7422H24.1014V13.2521H25.5915C26.4035 13.2521 27.0727 13.9124 27.0727 14.7422V16.732Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function WeddingsIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '38'}
      height={props.height ?? '38'}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.0463 25.0305C31.0463 31.7534 25.5636 37.2 18.796 37.2C12.0284 37.2 6.55371 31.7534 6.55371 25.0305C6.55371 20.9951 8.54089 17.4354 11.5815 15.2235L13.7443 17.808C11.4458 19.4016 9.92952 22.0416 9.92952 25.0384C9.92952 29.8983 13.9039 33.8464 18.796 33.8464C23.6881 33.8464 27.6625 29.8983 27.6625 25.0384C27.6625 22.0495 26.1541 19.4016 23.8477 17.8159L26.0105 15.2314C29.0511 17.4433 31.0383 21.0109 31.0383 25.0384L31.0463 25.0305ZM18.365 2.31665H19.2349L21.9324 7.79492H15.6756L18.365 2.31665ZM9.07559 9.07133H18.1575V19.901L9.07559 9.07133ZM19.4424 9.07133H28.5244L19.4424 19.901V9.07133ZM20.6714 2.31665H25.0368C25.3242 2.31665 25.5955 2.39593 25.8429 2.54656C26.0903 2.6972 26.2818 2.90332 26.4175 3.15702L28.7239 7.79492H23.3609L20.6635 2.31665H20.6714ZM11.1825 3.15702C11.3181 2.90332 11.5097 2.6972 11.7571 2.54656C12.0045 2.39593 12.2758 2.31665 12.5631 2.31665H16.9285L14.2311 7.79492H8.86809L11.1825 3.15702Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function PaperCrafringTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '38'}
      height={props.height ?? '38'}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_8602_16985"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="38"
        height="38"
      >
        <rect x="0.799805" y="0.800049" width="36.4" height="36.4" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8602_16985)">
        <path
          d="M34.6395 12.4671L29.2319 6.46381C28.8762 6.06933 28.2856 5.9976 27.8445 6.29167L21.9032 10.3082V8.55096C21.9032 7.69028 21.213 6.99456 20.3592 6.99456H18.1464C17.2925 6.99456 16.6024 7.69028 16.6024 8.55096V10.6668L10.1488 6.29167C9.70767 5.99043 9.1171 6.06933 8.76134 6.46381L3.35374 12.4671C3.1047 12.7468 3.01221 13.1341 3.11894 13.4927L5.04717 20.1271C5.18236 20.5862 5.59505 20.9018 6.07177 20.9018H7.32405C7.32405 20.9018 7.28848 20.9663 7.27425 21.0022L5.72312 25.5638C5.6662 25.6642 5.61639 25.7646 5.59505 25.8794C5.53101 26.2021 5.60928 26.5392 5.82273 26.7903L10.3623 32.2628C10.5544 32.4994 10.839 32.6357 11.1449 32.6501C11.1592 32.6501 11.1734 32.6501 11.1805 32.6501C11.4722 32.6501 11.7426 32.5281 11.949 32.3201L16.8016 27.2565L17.7621 31.3304C17.9258 32.0332 18.5448 32.5281 19.2635 32.5281C19.975 32.5281 20.6011 32.0332 20.7648 31.3304L21.6186 27.7011L26.0514 32.3201C26.2506 32.5281 26.5281 32.6501 26.8199 32.6501C26.8341 32.6501 26.8483 32.6501 26.8554 32.6501C27.1543 32.6357 27.4389 32.4994 27.6381 32.2628L32.1777 26.7903C32.384 26.5392 32.4694 26.2021 32.4053 25.8794C32.384 25.7646 32.3342 25.657 32.2773 25.5638L30.7261 21.0022C30.7119 20.9663 30.6906 20.9376 30.6763 20.9018H31.9286C32.4053 20.9018 32.818 20.5862 32.9532 20.1271L34.8815 13.4927C34.9882 13.1341 34.8957 12.7468 34.6467 12.4671H34.6395ZM5.3389 13.464L9.72901 8.60117L15.6987 12.632V18.75H6.87579L5.3389 13.464ZM15.6916 25.3199L11.2374 29.9676L8.32731 26.4603L15.6916 22.7809V25.3271V25.3199ZM26.7558 29.9676L22.3017 25.3199V22.7809L29.666 26.4603L26.7558 29.9676ZM31.1246 18.75H22.3017V12.632L28.2714 8.60117L32.6615 13.464L31.1246 18.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
